/**
 * A function to create a log object for the 'editorGotPendingApps' event (evid: 100)
 *
 * Event description: editor -> got pending apps.
 *
 * @param {editorGotPendingAppsParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {number} i1 - pending_apps
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorGotPendingAppsParams>} LogObject<editorGotPendingAppsParams>
 */
export function editorGotPendingApps(params) {
    return { evid: 100, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorDeletingApp' event (evid: 106)
 *
 * Event description: editor -> deleting app.
 *
 * @param {editorDeletingAppParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - dialog type
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorDeletingAppParams>} LogObject<editorDeletingAppParams>
 */
export function editorDeletingApp(params) {
    return { evid: 106, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorDeletingAppConfirmed' event (evid: 107)
 *
 * Event description: editor -> deleting app confirmed.
 *
 * @param {editorDeletingAppConfirmedParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - dialog type
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorDeletingAppConfirmedParams>} LogObject<editorDeletingAppConfirmedParams>
 */
export function editorDeletingAppConfirmed(params) {
    return { evid: 107, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketOpenAppMarket' event (evid: 11)
 *
 * Event description: editor market -> open app market.
 *
 * @param {editorMarketOpenAppMarketParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {GUID} origin_id - origin_id
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {number} pending - pending
 * @return {LogObject<editorMarketOpenAppMarketParams>} LogObject<editorMarketOpenAppMarketParams>
 */
export function editorMarketOpenAppMarket(params) {
    return { evid: 11, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAddAppExtension' event (evid: 110)
 *
 * Event description: editor -> add app extension.
 *
 * @param {editorAddAppExtensionParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {GUID} g2 - widget_id
 * @property {number} ts - ts
 * @property {string} c2 - component_id
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - page_id
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @property {GUID} g3 - instance_id
 * @return {LogObject<editorAddAppExtensionParams>} LogObject<editorAddAppExtensionParams>
 */
export function editorAddAppExtension(params) {
    return { evid: 110, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorRemoveAppExtension' event (evid: 111)
 *
 * Event description: editor -> remove app extension.
 *
 * @param {editorRemoveAppExtensionParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {GUID} g2 - widget_id
 * @property {number} ts - ts
 * @property {string} c2 - component_id
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - page_id
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @property {GUID} g3 - instance_id
 * @return {LogObject<editorRemoveAppExtensionParams>} LogObject<editorRemoveAppExtensionParams>
 */
export function editorRemoveAppExtension(params) {
    return { evid: 111, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketChoosingACategory' event (evid: 12)
 *
 * Event description: editor market -> choosing a category.
 *
 * @param {editorMarketChoosingACategoryParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} origin - the origin of category open
 * @property {string} category - the category name from the appstore categories
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketChoosingACategoryParams>} LogObject<editorMarketChoosingACategoryParams>
 */
export function editorMarketChoosingACategory(params) {
    return { evid: 12, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorTpaPpOpened' event (evid: 120)
 *
 * Event description: editor -> tpa PP opened.
 *
 * @param {editorTpaPpOpenedParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - origin
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorTpaPpOpenedParams>} LogObject<editorTpaPpOpenedParams>
 */
export function editorTpaPpOpened(params) {
    return { evid: 120, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorTpaPpUpgradeClicked' event (evid: 121)
 *
 * Event description: editor -> tpa PP upgrade clicked.
 *
 * @param {editorTpaPpUpgradeClickedParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {boolean} i1 - is_checked
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorTpaPpUpgradeClickedParams>} LogObject<editorTpaPpUpgradeClickedParams>
 */
export function editorTpaPpUpgradeClicked(params) {
    return { evid: 121, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorTpaPpMonthlyClicked' event (evid: 122)
 *
 * Event description: editor -> tpa PP monthly clicked.
 *
 * @param {editorTpaPpMonthlyClickedParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorTpaPpMonthlyClickedParams>} LogObject<editorTpaPpMonthlyClickedParams>
 */
export function editorTpaPpMonthlyClicked(params) {
    return { evid: 122, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketAppModalIsOpened' event (evid: 13)
 *
 * Event description: editor market -> app modal is opened.
 *
 * @param {editorMarketAppModalIsOpenedParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - the origin of the caller
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the actual value of 'search' or 'categories'
 * @return {LogObject<editorMarketAppModalIsOpenedParams>} LogObject<editorMarketAppModalIsOpenedParams>
 */
export function editorMarketAppModalIsOpened(params) {
    return { evid: 13, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketClickAddToSite' event (evid: 14)
 *
 * Event description: editor market -> click add to site.
 *
 * @param {editorMarketClickAddToSiteParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - the origin of the click on 'add to site'
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the actual value of 'search' or 'categories'
 * @return {LogObject<editorMarketClickAddToSiteParams>} LogObject<editorMarketClickAddToSiteParams>
 */
export function editorMarketClickAddToSite(params) {
    return { evid: 14, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketClickOnATabInAppModal' event (evid: 15)
 *
 * Event description: editor market -> click on a tab in app modal.
 *
 * @param {editorMarketClickOnATabInAppModalParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} tab_name - the tab name of the opened tab inside app modal window
 * @property {string} origin - origin
 * @property {string} app_name - app_name
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<editorMarketClickOnATabInAppModalParams>} LogObject<editorMarketClickOnATabInAppModalParams>
 */
export function editorMarketClickOnATabInAppModal(params) {
    return { evid: 15, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketClickOnSearch' event (evid: 17)
 *
 * Event description: editor market -> click on search.
 *
 * @param {editorMarketClickOnSearchParams} params - The parameters for this event
 * @property {string} search_terms - the text that user has entered into the search box
 * @property {number} count - the amount of results
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} origin - the origin of the click on 'upgrade button'
 * @property {GUID} app_id - the top result app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the text that user has entered into the search box
 * @return {LogObject<editorMarketClickOnSearchParams>} LogObject<editorMarketClickOnSearchParams>
 */
export function editorMarketClickOnSearch(params) {
    return { evid: 17, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketWelcomeScreenClosedByX' event (evid: 20)
 *
 * Event description: editor market -> welcome screen closed by X.
 *
 * @param {editorMarketWelcomeScreenClosedByXParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<editorMarketWelcomeScreenClosedByXParams>} LogObject<editorMarketWelcomeScreenClosedByXParams>
 */
export function editorMarketWelcomeScreenClosedByX(params) {
    return { evid: 20, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myAppsAndServicesUpgradeAppButton' event (evid: 200)
 *
 * Event description: 'my apps and services' -> upgrade app button.
 *
 * @param {myAppsAndServicesUpgradeAppButtonParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<myAppsAndServicesUpgradeAppButtonParams>} LogObject<myAppsAndServicesUpgradeAppButtonParams>
 */
export function myAppsAndServicesUpgradeAppButton(params) {
    return { evid: 200, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appsAndServicesMarketMarketOpened' event (evid: 201)
 *
 * Event description: 'apps and services market' -> market opened.
 *
 * @param {appsAndServicesMarketMarketOpenedParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {GUID} origin_id - origin_id
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<appsAndServicesMarketMarketOpenedParams>} LogObject<appsAndServicesMarketMarketOpenedParams>
 */
export function appsAndServicesMarketMarketOpened(params) {
    return { evid: 201, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appsAndServicesMarketChooseCategory' event (evid: 202)
 *
 * Event description: 'apps and services market' -> choose category.
 *
 * @param {appsAndServicesMarketChooseCategoryParams} params - The parameters for this event
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} view - layout.default.all
 * @return {LogObject<appsAndServicesMarketChooseCategoryParams>} LogObject<appsAndServicesMarketChooseCategoryParams>
 */
export function appsAndServicesMarketChooseCategory(params) {
    return { evid: 202, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appsAndServicesMarketSearch' event (evid: 203)
 *
 * Event description: 'apps and services market' -> search.
 *
 * @param {appsAndServicesMarketSearchParams} params - The parameters for this event
 * @property {string} search_terms - the text that user has entered into the search box
 * @property {number} count - the amount of results
 * @property {string} origin - origin
 * @property {GUID} app_id - the top result app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the text that user has entered into the search box
 * @return {LogObject<appsAndServicesMarketSearchParams>} LogObject<appsAndServicesMarketSearchParams>
 */
export function appsAndServicesMarketSearch(params) {
    return { evid: 203, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppAddAppButtonWasClicked' event (evid: 204)
 *
 * Event description: BO app -> 'add app' button was clicked.
 *
 * @param {boAppAddAppButtonWasClickedParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<boAppAddAppButtonWasClickedParams>} LogObject<boAppAddAppButtonWasClickedParams>
 */
export function boAppAddAppButtonWasClicked(params) {
    return { evid: 204, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppModalClickOnATab' event (evid: 205)
 *
 * Event description: BO app modal -> click on a tab.
 *
 * @param {boAppModalClickOnATabParams} params - The parameters for this event
 * @property {string} tab_name - tab_name
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<boAppModalClickOnATabParams>} LogObject<boAppModalClickOnATabParams>
 */
export function boAppModalClickOnATab(params) {
    return { evid: 205, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardMarketAppModalLoaded' event (evid: 206)
 *
 * Event description: Dashboard market app modal loaded.
 *
 * @param {dashboardMarketAppModalLoadedParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<dashboardMarketAppModalLoadedParams>} LogObject<dashboardMarketAppModalLoadedParams>
 */
export function dashboardMarketAppModalLoaded(params) {
    return { evid: 206, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppOpenAppButtonWasClicked' event (evid: 207)
 *
 * Event description: BO app -> 'open app' button was clicked.
 *
 * @param {boAppOpenAppButtonWasClickedParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<boAppOpenAppButtonWasClickedParams>} LogObject<boAppOpenAppButtonWasClickedParams>
 */
export function boAppOpenAppButtonWasClicked(params) {
    return { evid: 207, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppClickOnRemoveIcon' event (evid: 209)
 *
 * Event description: BO app -> click on remove icon.
 *
 * @param {boAppClickOnRemoveIconParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<boAppClickOnRemoveIconParams>} LogObject<boAppClickOnRemoveIconParams>
 */
export function boAppClickOnRemoveIcon(params) {
    return { evid: 209, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppConfirmRemove' event (evid: 210)
 *
 * Event description: BO app -> confirm remove.
 *
 * @param {boAppConfirmRemoveParams} params - The parameters for this event
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<boAppConfirmRemoveParams>} LogObject<boAppConfirmRemoveParams>
 */
export function boAppConfirmRemove(params) {
    return { evid: 210, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boAppViewMyAppsPage' event (evid: 211)
 *
 * Event description: BO app -> view 'my apps' page.
 *
 * @param {boAppViewMyAppsPageParams} params - The parameters for this event
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - search_terms
 * @return {LogObject<boAppViewMyAppsPageParams>} LogObject<boAppViewMyAppsPageParams>
 */
export function boAppViewMyAppsPage(params) {
    return { evid: 211, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appsAndServicesMarketSearchClickOnLinkToEditor' event (evid: 213)
 *
 * Event description: 'apps and services market' -> search -> click on link to editor
 *
 * @param {appsAndServicesMarketSearchClickOnLinkToEditorParams} params - The parameters for this event
 * @property {string} search_terms - search_terms
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<appsAndServicesMarketSearchClickOnLinkToEditorParams>} LogObject<appsAndServicesMarketSearchClickOnLinkToEditorParams>
 */
export function appsAndServicesMarketSearchClickOnLinkToEditor(params) {
    return { evid: 213, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketChoosingACategory' event (evid: 22)
 *
 * Event description: standalone market -> choosing a category.
 *
 * @param {standaloneMarketChoosingACategoryParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} origin - the origin of category open
 * @property {string} category - the category name from the appstore categories
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<standaloneMarketChoosingACategoryParams>} LogObject<standaloneMarketChoosingACategoryParams>
 */
export function standaloneMarketChoosingACategory(params) {
    return { evid: 22, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketAppModalIsOpened' event (evid: 23)
 *
 * Event description: standalone market -> app modal is opened.
 *
 * @param {standaloneMarketAppModalIsOpenedParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - the origin of the caller
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the actual value of 'search' or 'categories'
 * @return {LogObject<standaloneMarketAppModalIsOpenedParams>} LogObject<standaloneMarketAppModalIsOpenedParams>
 */
export function standaloneMarketAppModalIsOpened(params) {
    return { evid: 23, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketClickAddToSite' event (evid: 24)
 *
 * Event description: standalone market -> click add to site.
 *
 * @param {standaloneMarketClickAddToSiteParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - the origin of the click on 'add to site'
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the actual value of 'search' or 'categories'
 * @return {LogObject<standaloneMarketClickAddToSiteParams>} LogObject<standaloneMarketClickAddToSiteParams>
 */
export function standaloneMarketClickAddToSite(params) {
    return { evid: 24, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketClickOnATabInAppModal' event (evid: 25)
 *
 * Event description: standalone market -> click on a tab in app modal.
 *
 * @param {standaloneMarketClickOnATabInAppModalParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} tab_name - the tab name of the opened tab inside app modal window
 * @property {string} referral_info - referral_info
 * @property {string} origin - origin
 * @property {string} app_name - app_name
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<standaloneMarketClickOnATabInAppModalParams>} LogObject<standaloneMarketClickOnATabInAppModalParams>
 */
export function standaloneMarketClickOnATabInAppModal(params) {
    return { evid: 25, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketClickOnSearch' event (evid: 27)
 *
 * Event description: standalone market -> click on search.
 *
 * @param {standaloneMarketClickOnSearchParams} params - The parameters for this event
 * @property {string} search_terms - the text that user has entered into the search box
 * @property {number} count - the amount of results
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} origin - the origin of the click on 'upgrade button'
 * @property {GUID} app_id - the top result app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - the text that user has entered into the search box
 * @return {LogObject<standaloneMarketClickOnSearchParams>} LogObject<standaloneMarketClickOnSearchParams>
 */
export function standaloneMarketClickOnSearch(params) {
    return { evid: 27, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketShareButton' event (evid: 28)
 *
 * Event description: standalone market -> share button.
 *
 * @param {standaloneMarketShareButtonParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<standaloneMarketShareButtonParams>} LogObject<standaloneMarketShareButtonParams>
 */
export function standaloneMarketShareButton(params) {
    return { evid: 28, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'standaloneMarketNewToWix' event (evid: 29)
 *
 * Event description: standalone market -> new to wix.
 *
 * @param {standaloneMarketNewToWixParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<standaloneMarketNewToWixParams>} LogObject<standaloneMarketNewToWixParams>
 */
export function standaloneMarketNewToWix(params) {
    return { evid: 29, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketRemovePendingApp' event (evid: 30)
 *
 * Event description: editor market -> remove pending app.
 *
 * @param {editorMarketRemovePendingAppParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketRemovePendingAppParams>} LogObject<editorMarketRemovePendingAppParams>
 */
export function editorMarketRemovePendingApp(params) {
    return { evid: 30, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartMarketOpenAppMarket' event (evid: 301)
 *
 * Event description: premium cart market -> open app market
 *
 * @param {premiumCartMarketOpenAppMarketParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {GUID} origin_id - origin_id
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {number} pending - pending
 * @return {LogObject<premiumCartMarketOpenAppMarketParams>} LogObject<premiumCartMarketOpenAppMarketParams>
 */
export function premiumCartMarketOpenAppMarket(params) {
    return { evid: 301, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartMarketChoosingACategory' event (evid: 302)
 *
 * Event description: premium cart market -> choosing a category
 *
 * @param {premiumCartMarketChoosingACategoryParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} view - view
 * @return {LogObject<premiumCartMarketChoosingACategoryParams>} LogObject<premiumCartMarketChoosingACategoryParams>
 */
export function premiumCartMarketChoosingACategory(params) {
    return { evid: 302, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartMarketAppModalIsOpened' event (evid: 303)
 *
 * Event description: premium cart market -> app modal is opened
 *
 * @param {premiumCartMarketAppModalIsOpenedParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<premiumCartMarketAppModalIsOpenedParams>} LogObject<premiumCartMarketAppModalIsOpenedParams>
 */
export function premiumCartMarketAppModalIsOpened(params) {
    return { evid: 303, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartMarketClickAddToCart' event (evid: 304)
 *
 * Event description: premium cart market -> click add to cart
 *
 * @param {premiumCartMarketClickAddToCartParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} app_name - app_name
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<premiumCartMarketClickAddToCartParams>} LogObject<premiumCartMarketClickAddToCartParams>
 */
export function premiumCartMarketClickAddToCart(params) {
    return { evid: 304, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartMarketClickOnATab' event (evid: 305)
 *
 * Event description: premium cart market -> click on a tab
 *
 * @param {premiumCartMarketClickOnATabParams} params - The parameters for this event
 * @property {GUID} metasite_id - metasite_id
 * @property {string} tab_name - tab_name
 * @property {string} referral_info - referral_info
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<premiumCartMarketClickOnATabParams>} LogObject<premiumCartMarketClickOnATabParams>
 */
export function premiumCartMarketClickOnATab(params) {
    return { evid: 305, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketSiteSelectorOpen' event (evid: 31)
 *
 * Event description: market site selector -> open.
 *
 * @param {marketSiteSelectorOpenParams} params - The parameters for this event
 * @property {string} sitetype - site_type_name
 * @property {number} sitescount - sites_cnt
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} buttontext - button
 * @property {number} site_type - site_type
 * @property {string} origin - origin
 * @property {string} title - title
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketSiteSelectorOpenParams>} LogObject<marketSiteSelectorOpenParams>
 */
export function marketSiteSelectorOpen(params) {
    return { evid: 31, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketSiteSelectorClose' event (evid: 32)
 *
 * Event description: market site selector -> close.
 *
 * @param {marketSiteSelectorCloseParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketSiteSelectorCloseParams>} LogObject<marketSiteSelectorCloseParams>
 */
export function marketSiteSelectorClose(params) {
    return { evid: 32, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketSiteSelectorSelectSite' event (evid: 33)
 *
 * Event description: market site selector -> select site.
 *
 * @param {marketSiteSelectorSelectSiteParams} params - The parameters for this event
 * @property {string} siteType - site_type_name
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {boolean} isPublished - ispublished
 * @property {string} buttonText - button
 * @property {number} site_type - site_type
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {boolean} isPremium - ispremium
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketSiteSelectorSelectSiteParams>} LogObject<marketSiteSelectorSelectSiteParams>
 */
export function marketSiteSelectorSelectSite(params) {
    return { evid: 33, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketAcceptAppPermissions' event (evid: 34)
 *
 * Event description: market -> accept app permissions.
 *
 * @param {marketAcceptAppPermissionsParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketAcceptAppPermissionsParams>} LogObject<marketAcceptAppPermissionsParams>
 */
export function marketAcceptAppPermissions(params) {
    return { evid: 34, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketRejectAppPermissions' event (evid: 35)
 *
 * Event description: editor market -> reject app permissions.
 *
 * @param {editorMarketRejectAppPermissionsParams} params - The parameters for this event
 * @property {string}  - market_type
 * @property {string} c3 - category
 * @property {string} server - server
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {string} g2 - value
 * @property {number} ts - ts
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - origin
 * @property {string} origin - origin
 * @property {string} ver - ver
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<editorMarketRejectAppPermissionsParams>} LogObject<editorMarketRejectAppPermissionsParams>
 */
export function editorMarketRejectAppPermissions(params) {
    return { evid: 35, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketOpenMarketTermsOfUse' event (evid: 36)
 *
 * Event description: market -> open market terms of use.
 *
 * @param {marketOpenMarketTermsOfUseParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketOpenMarketTermsOfUseParams>} LogObject<marketOpenMarketTermsOfUseParams>
 */
export function marketOpenMarketTermsOfUse(params) {
    return { evid: 36, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketSuggestAnAppButton' event (evid: 37)
 *
 * Event description: editor market -> suggest an app button.
 *
 * @param {editorMarketSuggestAnAppButtonParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketSuggestAnAppButtonParams>} LogObject<editorMarketSuggestAnAppButtonParams>
 */
export function editorMarketSuggestAnAppButton(params) {
    return { evid: 37, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketSuggestAnAppConfirmed' event (evid: 38)
 *
 * Event description: editor market -> suggest an app confirmed.
 *
 * @param {editorMarketSuggestAnAppConfirmedParams} params - The parameters for this event
 * @property {string} name - name
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} dsc - dsc
 * @property {string} origin - origin
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketSuggestAnAppConfirmedParams>} LogObject<editorMarketSuggestAnAppConfirmedParams>
 */
export function editorMarketSuggestAnAppConfirmed(params) {
    return { evid: 38, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketPermissionsModalUp' event (evid: 39)
 *
 * Event description: market -> permissions modal up.
 *
 * @param {marketPermissionsModalUpParams} params - The parameters for this event
 * @property {GUID} metasite_id - msid
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - referral_info
 * @property {string} market_type - market_type
 * @property {string} origin - origin
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - The editing session of the editor
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @return {LogObject<marketPermissionsModalUpParams>} LogObject<marketPermissionsModalUpParams>
 */
export function marketPermissionsModalUp(params) {
    return { evid: 39, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketOpenAppExtensions' event (evid: 40)
 *
 * Event description: editor market -> open app extensions.
 *
 * @param {editorMarketOpenAppExtensionsParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - origin
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketOpenAppExtensionsParams>} LogObject<editorMarketOpenAppExtensionsParams>
 */
export function editorMarketOpenAppExtensions(params) {
    return { evid: 40, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorMarketAddedExtensionToSpecificPage' event (evid: 42)
 *
 * Event description: editor market -> added extension to specific page.
 *
 * @param {editorMarketAddedExtensionToSpecificPageParams} params - The parameters for this event
 * @property {string} server - server
 * @property {GUID} site_id - site_id
 * @property {string} majorver - majorver
 * @property {GUID} g2 - widget_id
 * @property {number} ts - ts
 * @property {string} __cookies_prefix___wixStatemap - state_map
 * @property {string} viewmode - viewmode
 * @property {GUID} g1 - app_id
 * @property {string} c1 - page_id
 * @property {boolean} i1 - is_checked
 * @property {string} ver - ver
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - global session id
 * @property {GUID} msid - msid
 * @return {LogObject<editorMarketAddedExtensionToSpecificPageParams>} LogObject<editorMarketAddedExtensionToSpecificPageParams>
 */
export function editorMarketAddedExtensionToSpecificPage(params) {
    return { evid: 42, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homepageButtonsAddYourAppClick' event (evid: 501)
 *
 * Event description: homepage buttons -> add_your_app_click
 *
 * @param {homepageButtonsAddYourAppClickParams} params - The parameters for this event
 * @property {string} referral_info - {wix_footer,wix_about,eng_blog, [loung_ref_link],[search_engine],facebook,twitter,[email_guid]
 * @property {string} origin - {dev_header_menu, get_started_header, get_started_mid_page}
 * @return {LogObject<homepageButtonsAddYourAppClickParams>} LogObject<homepageButtonsAddYourAppClickParams>
 */
export function homepageButtonsAddYourAppClick(params) {
    return { evid: 501, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterLoadPage' event (evid: 507)
 *
 * Event description: Any page of the following was loaded
 *
 * @param {devCenterLoadPageParams} params - The parameters for this event
 * @property {string} origin - create_app register_your_app_page wixhive-api_page app_info overview_info live_demo features endpoint_popup
 * @return {LogObject<devCenterLoadPageParams>} LogObject<devCenterLoadPageParams>
 */
export function devCenterLoadPage(params) {
    return { evid: 507, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterClickOnAddEditComponent' event (evid: 508)
 *
 * Event description: developer clicked on add new component or edit specific component
 * http://www.screencast.com/t/fYSi7NU5Doi
 * http://www.screencast.com/t/eBsDCcE0c
 *
 * @param {devCenterClickOnAddEditComponentParams} params - The parameters for this event
 * @property {string} origin - comp_dropdown edit_btn
 * @return {LogObject<devCenterClickOnAddEditComponentParams>} LogObject<devCenterClickOnAddEditComponentParams>
 */
export function devCenterClickOnAddEditComponent(params) {
    return { evid: 508, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterClickOnSave' event (evid: 509)
 *
 * Event description: Developer clicked on save
 * http://www.screencast.com/t/ZfosScFfuXoH
 * http://www.screencast.com/t/8IgdvTjQrAUo
 * http://www.screencast.com/t/ggQupDcCcGc
 *
 * @param {devCenterClickOnSaveParams} params - The parameters for this event
 * @property {string} origin - create_app register_your_app_page wixhive-api_page app_info overview_info live_demo features endpoint_popup submit_appedit_btn
 * @return {LogObject<devCenterClickOnSaveParams>} LogObject<devCenterClickOnSaveParams>
 */
export function devCenterClickOnSave(params) {
    return { evid: 509, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterSaveSuccess' event (evid: 510)
 *
 * Event description: Save was succeeded
 *
 * @param {devCenterSaveSuccessParams} params - The parameters for this event
 * @property {string} origin - create_app register_your_app_page wixhive-api_page app_info overview_info live_demo features endpoint_popup submit_app
 * @return {LogObject<devCenterSaveSuccessParams>} LogObject<devCenterSaveSuccessParams>
 */
export function devCenterSaveSuccess(params) {
    return { evid: 510, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'homepageGalleryArrowClick' event (evid: 511)
 *
 * Event description: homepage gallery -> arrow_click
 *
 * @param {homepageGalleryArrowClickParams} params - The parameters for this event
 * @property {string} referral_info - {wix_footer,wix_about,eng_blog, [loung_ref_link],[search_engine],facebook,twitter,[email_guid]
 * @property {string} direction - {right,left}
 * @return {LogObject<homepageGalleryArrowClickParams>} LogObject<homepageGalleryArrowClickParams>
 */
export function homepageGalleryArrowClick(params) {
    return { evid: 511, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterHomePageView' event (evid: 540)
 *
 * Event description: Dev center home page view.
 *
 * @param {devCenterHomePageViewParams} params - The parameters for this event
 * @property {string} viewName - view
 * @property {Url} referral_url - referral
 * @property {GUID} uuid - uuid
 * @property {string} referral_info - {wix_footer,wix_about,eng_blog, [loung_ref_link],[search_engine],facebook,twitter,[email_guid]
 * @return {LogObject<devCenterHomePageViewParams>} LogObject<devCenterHomePageViewParams>
 */
export function devCenterHomePageView(params) {
    return { evid: 540, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemAddEditReviewClick' event (evid: 601)
 *
 * Event description: review system -> add_edit review click
 *
 * @param {reviewSystemAddEditReviewClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} product_id - app_id
 * @property {string} type - {post, edit}
 * @return {LogObject<reviewSystemAddEditReviewClickParams>} LogObject<reviewSystemAddEditReviewClickParams>
 */
export function reviewSystemAddEditReviewClick(params) {
    return { evid: 601, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemPostReview' event (evid: 602)
 *
 * Event description: review system -> post review
 *
 * @param {reviewSystemPostReviewParams} params - The parameters for this event
 * @property {number} rate - {1,2,3,4,5}
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {boolean} has_description - {0,1}
 * @property {GUID} product_id - app_id
 * @property {string} type - {post, edit}
 * @return {LogObject<reviewSystemPostReviewParams>} LogObject<reviewSystemPostReviewParams>
 */
export function reviewSystemPostReview(params) {
    return { evid: 602, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemCancelClick' event (evid: 603)
 *
 * Event description: review system -> cancel click
 *
 * @param {reviewSystemCancelClickParams} params - The parameters for this event
 * @property {GUID} product_id - app_id
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @return {LogObject<reviewSystemCancelClickParams>} LogObject<reviewSystemCancelClickParams>
 */
export function reviewSystemCancelClick(params) {
    return { evid: 603, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemSortByClick' event (evid: 604)
 *
 * Event description: review system -> sort by click
 *
 * @param {reviewSystemSortByClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} product_id - app_id
 * @property {string} value - {most_recent, most_liked, highest_rate, lowest_rate}
 * @return {LogObject<reviewSystemSortByClickParams>} LogObject<reviewSystemSortByClickParams>
 */
export function reviewSystemSortByClick(params) {
    return { evid: 604, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemShareReview' event (evid: 605)
 *
 * Event description: review system -> share review
 *
 * @param {reviewSystemShareReviewParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} product_id - app_id
 * @property {string} type - {facebook, twitter..}
 * @return {LogObject<reviewSystemShareReviewParams>} LogObject<reviewSystemShareReviewParams>
 */
export function reviewSystemShareReview(params) {
    return { evid: 605, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSystemLikeClick' event (evid: 606)
 *
 * Event description: review system -> like click
 *
 * @param {reviewSystemLikeClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} product_id - app_id
 * @property {string} type - {like, dislike}
 * @return {LogObject<reviewSystemLikeClickParams>} LogObject<reviewSystemLikeClickParams>
 */
export function reviewSystemLikeClick(params) {
    return { evid: 606, src: 22, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketInstallApp' event (evid: 1)
 *
 * Event description: AppMarket - App Installed (Server).
 *
 * @param {appMarketInstallAppParams} params - The parameters for this event
 * @property {string} app_version - version of app
 * @property {number} sum_one - value 1 for test sum
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - app instance id
 * @return {LogObject<appMarketInstallAppParams>} LogObject<appMarketInstallAppParams>
 */
export function appMarketInstallApp(params) {
    return { evid: 1, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppInstallSuccessClientAndServer' event (evid: 10)
 *
 * Event description: New app Install event to replace the old onces (2 and 1) and fix bugs.
 *
 * @param {appMarketAppInstallSuccessClientAndServerParams} params - The parameters for this event
 * @property {string} navigation_source - e.g. top-search. if the user clicks on the app from a navigation source (sidebar menu/ search). from which navigation source.
 * @property {string} market - editor, dashboard, adi, add-panel
 * @property {string} widget_referral - is flow referred from widget
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info (correct, no typo). The previous page tag_type
 * @property {number} sum_one - value 1 of ttest
 * @property {number} referral_section_index - what is the index number of the app box that was clicked in previous page
 * @property {GUID} impression_id - Impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} search_term - word used for search term, led to search result, led to app page and install
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {GUID} app_id - app_id
 * @property {string} tag_type - what is the type of app tag? category, collection etc
 * @property {boolean} is_app_dependency - true\false
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - app instance id
 * @property {string} tag_name - what is the specific tag from which the app was installed from
 * @property {number} index - app index number when presented
 * @property {string} referral_tag_name - what is the tag_name that referred to this install
 * @return {LogObject<appMarketAppInstallSuccessClientAndServerParams>} LogObject<appMarketAppInstallSuccessClientAndServerParams>
 */
export function appMarketAppInstallSuccessClientAndServer(params) {
    return { evid: 10, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDemoLinkClicked' event (evid: 100)
 *
 * Event description: when a user clicks on a demo link to an app provided by the developer, from the app page in the app market.
 *
 * @param {appMarketDemoLinkClickedParams} params - The parameters for this event
 * @property {string} market - What market? (dashboard, editor, standalone etc)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - what is the site postreg? {general, online_store, music...}
 * @property {string} category - what is the apps category? {featured, new, search, home, must-have-apps....}
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} demo_link - demo link
 * @return {LogObject<appMarketDemoLinkClickedParams>} LogObject<appMarketDemoLinkClickedParams>
 */
export function appMarketDemoLinkClicked(params) {
    return { evid: 100, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnMenu' event (evid: 101)
 *
 * Event description: click on menu
 *
 * @param {clickOnMenuParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {string} page_id - {home_page/search}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnMenuParams>} LogObject<clickOnMenuParams>
 */
export function clickOnMenu(params) {
    return { evid: 101, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deprecatedSrc24Evid1021' event (evid: 1021)
 *
 * Event description: Click on view more apps
 *
 * @param {deprecatedSrc24Evid1021Params} params - The parameters for this event
 * @property {Url} referral_url - URL from which the visitor reached the page
 * @property {GUID} uuid - uuid
 * @property {string} vertical - vertical
 * @property {GUID} esi - session ID
 * @property {GUID} msid - msid
 * @return {LogObject<deprecatedSrc24Evid1021Params>} LogObject<deprecatedSrc24Evid1021Params>
 */
export function deprecatedSrc24Evid1021(params) {
    return { evid: 1021, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoverOnCategory' event (evid: 103)
 *
 * Event description: hover on category
 *
 * @param {hoverOnCategoryParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} category - the category name from the appstore categories
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<hoverOnCategoryParams>} LogObject<hoverOnCategoryParams>
 */
export function hoverOnCategory(params) {
    return { evid: 103, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterTokenReceivedOauthInstall' event (evid: 1050)
 *
 * Event description: Dev Center - Token Received Oauth Install.This is no longer in use, this was created again in the new app market
 *
 * @param {devCenterTokenReceivedOauthInstallParams} params - The parameters for this event
 * @property {string} http_method - get or post
 * @property {GUID} app_id - app id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<devCenterTokenReceivedOauthInstallParams>} LogObject<devCenterTokenReceivedOauthInstallParams>
 */
export function devCenterTokenReceivedOauthInstall(params) {
    return { evid: 1050, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPostAppReview' event (evid: 106)
 *
 * Event description: Posting an app review
 *
 * @param {appMarketPostAppReviewParams} params - The parameters for this event
 * @property {GUID} review_id - what is the id of the review
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} post_type - is a new review post, or a comment on a review
 * @property {boolean} has_description - Is it only title? or also description?
 * @property {string} appScore - ( 1,2,3,4,5 ) , what is the score that user gave the app
 * @property {string} review_title - title of the review given by the user that post the review
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} actionType - add_review, edit_review
 * @property {string} tag_type - tag_type
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {string} review_body - review_body
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPostAppReviewParams>} LogObject<appMarketPostAppReviewParams>
 */
export function appMarketPostAppReview(params) {
    return { evid: 106, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAddEditAppReviewClick' event (evid: 107)
 *
 * Event description: User opens the review modal of an app.
 *
 * @param {appMarketAddEditAppReviewClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} post_type - is a new review post, or a comment on a review
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} actionType - add_review, edit_review
 * @property {string} tag_type - tag_type
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketAddEditAppReviewClickParams>} LogObject<appMarketAddEditAppReviewClickParams>
 */
export function appMarketAddEditAppReviewClick(params) {
    return { evid: 107, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCancelAppReviewClick' event (evid: 108)
 *
 * Event description: Clicking on cancel when review page is open for apps.
 *
 * @param {appMarketCancelAppReviewClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} tag_type - tag_type
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketCancelAppReviewClickParams>} LogObject<appMarketCancelAppReviewClickParams>
 */
export function appMarketCancelAppReviewClick(params) {
    return { evid: 108, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSortReviews' event (evid: 109)
 *
 * Event description: Sorting apps reviews
 *
 * @param {appMarketSortReviewsParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} value - {most_recent, most_liked, highest_rate, lowest_rate}
 * @return {LogObject<appMarketSortReviewsParams>} LogObject<appMarketSortReviewsParams>
 */
export function appMarketSortReviews(params) {
    return { evid: 109, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketOpened' event (evid: 11)
 *
 * Event description: market opened
 *
 * @param {marketOpenedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {number} num_pending_apps - {0,1,2...}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {number} ts - market loading time in ms
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} personalized - {general, online_store, music...}
 * @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
 * @property {string} page_name - {'home, 'pending', 'app', 'search'}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {boolean} is_first - (per user per site)
 * @property {string} vertical - {general, online_store, music...}
 * @property {number} ts_partial - loading time from previous step (after the SSR was loaded) in ms
 * @property {string} tag_type - type of tag, 'homepage','app page', 'category page' etc)
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag, category name such as 'music' etc
 * @property {string} postreg_category - what is the postreg category of the site
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 *
 * @return {LogObject<marketOpenedParams>} LogObject<marketOpenedParams>
 */
export function marketOpened(params) {
    return { evid: 11, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketLikeUnlikeAppReview' event (evid: 110)
 *
 * Event description: AppMarket - Like /Dislike App Review
 *
 * @param {appMarketLikeUnlikeAppReviewParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} helpful_click - like / unlike
 * @property {GUID} appId - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketLikeUnlikeAppReviewParams>} LogObject<appMarketLikeUnlikeAppReviewParams>
 */
export function appMarketLikeUnlikeAppReview(params) {
    return { evid: 110, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPackagePickerNavigation' event (evid: 1102)
 *
 * Event description: Event is triggered whenever the user navigates between the screens in the PP (select a plan/ select a billing cycle/ complete your purchase)
 *
 * @param {appMarketPackagePickerNavigationParams} params - The parameters for this event
 * @property {string} buttonType - back/breadcrumbs
 * @property {string} from_tab - navigation origin
 * @property {string} vertical - vertical
 * @property {string} to_tab - navigation destination
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPackagePickerNavigationParams>} LogObject<appMarketPackagePickerNavigationParams>
 */
export function appMarketPackagePickerNavigation(params) {
    return { evid: 1102, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAutocompleteFailed' event (evid: 1103)
 *
 * Event description: autocomplete Failed
 *
 * @param {appMarketAutocompleteFailedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone}
 * @property {string} vertical - vertical
 * @property {string} autocomplete_query - auto_search_term
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {string} type - {search_term, app, category}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketAutocompleteFailedParams>} LogObject<appMarketAutocompleteFailedParams>
 */
export function appMarketAutocompleteFailed(params) {
    return { evid: 1103, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPendingAppConsentModalLoaded' event (evid: 1104)
 *
 * Event description: When users tries to use an app that was installed but not all the way properly (so its in pending mode). the app will prompt the user to finish the installation first.
 *
 * @param {appMarketPendingAppConsentModalLoadedParams} params - The parameters for this event
 * @property {string} step_name - 'modal opened' or 'click on start'
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPendingAppConsentModalLoadedParams>} LogObject<appMarketPendingAppConsentModalLoadedParams>
 */
export function appMarketPendingAppConsentModalLoaded(params) {
    return { evid: 1104, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketShowHideMenuClick' event (evid: 1105)
 *
 * Event description: The user clicks on Show Menu / Hide menu.
 * menu: BizManager (Dashboard) sidebar menu
 *
 * @param {appMarketShowHideMenuClickParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} vertical - vertical
 * @property {string} entry_point - user enter the market from: dashboard_sidebar_menu, search, explore, dashboard_more_than_a_website
 * @property {string} type - type of click: 'show' or 'hide'
 * @property {GUID} esi - esi
 * @property {string} page_type - current page in the App Market: Homepage, manage_apps, app_page, collection, category
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketShowHideMenuClickParams>} LogObject<appMarketShowHideMenuClickParams>
 */
export function appMarketShowHideMenuClick(params) {
    return { evid: 1105, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPageView' event (evid: 111)
 *
 * Event description: Every page opened in the App Market will trigger this event.
 *
 * @param {appMarketPageViewParams} params - The parameters for this event
 * @property {string} slug_index_list - list of slug_id presented in homepage from top to bottom
 * @property {string} navigation_source - what triggered the pave view? ( menu navigation, search, deep link etc)
 * @property {string} utm_id - campaign source
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {boolean} has_app_requirement - true\false
 * @property {boolean} is_compatible - true\false
 * @property {string} app_subcategory - if app was shown in a category page where sub categories were selected - name them.
 * @property {string} referral_sub_tag_name - e.g. sub category
 * @property {string} widget_referral - is flow referred from widget
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info (correct, no typo)
 * @property {number} referral_section_index - what is the index number of the app box that was clicked in previous page
 * @property {boolean} in_context_view - bool
 * @property {number} app_review_score - the current app score when a app page is loaded. (multiplied by 100 due to format limitations). if No score, -1000 will be the score.
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - Impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} page_name - page name
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - search_term used to get here
 * @property {string} vertical - vertical
 * @property {string} sub_tag_name - sub tag . e.g. sub-categories
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - if app page opened, app_id. Else = null
 * @property {string} tag_type - tag type - collection, category
 * @property {boolean} is_app_dependency - true\false
 * @property {boolean} is_external - not originally from the app market
 * @property {number} app_review_count - how many reviews were posted for this app at this point
 * @property {GUID} esi - esi
 * @property {string} refferal_info - refferal_info - is typo
 * @property {GUID} msid - msid
 * @property {string} tag_name - the name of the tag type (if collection - must have apps, free apps etc. if category - music, video , business etc)
 * @property {string} referral_tag_type - previous page type
 * @property {string} referral_tag_name - what is the tag_name that referred to this page
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} badge_name - in case it’s an app page (tag_type=’app_page’) report an array with all the badge names that appear in the app box separated by commas, f.e: premium_benefit, wix_choice
 * In case it’s not the app page report null.
 * @property {string} page_id - the ID of the page viewed
 * @property {string} page_url - the relevant part in the URL of this page
 * @property {string} origin - relevant only to apps in context otherwise will be null. the origin will be the project/area calling to app market component.
 *
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @property {string} history_path - a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @property {string} last_page - the last page the user visited before he entered the app page.
 * will be reported only when the tag_type='app_page', otherwise null
 * @property {number} sale_discount -  sale_type
 * If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketPageViewParams>} LogObject<appMarketPageViewParams>
 */
export function appMarketPageView(params) {
    return { evid: 111, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketOpenAppCategory' event (evid: 112)
 *
 * Event description: Open an entire app category for farther browsing
 *
 * @param {appMarketOpenAppCategoryParams} params - The parameters for this event
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} category_tree - is category or subcategory
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} app_category - App category name (fitness, photography, marketing etc)
 * @property {string} pageType - Type of page viewed ( Homepage, App page, Developer page , collection page etc)
 * @property {GUID} esi - esi
 * @property {number} index - ranking order of see-more-apps click from top to bottom (1 is first, 2 is 2nd, 3 is 3rd etc).
 * @return {LogObject<appMarketOpenAppCategoryParams>} LogObject<appMarketOpenAppCategoryParams>
 */
export function appMarketOpenAppCategory(params) {
    return { evid: 112, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppImpression' event (evid: 113)
 *
 * Event description: When an app is loaded and visible to user, meaning it was exposed for the user to engage with.
 *
 * @param {appMarketAppImpressionParams} params - The parameters for this event
 * @property {string} price_label_eng - Free, starting from 4 GBP / month
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {boolean} is_compatible - true\false
 * @property {string} impression_type - type of exposure of app (app cube, search suggestion etc)
 * @property {string} app_subcategory - if app was shown in a category page where sub categories were selected - name them.
 * @property {GUID} collimp_id - collection impression id
 * @property {number} section_index - from top = 0, to last = 0+n. what is the ranking order of the section presented?
 * @property {number} app_review_score - the score shown next to the app name
 * @property {string} section - section in which app box is located
 * @property {GUID} impression_id - impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} badge_name - name of badge of app box (e.g - Premium Benefit)
 * @property {string} page_name - page name
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - search_term used to expose this app
 * @property {string} vertical - vertical
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} app_id - app id
 * @property {string} tag_type - collection, category
 * @property {boolean} is_app_dependency - true\false
 * @property {number} app_review_count - total number of reviews in the parentheses
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag (must have apps, music apps, free collection etc).
 * @property {number} index - The listing ranking of the number in the presented page.
 * @property {string} badge_name_for_test - temp badge name for AB test
 * @property {boolean} in_context_view - true if the app impression is through “in context”, otherwise false
 * @property {string} origin - in case the app impression from context the origin will be the project/area calling to app market component
 * @property {string} in_context_mode - in case the app impression is in context report the context mode: page (for back office page apps in context)/modal (for apps modal in the back office)
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset.
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketAppImpressionParams>} LogObject<appMarketAppImpressionParams>
 */
export function appMarketAppImpression(params) {
    return { evid: 113, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSpotlightArticle' event (evid: 114)
 *
 * Event description: In the Manage Apps tab, when user is exposed to an action requirement of an app.
 *
 * @param {appMarketSpotlightArticleParams} params - The parameters for this event
 * @property {string} market - market (dashboard, editor standalone
 * @property {Url} url - article url
 * @property {string} action_cta - cta action (claim app, upgrade app, add info, etc)
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} sale_discount - If the app is on sale and the sale badge appears, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketSpotlightArticleParams>} LogObject<appMarketSpotlightArticleParams>
 */
export function appMarketSpotlightArticle(params) {
    return { evid: 114, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketConsentPageAllowAndInstall' event (evid: 115)
 *
 * Event description: User allows permission to app requests, and proceeds to install app
 *
 * @param {appMarketConsentPageAllowAndInstallParams} params - The parameters for this event
 * @property {number} num_of_permissions - number of permissions requested by the installer
 * @property {string} market - editor, dashboard market?
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info
 * @property {string} consentVersion - new consent, old consent
 * @property {string} marketVersion - new market or old market
 * @property {string} vertical - what is the vertical of the site
 * @property {GUID} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {string} flow_type - consent or update_app_version
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {boolean} in_context_view - true if the consent modal was triggered through “in context”, otherwise false
 * @return {LogObject<appMarketConsentPageAllowAndInstallParams>} LogObject<appMarketConsentPageAllowAndInstallParams>
 */
export function appMarketConsentPageAllowAndInstall(params) {
    return { evid: 115, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketMenuNavigation' event (evid: 116)
 *
 * Event description: User navigate through the App Market, using the side menu.
 *
 * @param {appMarketMenuNavigationParams} params - The parameters for this event
 * @property {string} market - editor, dashboard etc
 * @property {string} slug_id - slug_id
 * @property {string} marketVersion - version of the market - old or new
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {string} menu_item_label - name of menu label
 * @property {GUID} msid - msid
 * @property {number} index - index of label in menu
 * @property {string} item_type - The type of the item clicked in the sidebar. Values: ‘home’, ‘collection’, ‘category’, ‘manage_apps’
 * @property {string} item_section - The section of the item clicked in the sidebar. Values: ‘Explore’, ‘Apps to Help You’, ‘Categories’, else null.
 * @property {string} page_type - The type of the page that the user is on when clicking on one of the sidebar items.
 * @property {string} page_name - The name of the page that the user is on when clicking on one of the sidebar items.
 * @return {LogObject<appMarketMenuNavigationParams>} LogObject<appMarketMenuNavigationParams>
 */
export function appMarketMenuNavigation(params) {
    return { evid: 116, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketConsentPageAllowAndInstallSrc24Evid117' event (evid: 117)
 *
 * Event description: This event was never used. can be used for new events.
 *
 * @param {appMarketConsentPageAllowAndInstallSrc24Evid117Params} params - The parameters for this event
 * @property {string} marketVersion - new market or old market
 * @property {string} vertical - what is the vertical of the site
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketConsentPageAllowAndInstallSrc24Evid117Params>} LogObject<appMarketConsentPageAllowAndInstallSrc24Evid117Params>
 */
export function appMarketConsentPageAllowAndInstallSrc24Evid117(params) {
    return { evid: 117, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSubCategoryClick' event (evid: 118)
 *
 * Event description: User clicks on a sub-category tag, to filter in (or out) the apps that are presented in a category page. Also triggered when sub-category on sidebar is clicked.
 * Reporting from the sidebar will stop in September 2024, and 24:116 will replace it with specific filters.
 *
 * @param {appMarketSubCategoryClickParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} category_name - name of category page
 * @property {string} subcategory_name - name of sub-category clicked
 * @property {string} marketVersion - new or old
 * @property {string} loaction - from where the user reached to the page, and then clicked on the sub category- side menu and etc
 * @property {string} vertical - vertical
 * @property {string} type - type of click: 'exclude' or 'include'
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} app_id - The app_id of the app, if this click was made on an app page
 * @return {LogObject<appMarketSubCategoryClickParams>} LogObject<appMarketSubCategoryClickParams>
 */
export function appMarketSubCategoryClick(params) {
    return { evid: 118, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPageScroll' event (evid: 119)
 *
 * Event description: How much did the user scrolled down while browsing different pages in the App Market.
 *
 * @param {appMarketPageScrollParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {number} pixels_scrolled - amount of pixels scrolled down from page start
 * @property {string} marketVersion - market version = 'new'
 * @property {string} vertical - vertical
 * @property {string} pageType - Type of page viewed ( Homepage, App page, Developer page , collection page, category etc)
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of tag, if exists (category - video, music etc. collection - must have apps, free apps ... etc)
 * @return {LogObject<appMarketPageScrollParams>} LogObject<appMarketPageScrollParams>
 */
export function appMarketPageScroll(params) {
    return { evid: 119, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryClick' event (evid: 12)
 *
 * Event description: Choosing an app category from the categories menu in the app market
 *
 * @param {categoryClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {string} widget_name - widget_name
 * @property {GUID} uuid - uuid
 * @property {string} subcategory_name - subcategory name
 * @property {string} page_name - homepage etc.
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {welcome_screen, direct,...} 'more_apps_like_this' = app page
 * @property {string} category - {new, my_apps,...}
 * @property {string} tag_type - tag type
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag_name
 * @property {string} app_id - app_id if this click is on an app page
 * @return {LogObject<categoryClickParams>} LogObject<categoryClickParams>
 */
export function categoryClick(params) {
    return { evid: 12, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPendingForDeleteModalGoToEditorClick' event (evid: 120)
 *
 * Event description: when user is trying to delete an editor component app from the BM , he will get this modal to ask him to move to Editor. clicking on action button will send this bi
 *
 * @param {appMarketPendingForDeleteModalGoToEditorClickParams} params - The parameters for this event
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPendingForDeleteModalGoToEditorClickParams>} LogObject<appMarketPendingForDeleteModalGoToEditorClickParams>
 */
export function appMarketPendingForDeleteModalGoToEditorClick(params) {
    return { evid: 120, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPostConsentLoaded' event (evid: 121)
 *
 * Event description: After Consent flow for app install is finished, user will be prompt to take action in some cases. when presented to so , this event will be sent.
 *
 * @param {appMarketPostConsentLoadedParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} post_consent_type - type of the post conten
 * @property {boolean} in_context_view - bool
 * @property {string} marketVersion - for new market = 'new', else null
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPostConsentLoadedParams>} LogObject<appMarketPostConsentLoadedParams>
 */
export function appMarketPostConsentLoaded(params) {
    return { evid: 121, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPostConsentAction' event (evid: 122)
 *
 * Event description: After Consent flow for app install is finished, user will be prompt to take action in some cases. when user is taking action in this window, this event will be sent.
 *
 * @param {appMarketPostConsentActionParams} params - The parameters for this event
 * @property {string} market - market
 * @property {boolean} in_context_view - bool
 * @property {string} marketVersion - for new market = 'new', else null
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} action - what is the action that the user clicked on
 * @return {LogObject<appMarketPostConsentActionParams>} LogObject<appMarketPostConsentActionParams>
 */
export function appMarketPostConsentAction(params) {
    return { evid: 122, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketWidgetLoaded' event (evid: 123)
 *
 * Event description: Widget is loaded to user, for example - recommended apps widget in the business manager homepage.
 *
 * @param {appMarketWidgetLoadedParams} params - The parameters for this event
 * @property {string} widget_name - what is the widget name
 * @property {string} vertical - vertical
 * @property {string} origin - what is the origin of the widget?
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketWidgetLoadedParams>} LogObject<appMarketWidgetLoadedParams>
 */
export function appMarketWidgetLoaded(params) {
    return { evid: 123, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPendingForDeleteModalCloseModal' event (evid: 124)
 *
 * Event description: when user is trying to delete an editor component app from the BM , he will get this modal to ask him to move to Editor.closing this modal will send this bi event
 *
 * @param {appMarketPendingForDeleteModalCloseModalParams} params - The parameters for this event
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPendingForDeleteModalCloseModalParams>} LogObject<appMarketPendingForDeleteModalCloseModalParams>
 */
export function appMarketPendingForDeleteModalCloseModal(params) {
    return { evid: 124, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketBreadcrumbsClick' event (evid: 125)
 *
 * Event description: user clicks on breadcrumb navigation
 *
 * @param {appMarketBreadcrumbsClickParams} params - The parameters for this event
 * @property {number} nav_level - level of breadcrumb clicked, 1 > 2 > 3 > etc
 * @property {string} tag_name_clicked - tag name of target
 * @property {string} market - market
 * @property {string} tag_type_clicked - target of tag type
 * @property {string} marketVersion - "new" for new market, else null
 * @property {string} vertical - vertical
 * @property {string} tag_type - tag type
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @return {LogObject<appMarketBreadcrumbsClickParams>} LogObject<appMarketBreadcrumbsClickParams>
 */
export function appMarketBreadcrumbsClick(params) {
    return { evid: 125, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDeveloperContactBoxActionClick' event (evid: 126)
 *
 * Event description: User clicks on developer contact box action in the App page
 *
 * @param {appMarketDeveloperContactBoxActionClickParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} marketVersion - market version, "new" for new else null
 * @property {string} vertical - vertical
 * @property {string} actionName - name of action taken:  [visit_website, contact_support, privacy]
 * @property {string} app_id - app_id
 * @property {string} tag_type - tag_type
 * @property {GUID} esi - editor session id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @return {LogObject<appMarketDeveloperContactBoxActionClickParams>} LogObject<appMarketDeveloperContactBoxActionClickParams>
 */
export function appMarketDeveloperContactBoxActionClick(params) {
    return { evid: 126, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPendingForDeleteModalLoaded' event (evid: 127)
 *
 * Event description: when user is trying to delete an editor component app from the BM , he will get this modal to ask him to move to Editor.
 *
 * @param {appMarketPendingForDeleteModalLoadedParams} params - The parameters for this event
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketPendingForDeleteModalLoadedParams>} LogObject<appMarketPendingForDeleteModalLoadedParams>
 */
export function appMarketPendingForDeleteModalLoaded(params) {
    return { evid: 127, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppCollectionImpressions' event (evid: 128)
 *
 * Event description: Section
 *
 * @param {appMarketAppCollectionImpressionsParams} params - The parameters for this event
 * @property {number} collection_index - what is the index of the collection in the page (from top to bottom)
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} prediction_type - is it static, or using the data science model to choose apps shown
 * @property {string} apps_list - list of app_id by the order they are presented from top left, seperated by ","
 * @property {GUID} collimp_id - collection impression id (guid)
 * @property {string} page_name - page name
 * @property {string} vertical - vertical
 * @property {number} number_of_apps - how many apps presented in the collection
 * @property {string} tag_type - collection, category
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag (must have apps, music apps, free collection etc).
 * @property {string} history_path -  a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @return {LogObject<appMarketAppCollectionImpressionsParams>} LogObject<appMarketAppCollectionImpressionsParams>
 */
export function appMarketAppCollectionImpressions(params) {
    return { evid: 128, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketMobileAlertForInstallMoveToDesktop' event (evid: 129)
 *
 * Event description: User try to install an app from the  mobile standalone appmarket and we open a modal to tell him to move to desktop.
 *
 * @param {appMarketMobileAlertForInstallMoveToDesktopParams} params - The parameters for this event
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketMobileAlertForInstallMoveToDesktopParams>} LogObject<appMarketMobileAlertForInstallMoveToDesktopParams>
 */
export function appMarketMobileAlertForInstallMoveToDesktop(params) {
    return { evid: 129, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchSearchClick' event (evid: 13)
 *
 * Event description: search -> search click
 *
 * @param {searchSearchClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone}
 * @property {string} search_term_typed - the actual term before autocomplete choice
 * @property {string} search_type - direct, apps, popular, categories
 * @property {GUID} uuid - uuid
 * @property {string} page_name - page name
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {search_auto, direct}
 * @property {string} tag_type - tag_type of searched bar
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} index - index number of app preseting ranking order
 * @property {string} search_location - search_location
 * @property {string} history_path - a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @property {string} last_page - the last page the user visited before he entered the app page.
 * will be reported only when the tag_type='app_page', otherwise null
 * @return {LogObject<searchSearchClickParams>} LogObject<searchSearchClickParams>
 */
export function searchSearchClick(params) {
    return { evid: 13, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageScrollPage' event (evid: 130)
 *
 * Event description: How much did the user scrolled down while browsing the app page in the App Market.
 *
 * @param {appMarketAppPageScrollPageParams} params - The parameters for this event
 * @property {string} page_part - what is the part in the page that was exposed ( reviews, pricing plans, overview etc)
 * @property {string} market - dashboard, editor, standalone
 * @property {string} marketVersion - new
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {number} page_part_index - the order of the part from top to bottom (1, 2, ,3 ...)
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of tag, if exists (category - video, music etc. collection - must have apps, free apps ... etc)
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {number} num_packages - Number of pricing plans shown
 *
 * @property {number} num_benefits_packages - Number of pricing plans with benefits badge
 * @return {LogObject<appMarketAppPageScrollPageParams>} LogObject<appMarketAppPageScrollPageParams>
 */
export function appMarketAppPageScrollPage(params) {
    return { evid: 130, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateAppClickUpdate' event (evid: 131)
 *
 * Event description: user click on upgrade app
 *
 * @param {appMarketUpdateAppClickUpdateParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<appMarketUpdateAppClickUpdateParams>} LogObject<appMarketUpdateAppClickUpdateParams>
 */
export function appMarketUpdateAppClickUpdate(params) {
    return { evid: 131, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateAppOpenUpdateModal' event (evid: 132)
 *
 * Event description: Update Modal - Modal Opened after user clicked on 'update app'
 *
 * @param {appMarketUpdateAppOpenUpdateModalParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<appMarketUpdateAppOpenUpdateModalParams>} LogObject<appMarketUpdateAppOpenUpdateModalParams>
 */
export function appMarketUpdateAppOpenUpdateModal(params) {
    return { evid: 132, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateAppApproveUpdate' event (evid: 133)
 *
 * Event description: User approve update in the update modal
 *
 * @param {appMarketUpdateAppApproveUpdateParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<appMarketUpdateAppApproveUpdateParams>} LogObject<appMarketUpdateAppApproveUpdateParams>
 */
export function appMarketUpdateAppApproveUpdate(params) {
    return { evid: 133, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageClickReadMoreDescription' event (evid: 134)
 *
 * Event description: when a user clicks on the "Read More" button (app description), from the app page in the app market.
 *
 * @param {appMarketAppPageClickReadMoreDescriptionParams} params - The parameters for this event
 * @property {string} market - What market? (dashboard, editor, standalone etc)
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketAppPageClickReadMoreDescriptionParams>} LogObject<appMarketAppPageClickReadMoreDescriptionParams>
 */
export function appMarketAppPageClickReadMoreDescription(params) {
    return { evid: 134, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketBackButtonClick' event (evid: 135)
 *
 * Event description: User clicks to go back from where he is.
 *
 * @param {appMarketBackButtonClickParams} params - The parameters for this event
 * @property {string} location - location of button
 * @property {string} market - what is the market
 * @property {string} vertical - vertical
 * @property {string} tag_type - (homepage, app page, collection etc)
 * @property {GUID} appId - null if not in app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @return {LogObject<appMarketBackButtonClickParams>} LogObject<appMarketBackButtonClickParams>
 */
export function appMarketBackButtonClick(params) {
    return { evid: 135, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCollectionsPills' event (evid: 137)
 *
 * Event description: In the Home page ----> discovery flow, each pill is collection.
 *
 * @param {appMarketCollectionsPillsParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {GUID} collimp_id - collection impression id (guid)
 * @property {string} slug_id - slug_id
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} index - what is the index of the collection in the flow (from top to bottom)
 * @return {LogObject<appMarketCollectionsPillsParams>} LogObject<appMarketCollectionsPillsParams>
 */
export function appMarketCollectionsPills(params) {
    return { evid: 137, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketStandaloneHomepageClicksOnGetStarted' event (evid: 138)
 *
 * Event description: user enters the standalone homepage and clicks on get started (link to Wix Studio / funnel).
 *
 * @param {appMarketStandaloneHomepageClicksOnGetStartedParams} params - The parameters for this event
 * @property {string} market - standalone
 * @property {string} page_name - homepage etc.
 * @property {string} vertical - vertical
 * @property {string} tag_type - home page
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketStandaloneHomepageClicksOnGetStartedParams>} LogObject<appMarketStandaloneHomepageClicksOnGetStartedParams>
 */
export function appMarketStandaloneHomepageClicksOnGetStarted(params) {
    return { evid: 138, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketStandaloneHomepageClicksOnStartNow' event (evid: 139)
 *
 * Event description: user enters the standalone homepage and clicks on start now (link to dev center).
 *
 * @param {appMarketStandaloneHomepageClicksOnStartNowParams} params - The parameters for this event
 * @property {string} market - standalone
 * @property {string} page_name - page name
 * @property {string} vertical - vertical
 * @property {string} tag_type - home page
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketStandaloneHomepageClicksOnStartNowParams>} LogObject<appMarketStandaloneHomepageClicksOnStartNowParams>
 */
export function appMarketStandaloneHomepageClicksOnStartNow(params) {
    return { evid: 139, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchSearchFocus' event (evid: 14)
 *
 * Event description: search -> search focus
 *
 * @param {searchSearchFocusParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone}
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} search_location - search_location
 * @return {LogObject<searchSearchFocusParams>} LogObject<searchSearchFocusParams>
 */
export function searchSearchFocus(params) {
    return { evid: 14, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketWidgetsNavigationClick' event (evid: 140)
 *
 * Event description: user navigate in the widget section to right or left
 *
 * @param {appMarketWidgetsNavigationClickParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} widget_type - collection/category
 * @property {string} direction - 'right' or 'left'
 * @property {string} section - widget name
 * @property {string} page_name - page name (homepage etc.)
 * @property {string} marketVersion - new
 * @property {string} vertical - vertical
 * @property {string} tag_type - type of tag
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of tag
 * @return {LogObject<appMarketWidgetsNavigationClickParams>} LogObject<appMarketWidgetsNavigationClickParams>
 */
export function appMarketWidgetsNavigationClick(params) {
    return { evid: 140, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDeleteModalClickOnCustomerCare' event (evid: 141)
 *
 * Event description: User clicks on contact Customer Care button in the delete modal
 *
 * @param {appMarketDeleteModalClickOnCustomerCareParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {string} tag_type - Where did the delete take place from?
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketDeleteModalClickOnCustomerCareParams>} LogObject<appMarketDeleteModalClickOnCustomerCareParams>
 */
export function appMarketDeleteModalClickOnCustomerCare(params) {
    return { evid: 141, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSubCategoryHover' event (evid: 142)
 *
 * Event description: User hovers on a sub-category tag, to filter in (or out) the apps that are presented in a category page.
 *
 * @param {appMarketSubCategoryHoverParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} category_name - name of category page
 * @property {string} subcategory_name - name of sub-category hovered
 * @property {string} loaction - from where the user reached to the page, and then hovered on the sub category- side menu and etc
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSubCategoryHoverParams>} LogObject<appMarketSubCategoryHoverParams>
 */
export function appMarketSubCategoryHover(params) {
    return { evid: 142, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleCheckAllSaleAppsCollectionClick' event (evid: 143)
 *
 * Event description: App Market - Sale - Check All Sale Apps Click
 *
 * @param {appMarketSaleCheckAllSaleAppsCollectionClickParams} params - The parameters for this event
 * @property {string} market - market - app market, manage apps, dashboard
 * @property {string} slug_id - pre-holiday-sale
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {string} tag_type - tag_type
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} button_location - top or botton
 * @return {LogObject<appMarketSaleCheckAllSaleAppsCollectionClickParams>} LogObject<appMarketSaleCheckAllSaleAppsCollectionClickParams>
 */
export function appMarketSaleCheckAllSaleAppsCollectionClick(params) {
    return { evid: 143, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleUpgradePlanClick' event (evid: 144)
 *
 * Event description: App Market -  Sale - Upgrade Plan Click
 *
 * @param {appMarketSaleUpgradePlanClickParams} params - The parameters for this event
 * @property {string} market - market - app market, manage apps, dashboard
 * @property {string} slug_id - pre-holiday-sale
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} referral_tag_type - ‘home page’\ ‘manage apps’ \ search
 * @property {string} button_location - click location
 * @return {LogObject<appMarketSaleUpgradePlanClickParams>} LogObject<appMarketSaleUpgradePlanClickParams>
 */
export function appMarketSaleUpgradePlanClick(params) {
    return { evid: 144, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketClickOnCompleteSetup' event (evid: 145)
 *
 * Event description: User clicks 'Complete Setup'
 *
 * @param {appMarketClickOnCompleteSetupParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} referral_info - referral info
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @return {LogObject<appMarketClickOnCompleteSetupParams>} LogObject<appMarketClickOnCompleteSetupParams>
 */
export function appMarketClickOnCompleteSetup(params) {
    return { evid: 145, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleCheckAllSaleAppsHeaderClick' event (evid: 146)
 *
 * Event description: App Market - Sale - Check All Sale Apps Click
 *
 * @param {appMarketSaleCheckAllSaleAppsHeaderClickParams} params - The parameters for this event
 * @property {string} market - market - app market, manage apps, dashboard
 * @property {string} slug_id - pre-holiday-sale
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} referral_tag_type - ‘home page’\ ‘manage apps’ \ search
 * @return {LogObject<appMarketSaleCheckAllSaleAppsHeaderClickParams>} LogObject<appMarketSaleCheckAllSaleAppsHeaderClickParams>
 */
export function appMarketSaleCheckAllSaleAppsHeaderClick(params) {
    return { evid: 146, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketTpaPricingPlansErrorPageLoaded' event (evid: 147)
 *
 * Event description: Monitoring client side errors during package picker funnel
 *
 * @param {appMarketTpaPricingPlansErrorPageLoadedParams} params - The parameters for this event
 * @property {string} pp_origin - Where did the package picker opened from
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} error_cause - error_cause
 * @return {LogObject<appMarketTpaPricingPlansErrorPageLoadedParams>} LogObject<appMarketTpaPricingPlansErrorPageLoadedParams>
 */
export function appMarketTpaPricingPlansErrorPageLoaded(params) {
    return { evid: 147, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppInstallationWithSilentConsent' event (evid: 148)
 *
 * Event description: App Installation started with silent consent - for wix apps or apps with silent consent.
 *
 * @param {appMarketAppInstallationWithSilentConsentParams} params - The parameters for this event
 * @property {string} slug_index_list - list of slug_id presented in homepage from top to bottom
 * @property {string} navigation_source - navigation_source
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} app_subcategory - app_subcategory
 * @property {string} widget_referral - is flow referred from widget
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info (correct, no typo)
 * @property {number} referral_section_index - what is the index number of the app box that was clicked in previous page
 * @property {boolean} in_context_view - bool
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - Impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - search_term
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - referral_section_name
 * @property {string} app_id - if app page opened, app_id. Else = null
 * @property {string} tag_type - tag_type
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - the name of the tag type (if collection - must have apps, free apps etc. if category - music, video , business etc)
 * @property {string} referral_tag_name - what is the tag_name that referred to this page
 * @return {LogObject<appMarketAppInstallationWithSilentConsentParams>} LogObject<appMarketAppInstallationWithSilentConsentParams>
 */
export function appMarketAppInstallationWithSilentConsent(params) {
    return { evid: 148, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppUpgradeCheckoutAttempt' event (evid: 149)
 *
 * Event description: AppMarket - App Upgrade - Upgrade Button Click.
 *
 * @param {appMarketAppUpgradeCheckoutAttemptParams} params - The parameters for this event
 * @property {string} pp_origin - where was the upgrade click initiated
 * @property {string} billing_flow - billing_flow
 * @property {string} vendorProductId - vendor_id
 * @property {string} coupon_name - name of coupon used to get discount or special offer
 * @property {string} vertical - app's vertical
 * @property {string} sale_name - nov21
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {number} payment_cycle - cycle_id = 3 is monthly, 6 is yearly etc.
 * @property {GUID} msid - msid
 * @property {string} flow_type - upgrade/free trial/downgrade
 * @property {string} app_plan_id - the app's package id/vendor Id
 * @property {string} package_name - the package name, f.e: 'premium', 'pro', etc.
 *
 * @property {string} app_instance_id - unique combination of app_id+msid
 * @return {LogObject<appMarketAppUpgradeCheckoutAttemptParams>} LogObject<appMarketAppUpgradeCheckoutAttemptParams>
 */
export function appMarketAppUpgradeCheckoutAttempt(params) {
    return { evid: 149, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchSearchResults' event (evid: 15)
 *
 * Event description: User interact with the search bar in the AppMarket. after typing a search term user will either: hit 'enter', choose an 'Autocomplete' option from search results, 'exit' the search.
 *
 * @param {searchSearchResultsParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone}
 * @property {GUID} site_id - site_id
 * @property {string} search_type - autocomplete , trending, recommended
 * @property {GUID} uuid - uuid
 * @property {GUID} first_result_app_id - [first_result_app_id]
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_results - {0,1,2,...}
 * @return {LogObject<searchSearchResultsParams>} LogObject<searchSearchResultsParams>
 */
export function searchSearchResults(params) {
    return { evid: 15, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketToastPresented' event (evid: 150)
 *
 * Event description: Toast is presented for user to take action for app.
 *
 * @param {appMarketToastPresentedParams} params - The parameters for this event
 * @property {string} market - dashboard, editor etc
 * @property {string} action_cta - action required
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketToastPresentedParams>} LogObject<appMarketToastPresentedParams>
 */
export function appMarketToastPresented(params) {
    return { evid: 150, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiOpenAppBo' event (evid: 1500)
 *
 * Event description: Site opens the app back office (dashboard)
 *
 * @param {thirdPartyAppsBiOpenAppBoParams} params - The parameters for this event
 * @property {string} event_data - event data for user
 * @property {GUID} app_instance_id - app_instance_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<thirdPartyAppsBiOpenAppBoParams>} LogObject<thirdPartyAppsBiOpenAppBoParams>
 */
export function thirdPartyAppsBiOpenAppBo(params) {
    return { evid: 1500, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiAppFinishedSetup' event (evid: 1501)
 *
 * Event description: This event is sent when user finishes the setup required in the 3rd party app platform. than - the 3rd party app sends a token 'oauth recevied'
 *
 * @param {thirdPartyAppsBiAppFinishedSetupParams} params - The parameters for this event
 * @property {string} event_data - holds any additional data about the event
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id
 * @return {LogObject<thirdPartyAppsBiAppFinishedSetupParams>} LogObject<thirdPartyAppsBiAppFinishedSetupParams>
 */
export function thirdPartyAppsBiAppFinishedSetup(params) {
    return { evid: 1501, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiAppDeepAction' event (evid: 1502)
 *
 * Event description: Site performs a deep action, related to the app
 *
 * @param {thirdPartyAppsBiAppDeepActionParams} params - The parameters for this event
 * @property {string} event_data - holds any additional data about the event
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id
 * @return {LogObject<thirdPartyAppsBiAppDeepActionParams>} LogObject<thirdPartyAppsBiAppDeepActionParams>
 */
export function thirdPartyAppsBiAppDeepAction(params) {
    return { evid: 1502, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiCustomBiEvent' event (evid: 1503)
 *
 * Event description: Custom BI event for app to send
 *
 * @param {thirdPartyAppsBiCustomBiEventParams} params - The parameters for this event
 * @property {string} event_data - holds any additional data about the event
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} locationGuid - location id
 * @property {GUID} app_id - app_id
 * @property {string} type - type
 * @property {string} custom_event_name - custom BI event name given to app
 * @property {GUID} msid - site id
 * @property {string} value - value
 * @return {LogObject<thirdPartyAppsBiCustomBiEventParams>} LogObject<thirdPartyAppsBiCustomBiEventParams>
 */
export function thirdPartyAppsBiCustomBiEvent(params) {
    return { evid: 1503, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiAppUpgradedExternal' event (evid: 1504)
 *
 * Event description: App was upgraded to premium, externali (outside of Wix)
 *
 * @param {thirdPartyAppsBiAppUpgradedExternalParams} params - The parameters for this event
 * @property {string} event_data - holds any additional data about the event
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id
 * @return {LogObject<thirdPartyAppsBiAppUpgradedExternalParams>} LogObject<thirdPartyAppsBiAppUpgradedExternalParams>
 */
export function thirdPartyAppsBiAppUpgradedExternal(params) {
    return { evid: 1504, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiChargeExternal' event (evid: 1505)
 *
 * Event description: A Charge was made externali
 *
 * @param {thirdPartyAppsBiChargeExternalParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name (monthly, yearly etc)
 * @property {string} event_data - full json parsed data for devs
 * @property {string} reason - reason
 * @property {string} currency - currency
 * @property {GUID} app_id - app_id
 * @property {string} app_plan_id - plan id of app
 * @property {GUID} msid - site id
 * @property {GUID} instance_id - app and msid guid - instance_id
 * @property {number} sum - sum of $
 * @return {LogObject<thirdPartyAppsBiChargeExternalParams>} LogObject<thirdPartyAppsBiChargeExternalParams>
 */
export function thirdPartyAppsBiChargeExternal(params) {
    return { evid: 1505, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiRefundExternal' event (evid: 1506)
 *
 * Event description: A refund was made externali
 *
 * @param {thirdPartyAppsBiRefundExternalParams} params - The parameters for this event
 * @property {string} cycle_name - cycle name (monthly, yearly etc)
 * @property {string} event_data - full json parsed data for devs
 * @property {string} reason - reason of charge ('new charge', 'renewal')
 * @property {string} currency - currency of payment
 * @property {GUID} app_id - app_id
 * @property {string} app_plan_id - plan id of app
 * @property {GUID} msid - site id
 * @property {GUID} instance_id - app and msid guid - instance_id
 * @property {number} sum - sum of $
 * @return {LogObject<thirdPartyAppsBiRefundExternalParams>} LogObject<thirdPartyAppsBiRefundExternalParams>
 */
export function thirdPartyAppsBiRefundExternal(params) {
    return { evid: 1506, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdyPartyAppsBiBusinessSetupCompleted' event (evid: 1507)
 *
 * Event description: the "ready" part, from the 3rd party app side is reay. (e.g - A hotel is set for wix hotels).
 * This does not include the Wix Part of being ready (premium, publish site, ready for payments, connected domain etc)
 *
 * @param {thirdyPartyAppsBiBusinessSetupCompletedParams} params - The parameters for this event
 * @property {string} event_data - event_data
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id
 * @return {LogObject<thirdyPartyAppsBiBusinessSetupCompletedParams>} LogObject<thirdyPartyAppsBiBusinessSetupCompletedParams>
 */
export function thirdyPartyAppsBiBusinessSetupCompleted(params) {
    return { evid: 1507, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiCodeUpdated' event (evid: 1508)
 *
 * Event description: The developer made changes to the code of the app. The event is used to trigger automation QA tests.
 *
 * @param {thirdPartyAppsBiCodeUpdatedParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<thirdPartyAppsBiCodeUpdatedParams>} LogObject<thirdPartyAppsBiCodeUpdatedParams>
 */
export function thirdPartyAppsBiCodeUpdated(params) {
    return { evid: 1508, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketToastClickOnCta' event (evid: 151)
 *
 * Event description: AppMarket - Toast Click on CTA.
 *
 * @param {appMarketToastClickOnCtaParams} params - The parameters for this event
 * @property {string} market - dashboard, editor etc
 * @property {string} action_cta - action required
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - editor session id
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketToastClickOnCtaParams>} LogObject<appMarketToastClickOnCtaParams>
 */
export function appMarketToastClickOnCta(params) {
    return { evid: 151, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketToastClosedX' event (evid: 152)
 *
 * Event description: user closes the toast presented
 *
 * @param {appMarketToastClosedXParams} params - The parameters for this event
 * @property {string} market - dashboard, editor etc
 * @property {string} action_cta - action required
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketToastClosedXParams>} LogObject<appMarketToastClosedXParams>
 */
export function appMarketToastClosedX(params) {
    return { evid: 152, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketInContextAppPageSeeFullDescription' event (evid: 153)
 *
 * Event description: click on 'see full description' button (in context modal)
 *
 * @param {appMarketInContextAppPageSeeFullDescriptionParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} uuid - uuid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - section that referred this
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @return {LogObject<appMarketInContextAppPageSeeFullDescriptionParams>} LogObject<appMarketInContextAppPageSeeFullDescriptionParams>
 */
export function appMarketInContextAppPageSeeFullDescription(params) {
    return { evid: 153, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketClickOnFreeTrialCta' event (evid: 154)
 *
 * Event description: Click on 'Free Trial' in the Manage Apps page or App page to get to an app package picker (start free trial checkout flow)
 *
 * @param {appMarketClickOnFreeTrialCtaParams} params - The parameters for this event
 * @property {string} market - editor/dashboard/standalone/etc.
 * @property {GUID} appInstanceId - app instance id
 * @property {GUID} appId - app id
 * @property {GUID} msid - msid
 * @property {string} origin - manage-apps/app-page
 *
 * @property {string} badge_name - in case the upgrade is from the app page report an array with all the badge names that appear in the app box separated by commas, f.e: premium_benefit, wix_choice, wix_sale, dev_sale.
 * in case the upgrade is from manage apps report the wix_sale/dev_sale when a sale badgae is appear near the upgrade CTA.
 * otherwise null.
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketClickOnFreeTrialCtaParams>} LogObject<appMarketClickOnFreeTrialCtaParams>
 */
export function appMarketClickOnFreeTrialCta(params) {
    return { evid: 154, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpgradeStartFreeTrialImpressionInTheManageAppsPageSrc24Evid156' event (evid: 156)
 *
 * Event description: In the Manage Apps tab, when user is exposed to an Upgrade/start free trial CTA
 *
 * @param {appMarketUpgradeStartFreeTrialImpressionInTheManageAppsPageSrc24Evid156Params} params - The parameters for this event
 * @property {string} market - dashboard/ editor/ standalone/etc.
 * @property {string} action_cta - cta action (upgrade/start free trial)
 * @property {GUID} appId - app_id
 * @property {GUID} msid - msid
 * @property {GUID} app_instance_id - the unique combination for msid+app_id
 * @property {string} badge_name - in case the upgrade is from the app page report an array with all the badge names that appear in the app box separated by commas, f.e: premium_benefit, wix_choice, wix_sale, dev_sale.
 * in case the upgrade is from manage apps report the wix_sale/dev_sale when a sale badge is appear near the upgrade CTA.
 * otherwise null.
 *
 * @property {number} sale - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 *
 * @return {LogObject<appMarketUpgradeStartFreeTrialImpressionInTheManageAppsPageSrc24Evid156Params>} LogObject<appMarketUpgradeStartFreeTrialImpressionInTheManageAppsPageSrc24Evid156Params>
 */
export function appMarketUpgradeStartFreeTrialImpressionInTheManageAppsPageSrc24Evid156(params) {
    return { evid: 156, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMArketPackagePickerClickOnSelectPlanSrc24Evid157' event (evid: 157)
 *
 * Event description: The event is triggered when a user clicks on 'select plan' to get to the cycle choosing page
 *
 * @param {appMArketPackagePickerClickOnSelectPlanSrc24Evid157Params} params - The parameters for this event
 * @property {string} pp_origin - pp_origin {settings,GFPP,BM}
 * @property {string} package_id - the package id
 * @property {string} market - source of click for upgrade (editor, dashboard)
 * @property {string} package_name - the package name the string itself
 * @property {GUID} app_id - app_id
 * @property {string} app_plan_id - plan_id of app
 * @property {string} flow_type - upgrade/free trial/downgrade
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {boolean} is_benefit - True if the selected plan is an app benefit
 * @property {number} sale_discount - the sale discount in precentages, f.e: 20 equal to 20%.
 * @property {string} sale_name - sale name
 * @return {LogObject<appMArketPackagePickerClickOnSelectPlanSrc24Evid157Params>} LogObject<appMArketPackagePickerClickOnSelectPlanSrc24Evid157Params>
 */
export function appMArketPackagePickerClickOnSelectPlanSrc24Evid157(params) {
    return { evid: 157, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMArketPackagePickerClickOnSelectPlanSrc24Evid158' event (evid: 158)
 *
 * Event description: The event is triggered when the user clicks on 'continue to checkout' to get to the checkout page from the  cycle choosing page
 *
 * @param {appMArketPackagePickerClickOnSelectPlanSrc24Evid158Params} params - The parameters for this event
 * @property {string} pp_origin - pp_origin {settings,GFPP,BM}
 * @property {string} package_id - the package id
 * @property {string} market - source of click for upgrade (editor, dashboard)
 * @property {string} package_name - the package name the string itself
 * @property {GUID} app_id - app_id
 * @property {string} app_plan_id - plan_id of app
 * @property {string} flow_type - upgrade/free trial/downgrade
 * @property {GUID} msid - msid
 * @property {GUID} app_instance_id - unique combination of msid+app_id
 * @property {boolean} is_benefit - True if the selected plan is an app benefit
 * @property {string} sale_name - wix sale or dev sale
 * @property {number} sale_discount - If sale exists report the sale discount (f.e: 20), otherwise null.
 * @return {LogObject<appMArketPackagePickerClickOnSelectPlanSrc24Evid158Params>} LogObject<appMArketPackagePickerClickOnSelectPlanSrc24Evid158Params>
 */
export function appMArketPackagePickerClickOnSelectPlanSrc24Evid158(params) {
    return { evid: 158, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159' event (evid: 159)
 *
 * Event description: User clicks on a Category/Sub-Category label from the App Page, to get to the relevant Category/Sub-Category page.
 *
 * @param {appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159Params} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} category_name - name of category label
 * @property {string} app_page_location - from which location in the app page the user click on the category/sub category  - top page / side category section
 * @property {GUID} msid - msid
 * @property {string} subcategory_name - the sub_category name if the label was clicked is sub_category
 * @property {string} label_type - category / sub_category
 * @property {GUID} app_id - The app_id of the app page the click was made from
 * @return {LogObject<appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159Params>} LogObject<appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159Params>
 */
export function appMarketCategorySubCategoryClickFromTheAppPageSrc24Evid159(params) {
    return { evid: 159, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketReviewImpression' event (evid: 160)
 *
 * Event description: reviews impression- review impressions are visible in the app page.
 *
 * @param {appMarketReviewImpressionParams} params - The parameters for this event
 * @property {string} referral_name - home page, collections,  category...
 * @property {string} market - dashboard, editor, standalone
 * @property {GUID} collimp_id - collection impression id (guid)
 * @property {string} referral_info - what is the referral that referred to the app page
 * @property {number} reviewsScore - review score: 1-5
 * @property {boolean} dev_comment - did the developer commented on the review?
 * @property {string} slug_id - id of consistent set of apps
 * @property {number} review_index - the index of the review: 0 is the first review that will shown in the app page
 * @property {string} vertical - vertical
 * @property {string} tag_type - app page...
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {string} review_body - the body of the review, what was written
 * @property {GUID} msid - msid
 * @property {string} tag_name - what is the specific tag from the specific app page
 * @property {string} referral_tag_name - what is the tag_name that referred to this install
 * @return {LogObject<appMarketReviewImpressionParams>} LogObject<appMarketReviewImpressionParams>
 */
export function appMarketReviewImpression(params) {
    return { evid: 160, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppsInContextModalIsShownSrc24Evid161' event (evid: 161)
 *
 * Event description: When the Apps Modal In Context is shown -  when Apps In Context are presented in the Backoffice on a modal
 *
 * @param {appMarketAppsInContextModalIsShownSrc24Evid161Params} params - The parameters for this event
 * @property {string} title - he title that appears in the modal (only in English)
 * @property {string} sub_title - the sub title that appears in the modal (only in English)
 * @property {string} referral_info - the referral info when the apps modal is shown (the last parameter in the URL)
 * @property {number} loading_time - the modal loading time (the time since the call to open the modal until the apps in the modal is shown)
 * @property {string} origin - the origin will be the project/area calling to app market component
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @return {LogObject<appMarketAppsInContextModalIsShownSrc24Evid161Params>} LogObject<appMarketAppsInContextModalIsShownSrc24Evid161Params>
 */
export function appMarketAppsInContextModalIsShownSrc24Evid161(params) {
    return { evid: 161, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketClickOnExploreMoreAppsCtaInTheAppsInContextModalSrc24Evid162' event (evid: 162)
 *
 * Event description: When user is clicking on 'Explore More Apps' CTA in the Apss in context modal to get to the App Market
 *
 * @param {appMarketClickOnExploreMoreAppsCtaInTheAppsInContextModalSrc24Evid162Params} params - The parameters for this event
 * @property {string} title - he title that appears in the modal (only in English)
 * @property {string} sub_title - the sub title that appears in the modal (only in English)
 * @property {string} referral_info - the referral info when the apps modal is shown (the last parameter in the URL)
 * @property {string} origin - the origin will be the project/area calling to app market component
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @return {LogObject<appMarketClickOnExploreMoreAppsCtaInTheAppsInContextModalSrc24Evid162Params>} LogObject<appMarketClickOnExploreMoreAppsCtaInTheAppsInContextModalSrc24Evid162Params>
 */
export function appMarketClickOnExploreMoreAppsCtaInTheAppsInContextModalSrc24Evid162(params) {
    return { evid: 162, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketPageStartLoadedSrc24Evid163' event (evid: 163)
 *
 * Event description: Every page opened in the App Market will trigger this event.
 *
 * @param {appMarketPageStartLoadedSrc24Evid163Params} params - The parameters for this event
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} referral_info - referral_info (correct, no typo)
 * @property {boolean} in_context_view - bool
 * @property {string} sub_tag_name - sub tag . e.g. sub-categories
 * @property {string} app_id - if app page opened, app_id. Else = null
 * @property {string} tag_type - tag type - collection, category
 * @property {string} refferal_info - refferal_info - is typo
 * @property {GUID} msid - msid
 * @property {string} tag_name - the name of the tag type (if collection - must have apps, free apps etc. if category - music, video , business etc)
 * @property {string} referral_tag_type - previous page type
 * @property {string} referral_tag_name - what is the tag_name that referred to this page
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} origin - relevant only to apps in context otherwise will be null. the origin will be the project/area calling to app market component.
 *
 * @return {LogObject<appMarketPageStartLoadedSrc24Evid163Params>} LogObject<appMarketPageStartLoadedSrc24Evid163Params>
 */
export function appMarketPageStartLoadedSrc24Evid163(params) {
    return { evid: 163, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDashboardWidgetExploreMoreAppsClick' event (evid: 165)
 *
 * Event description: User clicks on explore more apps in the business manager widget panel.
 *
 * @param {appMarketDashboardWidgetExploreMoreAppsClickParams} params - The parameters for this event
 * @property {string} marketVersion - if new market = 'new' else null
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketDashboardWidgetExploreMoreAppsClickParams>} LogObject<appMarketDashboardWidgetExploreMoreAppsClickParams>
 */
export function appMarketDashboardWidgetExploreMoreAppsClick(params) {
    return { evid: 165, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSearchResultsPageEmptyStateIsShownSrc24Evid166' event (evid: 166)
 *
 * Event description: triggered when the search results page empty state is shown
 *
 * @param {appMarketSearchResultsPageEmptyStateIsShownSrc24Evid166Params} params - The parameters for this event
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} referral_info - referral_info (correct, no typo)
 * @property {string} search_term - search_term used to get here
 * @property {string} tag_type - search_results
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSearchResultsPageEmptyStateIsShownSrc24Evid166Params>} LogObject<appMarketSearchResultsPageEmptyStateIsShownSrc24Evid166Params>
 */
export function appMarketSearchResultsPageEmptyStateIsShownSrc24Evid166(params) {
    return { evid: 166, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketClickOnSaleFilterSrc24Evid167' event (evid: 167)
 *
 * Event description: When a user click on Apps on sale/ all apps filter (filter at the top of the AppMarket page)
 *
 * @param {appMarketClickOnSaleFilterSrc24Evid167Params} params - The parameters for this event
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} tag_name - the name of the tag type (if collection - must have apps, free apps etc. if category - music, video , business etc)
 * @property {string} tag_type - tag type - collection, category
 * @property {string} msid - msid
 * @property {string} filter_value - all apps/apps on sale
 * @return {LogObject<appMarketClickOnSaleFilterSrc24Evid167Params>} LogObject<appMarketClickOnSaleFilterSrc24Evid167Params>
 */
export function appMarketClickOnSaleFilterSrc24Evid167(params) {
    return { evid: 167, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketTerminatorLearnHowClick' event (evid: 169)
 *
 * Event description: When user clicks on 'learn how' after terminator box suggested a feature outside of app market.
 *
 * @param {appMarketTerminatorLearnHowClickParams} params - The parameters for this event
 * @property {string} experiment_name - what is the subject / name of experiment
 * @property {string} market - market (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - the keyword that was searched
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketTerminatorLearnHowClickParams>} LogObject<appMarketTerminatorLearnHowClickParams>
 */
export function appMarketTerminatorLearnHowClick(params) {
    return { evid: 169, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageClickOnReviewsNumber' event (evid: 170)
 *
 * Event description: App Market - App Page - Click on Reviews Number
 *
 * @param {appMarketAppPageClickOnReviewsNumberParams} params - The parameters for this event
 * @property {string} market - editor, dashboard, standalone
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid of site
 * @property {string} tag_name - name of the tag
 * @return {LogObject<appMarketAppPageClickOnReviewsNumberParams>} LogObject<appMarketAppPageClickOnReviewsNumberParams>
 */
export function appMarketAppPageClickOnReviewsNumber(params) {
    return { evid: 170, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketOauthTokenReceivedInstall' event (evid: 1700)
 *
 * Event description: Token Received from Oauth Install
 *
 * @param {appMarketOauthTokenReceivedInstallParams} params - The parameters for this event
 * @property {GUID} app_instance_id - instance_id
 * @property {string} http_method - get or post
 * @property {GUID} app_id - app id
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketOauthTokenReceivedInstallParams>} LogObject<appMarketOauthTokenReceivedInstallParams>
 */
export function appMarketOauthTokenReceivedInstall(params) {
    return { evid: 1700, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageReadMoreReviewsClick' event (evid: 171)
 *
 * Event description: App Market - App Page - Click on Reviews Number
 *
 * @param {appMarketAppPageReadMoreReviewsClickParams} params - The parameters for this event
 * @property {string} market - editor, dashboard, standalone
 * @property {string} marketVersion - new
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid of site
 * @property {string} tag_name - name of the tag
 * @property {string} click_type - click type =  [‘reviews’, ‘user_review’, ‘company_comment’]
 * @return {LogObject<appMarketAppPageReadMoreReviewsClickParams>} LogObject<appMarketAppPageReadMoreReviewsClickParams>
 */
export function appMarketAppPageReadMoreReviewsClick(params) {
    return { evid: 171, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageAppRequirementClick' event (evid: 172)
 *
 * Event description: App Market - App Page - Click on Reviews Number
 *
 * @param {appMarketAppPageAppRequirementClickParams} params - The parameters for this event
 * @property {string} market - editor, dashboard, standalone
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid of site
 * @property {string} tag_name - name of the tag
 * @property {string} action - other countries, 'site requirement'
 * @return {LogObject<appMarketAppPageAppRequirementClickParams>} LogObject<appMarketAppPageAppRequirementClickParams>
 */
export function appMarketAppPageAppRequirementClick(params) {
    return { evid: 172, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageAppGalleryClick' event (evid: 173)
 *
 * Event description: App Market - App Page - Click on Reviews Number
 *
 * @param {appMarketAppPageAppGalleryClickParams} params - The parameters for this event
 * @property {string} market - editor, dashboard, standalone
 * @property {string} marketVersion - new
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid of site
 * @property {string} tag_name - name of the tag
 * @property {string} action - right, left, dot (dot is the click in the middle bottom to choose specific image, for now is not being sent)
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {boolean} in_context_view - true if the app page view is through “in context”, otherwise false
 * @return {LogObject<appMarketAppPageAppGalleryClickParams>} LogObject<appMarketAppPageAppGalleryClickParams>
 */
export function appMarketAppPageAppGalleryClick(params) {
    return { evid: 173, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketInContextAppPageSeeFullDescriptionSrc24Evid174' event (evid: 174)
 *
 * Event description: click on 'see full description' button (in context modal)
 *
 * @param {appMarketInContextAppPageSeeFullDescriptionSrc24Evid174Params} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} uuid - uuid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - section that referred this
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketInContextAppPageSeeFullDescriptionSrc24Evid174Params>} LogObject<appMarketInContextAppPageSeeFullDescriptionSrc24Evid174Params>
 */
export function appMarketInContextAppPageSeeFullDescriptionSrc24Evid174(params) {
    return { evid: 174, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleBannerImpressionWebMobile' event (evid: 175)
 *
 * Event description: User viewed the sale banner (in Manage Apps page or in one of the App Market pages)
 *
 * @param {appMarketSaleBannerImpressionWebMobileParams} params - The parameters for this event
 * @property {string} market - standalone etc.
 * @property {string} sale_name - f.e: nov-24
 * @property {string} tag_type - page name where the banner appeared
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSaleBannerImpressionWebMobileParams>} LogObject<appMarketSaleBannerImpressionWebMobileParams>
 */
export function appMarketSaleBannerImpressionWebMobile(params) {
    return { evid: 175, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSortingAppsClick' event (evid: 176)
 *
 * Event description: Triggers when user clicks on the sorting button of the page
 *
 * @param {appMarketSortingAppsClickParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {string} sort_type - sorting type (discount descending, discount ascending etc.)
 * @property {string} vertical - vertical
 * @property {string} tag_type - current page name
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSortingAppsClickParams>} LogObject<appMarketSortingAppsClickParams>
 */
export function appMarketSortingAppsClick(params) {
    return { evid: 176, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketEditorRedirectModal' event (evid: 177)
 *
 * Event description: User is shown the redirect to editor modal
 *
 * @param {appMarketEditorRedirectModalParams} params - The parameters for this event
 * @property {number} num_of_permissions - number of permissions requested by the installer
 * @property {string} market - editor, dashboard market?
 * @property {string} referral_info - referral_info
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {string} flow_type - consent or update_app_version
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketEditorRedirectModalParams>} LogObject<appMarketEditorRedirectModalParams>
 */
export function appMarketEditorRedirectModal(params) {
    return { evid: 177, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketEditorRedirectClick' event (evid: 178)
 *
 * Event description: when user is trying to update an editor component app from the BM , he will get this modal to ask him to move to Editor. clicking on action button will send this bi
 *
 * @param {appMarketEditorRedirectClickParams} params - The parameters for this event
 * @property {string} market - editor, dashboard market?
 * @property {string} referral_info - referral_info
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {string} flow_type - consent or update_app_version
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketEditorRedirectClickParams>} LogObject<appMarketEditorRedirectClickParams>
 */
export function appMarketEditorRedirectClick(params) {
    return { evid: 178, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateSuccess' event (evid: 179)
 *
 * Event description: The update was successful (according to the server)
 *
 * @param {appMarketUpdateSuccessParams} params - The parameters for this event
 * @property {string} market - editor, dashboard market?
 * @property {string} referral_info - referral_info
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketUpdateSuccessParams>} LogObject<appMarketUpdateSuccessParams>
 */
export function appMarketUpdateSuccess(params) {
    return { evid: 179, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateSuccessMessageModalOpened' event (evid: 180)
 *
 * Event description: The update success modal shown
 *
 * @param {appMarketUpdateSuccessMessageModalOpenedParams} params - The parameters for this event
 * @property {string} market - editor, dashboard market?
 * @property {string} referral_info - referral_info
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketUpdateSuccessMessageModalOpenedParams>} LogObject<appMarketUpdateSuccessMessageModalOpenedParams>
 */
export function appMarketUpdateSuccessMessageModalOpened(params) {
    return { evid: 180, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appStartedUsingPendingConfiguration' event (evid: 1800)
 *
 * Event description: App sent the first APP_FINISHED_CONFIGURATION BI event
 *
 * @param {appStartedUsingPendingConfigurationParams} params - The parameters for this event
 * @property {string} version - app version that started sending Pending Configuration BI
 * @property {GUID} app_id - app identifier
 * @return {LogObject<appStartedUsingPendingConfigurationParams>} LogObject<appStartedUsingPendingConfigurationParams>
 */
export function appStartedUsingPendingConfiguration(params) {
    return { evid: 1800, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pendingInstallationWasCompleted' event (evid: 1801)
 *
 * Event description: Pending installation with pendingReason field
 * (For installation count, pendingReason = EDITOR)
 *
 * @param {pendingInstallationWasCompletedParams} params - The parameters for this event
 * @property {string} pendingReason - the reason the installation was pending
 * @property {string} version - app version that started sending Pending Configuration BI
 * @property {GUID} appId - app identifier
 * @property {GUID} msid - msid
 * @return {LogObject<pendingInstallationWasCompletedParams>} LogObject<pendingInstallationWasCompletedParams>
 */
export function pendingInstallationWasCompleted(params) {
    return { evid: 1801, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pendingInstallationDeleted' event (evid: 1802)
 *
 * Event description: User deleted a pending app
 *
 * @param {pendingInstallationDeletedParams} params - The parameters for this event
 * @property {string} pendingReason - the reason the installation was pending
 * @property {string} version - app version that started sending Pending Configuration BI
 * @property {GUID} appId - identifier
 * @property {GUID} msid - msid
 * @return {LogObject<pendingInstallationDeletedParams>} LogObject<pendingInstallationDeletedParams>
 */
export function pendingInstallationDeleted(params) {
    return { evid: 1802, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpdateSuccessNotification' event (evid: 181)
 *
 * Event description: The update success notification shown in editor
 *
 * @param {appMarketUpdateSuccessNotificationParams} params - The parameters for this event
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketUpdateSuccessNotificationParams>} LogObject<appMarketUpdateSuccessNotificationParams>
 */
export function appMarketUpdateSuccessNotification(params) {
    return { evid: 181, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOneTimePublishHelperPopupIsColsedSrc24Evid182' event (evid: 182)
 *
 * Event description: When the "one time publish helper" popup is closed
 *
 * @param {devCenterOneTimePublishHelperPopupIsColsedSrc24Evid182Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} page_name - the page where the popup is shown
 * @property {string} action_required - submit/publish (the action the user need to perform in order to save the changes)
 * @property {boolean} is_dont_show_checked - True if the ‘don’t show again’ box is checked, otherwise false.
 * @return {LogObject<devCenterOneTimePublishHelperPopupIsColsedSrc24Evid182Params>} LogObject<devCenterOneTimePublishHelperPopupIsColsedSrc24Evid182Params>
 */
export function devCenterOneTimePublishHelperPopupIsColsedSrc24Evid182(params) {
    return { evid: 182, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterApprovePublishModalIsShownSrc24Evid183' event (evid: 183)
 *
 * Event description: when the published modal is shown (ask the user to approve the publish)
 *
 * @param {devCenterApprovePublishModalIsShownSrc24Evid183Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} fields_updated - fields_updated - the fields the user updated and save separeted by commas. For example: app name,teaser,feature 1
 * @property {string} sections_updated - the sections the user updated and save separated by commas, For example: basic information,app icon,overview
 * @property {string} page_name - the page the user made changes in
 * @return {LogObject<devCenterApprovePublishModalIsShownSrc24Evid183Params>} LogObject<devCenterApprovePublishModalIsShownSrc24Evid183Params>
 */
export function devCenterApprovePublishModalIsShownSrc24Evid183(params) {
    return { evid: 183, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterClickToApprovePublishInThePublishedModalSrc24Evid184' event (evid: 184)
 *
 * Event description: When the user click on 'Publish' in the publish modal to approve the publishing
 *
 * @param {devCenterClickToApprovePublishInThePublishedModalSrc24Evid184Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} fields_updated -  the fields the user updated and save separeted by commas. For example: app name,teaser,feature 1
 * @property {string} sections_updated - the sections the user updated and save separated by commas, For example: basic information,app icon,overview
 * @property {string} page_name - the page the user made changes in
 * @return {LogObject<devCenterClickToApprovePublishInThePublishedModalSrc24Evid184Params>} LogObject<devCenterClickToApprovePublishInThePublishedModalSrc24Evid184Params>
 */
export function devCenterClickToApprovePublishInThePublishedModalSrc24Evid184(params) {
    return { evid: 184, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixOfferingBoxAction' event (evid: 1849)
 *
 * Event description: Wix offering is shown/clicked on
 *
 * @param {wixOfferingBoxActionParams} params - The parameters for this event
 * @property {string} market - editor/ dashboard
 * @property {string} offering_name - wix offering name (e.g - multilingual)
 * @property {string} referral_info - search_bar, search_results_page
 * @property {string} search_term - search term used to get to the result page
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id of the wix offering
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid of site
 * @property {string} action_type - impression or click
 * @return {LogObject<wixOfferingBoxActionParams>} LogObject<wixOfferingBoxActionParams>
 */
export function wixOfferingBoxAction(params) {
    return { evid: 1849, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCategoryClickSrc24Evid185' event (evid: 185)
 *
 * Event description: User clicks on the main category cta, for example on the sub-category page
 *
 * @param {appMarketCategoryClickSrc24Evid185Params} params - The parameters for this event
 * @property {string} app_id - app_id
 * @property {string} uuid - uuid
 * @property {string} msid - msid
 * @property {string} market - dashboard, editor, standalone
 * @property {string} tag_type - collection, category, homepage, app_page, search-result
 * @property {string} tag_name - for example, the name of the category
 * @property {string} sub_tag_name - the name of the sub-category
 * @return {LogObject<appMarketCategoryClickSrc24Evid185Params>} LogObject<appMarketCategoryClickSrc24Evid185Params>
 */
export function appMarketCategoryClickSrc24Evid185(params) {
    return { evid: 185, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketOpenThirdPartyAppBackOffice' event (evid: 1850)
 *
 * Event description: Open the App Backoffice from e-container modal.
 *
 * @param {appMarketOpenThirdPartyAppBackOfficeParams} params - The parameters for this event
 * @property {string} market - dashboard, editor... etc
 * @property {boolean} is_pending_install - is the app in a pending install state?
 * @property {string} referral_info - where was the app referred from? (last page)
 * @property {string} page_name - name of page opened
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketOpenThirdPartyAppBackOfficeParams>} LogObject<appMarketOpenThirdPartyAppBackOfficeParams>
 */
export function appMarketOpenThirdPartyAppBackOffice(params) {
    return { evid: 1850, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketHoverApp' event (evid: 1852)
 *
 * Event description: When the user hovers over an app
 *
 * @param {appMarketHoverAppParams} params - The parameters for this event
 * @property {string} market - market type - editor, dashboard, standalone
 * @property {string} impression_type - type the of app (app box, search suggestion etc)
 * @property {string} app_subcategory - if app was shown in a category page where sub category was selected - name the sub category.
 * @property {number} section_index - from top = 0, to last = 0+n. what is the ranking order of the section presented?
 * @property {string} section - section in which app box is located
 * @property {GUID} impression_id - impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} badge_name - name of badge of app box (e.g - Premium Benefit)
 * @property {string} search_term - search_term used to expose this app
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {string} tag_type - the page type
 * @property {GUID} esi - -
 * @property {GUID} msid - msid
 * @property {string} tag_name - the page type name: for category - the category name, for app page - the app name, etc.
 * @property {number} index - The listing ranking of the number in the presented page.
 * @return {LogObject<appMarketHoverAppParams>} LogObject<appMarketHoverAppParams>
 */
export function appMarketHoverApp(params) {
    return { evid: 1852, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageOneDependencyImpression' event (evid: 1853)
 *
 * Event description: app page one dependency impression
 *
 * @param {appMarketAppPageOneDependencyImpressionParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} dependency_type - app\ geo\ language
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {string} type - one, multiple, pending
 * @property {GUID} esi - esi
 * @property {string} refferal_info - referral_info
 * @property {string} app_dependency - app_dependency
 * @return {LogObject<appMarketAppPageOneDependencyImpressionParams>} LogObject<appMarketAppPageOneDependencyImpressionParams>
 */
export function appMarketAppPageOneDependencyImpression(params) {
    return { evid: 1853, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageOneDependencyClick' event (evid: 1854)
 *
 * Event description: app page one dependency click
 *
 * @param {appMarketAppPageOneDependencyClickParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} dependency_type - app\ geo\ language
 * @property {string} click_type - go to editor\ app
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {string} type - one, multiple, pending
 * @property {GUID} esi - esi
 * @property {string} refferal_info - referral_info
 * @property {string} app_dependency - app dependency id
 * @return {LogObject<appMarketAppPageOneDependencyClickParams>} LogObject<appMarketAppPageOneDependencyClickParams>
 */
export function appMarketAppPageOneDependencyClick(params) {
    return { evid: 1854, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketNotInUseAppPageMultipleDependencyImpression' event (evid: 1855)
 *
 * Event description: app page multiple dependency impression
 *
 * @param {appMarketNotInUseAppPageMultipleDependencyImpressionParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} vertical - vertical
 * @property {string} apps_dependency - app dependency ids
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {string} refferal_info - referral_info
 * @return {LogObject<appMarketNotInUseAppPageMultipleDependencyImpressionParams>} LogObject<appMarketNotInUseAppPageMultipleDependencyImpressionParams>
 */
export function appMarketNotInUseAppPageMultipleDependencyImpression(params) {
    return { evid: 1855, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageMultipleDependencyClick' event (evid: 1856)
 *
 * Event description: app page multiple dependency click
 *
 * @param {appMarketAppPageMultipleDependencyClickParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} vertical - vertical
 * @property {string} apps_dependency - app dependency ids
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {string} app_clicked - app_clicked - app_id
 * @property {string} refferal_info - referral_info
 * @return {LogObject<appMarketAppPageMultipleDependencyClickParams>} LogObject<appMarketAppPageMultipleDependencyClickParams>
 */
export function appMarketAppPageMultipleDependencyClick(params) {
    return { evid: 1856, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketHomepageAppDependencyAction' event (evid: 1857)
 *
 * Event description: homepage app dependency action
 *
 * @param {appMarketHomepageAppDependencyActionParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} app_to_return - app_to_return app id
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} vertical - vertical
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {string} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {string} refferal_info - referral_info
 * @property {string} action_type - impression\ click
 * @return {LogObject<appMarketHomepageAppDependencyActionParams>} LogObject<appMarketHomepageAppDependencyActionParams>
 */
export function appMarketHomepageAppDependencyAction(params) {
    return { evid: 1857, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAddAppDisableHover' event (evid: 1858)
 *
 * Event description: disable hover and message shows
 *
 * @param {appMarketAddAppDisableHoverParams} params - The parameters for this event
 * @property {string} require_type - the unfulfilled requirement (same as prompt message) , 'null' if all fulfilled
 * @property {string} navigation_source - e.g. top-search
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {string} all_requirements_filled - yes/no/no-requirements
 * @property {string} referral_sub_tag_name - e.g. sub category name
 * @property {string} section_name - name of section's title presented
 * @property {string} click_location - 'main_cta' or 'sticky_header'
 * @property {string} widget_referral - is flow referred from widget
 * @property {string} widget_name - when trying to add an app, if app the inside a widget - what is the widget name. else null
 * @property {GUID} uuid - uuid
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {number} section_index - from top = 0, to last = 0+n. what is the ranking order of the section presented?
 * @property {boolean} in_context_view - bool
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} referral_section_name - section that referred this
 * @property {string} category - Every app belongs to one category. which one is the app category of this app?
 * @property {GUID} app_id - app_id
 * @property {string} pageType - Type of page used when add app was clicked ( Homepage, App page, Developer page , collection page etc)
 * @property {string} tag_type - type of page opened - category, homepage, app page etc
 * @property {boolean} is_app_dependency - true\false
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag ('must have apps' , 'music' etc)
 * @property {string} referral_tag_type - previous page type
 * @property {number} index - The listing ranking of the number in the presented page.
 * @return {LogObject<appMarketAddAppDisableHoverParams>} LogObject<appMarketAddAppDisableHoverParams>
 */
export function appMarketAddAppDisableHover(params) {
    return { evid: 1858, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageClick' event (evid: 1859)
 *
 * Event description: User clicks on a CTA in the app page.
 *
 * @param {appMarketAppPageClickParams} params - The parameters for this event
 * @property {string} location - overview
 * @property {string} market - market
 * @property {Url} url - url of external link
 * @property {GUID} uuid - uuid
 * @property {string} vertical - vertical
 * @property {string} cta - company_name, read_more, read_less
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} value - the specific value of the cta
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @return {LogObject<appMarketAppPageClickParams>} LogObject<appMarketAppPageClickParams>
 */
export function appMarketAppPageClick(params) {
    return { evid: 1859, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketHoverOverSidebarItemSrc24Evid186' event (evid: 186)
 *
 * Event description: Triggered when a user hover over one of the items in the app market sidebar
 *
 * @param {appMarketHoverOverSidebarItemSrc24Evid186Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} market - editor, dashboard, standalone
 * @property {string} menu_item_label - the name of the item
 * @property {number} index - index of label in menu
 * @property {string} item_type - The type of the item hovered in the sidebar. Values: ‘home’, ‘collection’, ‘category’, ‘manage_apps’
 * @property {string} item_section - The section of the item hovered in the sidebar. Values: ‘Explore’, ‘Apps to Help You’, ‘Categories’, else null.
 * @property {string} page_type - The type of the page that the user is on when hovering on one of the sidebar items.
 * @property {string} page_name - The name of the page that the user is on when hovering on one of the sidebar items.
 * @return {LogObject<appMarketHoverOverSidebarItemSrc24Evid186Params>} LogObject<appMarketHoverOverSidebarItemSrc24Evid186Params>
 */
export function appMarketHoverOverSidebarItemSrc24Evid186(params) {
    return { evid: 186, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppPageHover' event (evid: 1860)
 *
 * Event description: User Hovers in the app page
 *
 * @param {appMarketAppPageHoverParams} params - The parameters for this event
 * @property {string} location - the location of the hover
 * @property {string} market - market
 * @property {GUID} uuid - uuid
 * @property {string} hover_type - availability, app_languages, site_requirments, other_countries
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @return {LogObject<appMarketAppPageHoverParams>} LogObject<appMarketAppPageHoverParams>
 */
export function appMarketAppPageHover(params) {
    return { evid: 1860, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleBannerClickSrc24Evid188' event (evid: 188)
 *
 * Event description: user is clicking on the sale banner (in Manage Apps page or in one of the App Market pages)
 *
 * @param {appMarketSaleBannerClickSrc24Evid188Params} params - The parameters for this event
 * @property {string} market - standalone etc.
 * @property {string} sale_name - f.e: nov-24
 * @property {string} tag_type - page name where the banner appeared
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSaleBannerClickSrc24Evid188Params>} LogObject<appMarketSaleBannerClickSrc24Evid188Params>
 */
export function appMarketSaleBannerClickSrc24Evid188(params) {
    return { evid: 188, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketManageAppsHoverOnSaleBadgeSrc24Evid189' event (evid: 189)
 *
 * Event description: In the Manage Apps tab, when user is hover on a sale badge for an app with action required
 *
 * @param {appMarketManageAppsHoverOnSaleBadgeSrc24Evid189Params} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {number} sale_discount - If the app is on sale and the sale badge appears, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketManageAppsHoverOnSaleBadgeSrc24Evid189Params>} LogObject<appMarketManageAppsHoverOnSaleBadgeSrc24Evid189Params>
 */
export function appMarketManageAppsHoverOnSaleBadgeSrc24Evid189(params) {
    return { evid: 189, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'thirdPartyAppsBiExternalBillingAppTransactionWasProcessedSrc24Evid191' event (evid: 191)
 *
 * Event description: When a transaction was processed via an external billing app
 *
 * @param {thirdPartyAppsBiExternalBillingAppTransactionWasProcessedSrc24Evid191Params} params - The parameters for this event
 * @property {GUID} app_instance_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {number} wix_share - The total amount representing Wix's share of the transaction (USD)
 * @property {string} type - the transaction type, 1 of 2 values: CHARGE/REFUND
 * @property {string} gross_revenue - The amount of money the app was charged, excluding sales tax.
 * @property {string} net_revenue - The amount of money charged, minus agreed upon expenses (e.g., shipping fees for print on demand or shipping apps, etc.)
 * @property {string} transaction_date_created - the transaction date created, reported by the app owner
 * @return {LogObject<thirdPartyAppsBiExternalBillingAppTransactionWasProcessedSrc24Evid191Params>} LogObject<thirdPartyAppsBiExternalBillingAppTransactionWasProcessedSrc24Evid191Params>
 */
export function thirdPartyAppsBiExternalBillingAppTransactionWasProcessedSrc24Evid191(params) {
    return { evid: 191, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppInstallationSuccess' event (evid: 2)
 *
 * Event description: App Install was successful, Client BI for rich data.
 *
 * @param {appMarketAppInstallationSuccessParams} params - The parameters for this event
 * @property {string} navigation_source - e.g. top-search
 * @property {string} market - editor, dashboard, adi, add-panel
 * @property {string} app_subcategory - what is the app sub-category of the category
 * @property {string} referral_sub_tag_name - e.g. sub category name
 * @property {string} installation_source - installation_source
 * @property {string} widget_referral - is flow referred from widget
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info (correct, no typo)
 * @property {number} sum_one - value 1 for ttest sum
 * @property {number} referral_section_index - what is the index number of the app box that was clicked in previous page
 * @property {boolean} in_context_view - bool
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - Impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} marketVersion - version of app market
 * @property {string} search_term - word used for search term, led to search result, led to app page and install
 * @property {string} vertical - vertical
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} referral_section_name - what is the section name that was clicked in previous page
 * @property {GUID} app_id - app_id
 * @property {string} tag_type - what is the type of app tag? category, collection etc
 * @property {boolean} is_app_dependency - true\false
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - app instance id
 * @property {string} tag_name - what is the specific tag from which the app was installed from
 * @property {string} referral_tag_type - the previous page if referral_info contains something else
 * @property {string} version_of_app - app version
 * @property {number} index - app index number when presented
 * @property {string} referral_tag_name - what is the tag_name that referred to this install
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} badge_name - report an array with all the badge names that appeared in the app box separated by commas, f.e: premium_benefit, wix_choice
 * @property {string} click_location - 'app-page-cta' - app page regular cta location
 *
 * 'app-sticky-header-cta' - app page sticky header
 *
 * 'app-modal-footer-cta' - ‘in-context’ footer
 * @property {string} correlation_id - API correlation ID, generated during initialization. Use it to join with installer BI.
 * @property {number} app_review_count - total number of reviews in the installation moment
 * @property {number} app_review_score - the current app score at the installation moment. (multiplied by 100 due to format limitations). if No score, -1000 will be the score.
 * @property {string} origin - will be sent only in context. the origin will be the project/area calling to app market component (relevant only to apps in context otherwise will be null)
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @property {string} history_path - a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @property {string} last_page - the last page the user visited before he entered the app page.
 * will be reported only when the tag_type='app_page', otherwise null
 * @property {number} sale_discount -  sale_discount
 * If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appMarketAppInstallationSuccessParams>} LogObject<appMarketAppInstallationSuccessParams>
 */
export function appMarketAppInstallationSuccess(params) {
    return { evid: 2, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorPageLoaded' event (evid: 200)
 *
 * Event description: error page loaded
 *
 * @param {errorPageLoadedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {string} referral_info - referral_info
 * @property {GUID} msid - msid
 * @property {string} error_type - the type of the error, for example: 'not found page'
 * @property {string} previous_tag_type - the type of the page the user come from: category, search_results, homepage, app_page, etc.
 * @return {LogObject<errorPageLoadedParams>} LogObject<errorPageLoadedParams>
 */
export function errorPageLoaded(params) {
    return { evid: 200, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingPageActivateNewTrialSuccessNotificationSrc24Evid205' event (evid: 205)
 *
 * Event description: When the activate new trial success notifications is shown in the Pricing page in the DevCenter
 *
 * @param {pricingPageActivateNewTrialSuccessNotificationSrc24Evid205Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {number} free_trial_days - the days of trials as it appears while the user clicks on ‘activate new trial’
 * @property {string} business_model - the marked business model while the user click on the toggle
 * @return {LogObject<pricingPageActivateNewTrialSuccessNotificationSrc24Evid205Params>} LogObject<pricingPageActivateNewTrialSuccessNotificationSrc24Evid205Params>
 */
export function pricingPageActivateNewTrialSuccessNotificationSrc24Evid205(params) {
    return { evid: 205, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalOpenAppModalClick' event (evid: 21)
 *
 * Event description: User clicks on app cube to get more info
 *
 * @param {appModalOpenAppModalClickParams} params - The parameters for this event
 * @property {string} price_label_eng - Free, starting from 4 GBP / month
 * @property {string} navigation_source - from which navigation source was the click [home(homepage search bar), sidebar, search (dashboard), editor_search....]
 * @property {string} utm_id - campaign source
 * @property {string} market - {editor,dashboard,standalone, da_widget, premium_cart}
 * @property {boolean} is_compatible - true\false
 * @property {string} referral_sub_tag_name - e.g. sub category name
 * @property {string} section_name - what is the title in the section presented.
 * @property {string} widget_referral - is flow referred from widget
 * @property {string} widget_name - If user clicked on an app cube that was located inside a widget. what is the widget name, else null
 * @property {GUID} uuid - uuid
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {number} section_index - from top = 0, to last = 0+n. what is the ranking order of the section presented?
 * @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - Impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} badge_name - badge
 * @property {string} page_name - page name
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} sub_tag_name - for sub tag such as sub-category in category
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} category - {featured, new, search, pending, all_carousel, my_apps....}
 * @property {GUID} app_id - app_id
 * @property {string} tag_type - category, collection, homepage etc.
 * @property {boolean} is_app_dependency - true\false
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - unique name of actual tag ('must have apps', 'photography' etc)
 * @property {string} referral_tag_type - the previous page type
 * @property {number} index - The listing ranking of the number in the presented page.
 * @property {string} referral_tag_name - referral additional info
 * @property {string} history_path -  a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @property {string} last_page - the last page the user visited before he entered the app page.
 * will be reported only when the tag_type='app_page', otherwise null
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<appModalOpenAppModalClickParams>} LogObject<appModalOpenAppModalClickParams>
 */
export function appModalOpenAppModalClick(params) {
    return { evid: 21, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalAppModalOpened' event (evid: 22)
 *
 * Event description: When a user clicks on an App in the App Market, a modal will be opened to present data about the App (overview, pricing, reviews, developer info.
 *
 * @param {appModalAppModalOpenedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {number} ts - market loading time in ms
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
 * @property {string} section - {related_apps.......}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} category - {add_panel: text, image..., market: featured, new, search, pending, all_carousel....}
 * @property {GUID} app_id - app_id
 * @property {number} item_position - {1,2,3,...}
 * @property {GUID} esi - esi
 * @property {string} component_type - {tpa,ed_component,list,blog...}
 * @property {GUID} msid - msid
 * @return {LogObject<appModalAppModalOpenedParams>} LogObject<appModalAppModalOpenedParams>
 */
export function appModalAppModalOpened(params) {
    return { evid: 22, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalTabClick' event (evid: 23)
 *
 * Event description: Inside an app modal, clicking on tabs (pricing, reviews, developer info, demo etc)
 *
 * @param {appModalTabClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {string} tab_name - {demo, reviews, reviews_link}
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appModalTabClickParams>} LogObject<appModalTabClickParams>
 */
export function appModalTabClick(params) {
    return { evid: 23, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalDevNameLinkClick' event (evid: 24)
 *
 * Event description: app modal -> dev name link click
 *
 * @param {appModalDevNameLinkClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {header, dev_info}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appModalDevNameLinkClickParams>} LogObject<appModalDevNameLinkClickParams>
 */
export function appModalDevNameLinkClick(params) {
    return { evid: 24, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalSupportInfoClick' event (evid: 25)
 *
 * Event description: app modal -> support info click
 *
 * @param {appModalSupportInfoClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} info_type - {email, website, phone}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appModalSupportInfoClickParams>} LogObject<appModalSupportInfoClickParams>
 */
export function appModalSupportInfoClick(params) {
    return { evid: 25, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appModalShareClick' event (evid: 27)
 *
 * Event description: app modal -> share click
 *
 * @param {appModalShareClickParams} params - The parameters for this event
 * @property {string} market - {standalone,...}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} share_type - {facebook, twitter}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appModalShareClickParams>} LogObject<appModalShareClickParams>
 */
export function appModalShareClick(params) {
    return { evid: 27, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchAutocompleteClick' event (evid: 29)
 *
 * Event description: search autocomplete click
 *
 * @param {searchAutocompleteClickParams} params - The parameters for this event
 * @property {string} auto_search_term - auto_search_term
 * @property {string} market - {editor,dashboard,standalone}
 * @property {GUID} site_id - site_id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - search_term
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {string} type - {search_term, app, category}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<searchAutocompleteClickParams>} LogObject<searchAutocompleteClickParams>
 */
export function searchAutocompleteClick(params) {
    return { evid: 29, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketWidgetsClickAction' event (evid: 3)
 *
 * Event description: When user clicks on a possible action in a widget: could be box of apps collection, category or simple articles
 *
 * @param {appMarketWidgetsClickActionParams} params - The parameters for this event
 * @property {string} tag_name_clicked - name of tag clicked on to go
 * @property {string} market - market platform
 * @property {string} widget_type - collection/category
 * @property {string} tag_type_clicked - type of tag clicked on to go
 * @property {string} section - what is the section (widget) name
 * @property {string} page_name - page name
 * @property {string} marketVersion - version of market
 * @property {string} vertical - vertical
 * @property {string} tag_type - Where was the widget when user clicked on it? (homepage, app page)
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - what was the actual page name , where the widget was shown? (app_id of app, homepage etc)
 * @return {LogObject<appMarketWidgetsClickActionParams>} LogObject<appMarketWidgetsClickActionParams>
 */
export function appMarketWidgetsClickAction(params) {
    return { evid: 3, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collectionOpenSiteCategoryPopUp' event (evid: 30)
 *
 * Event description: When changing  the site category (stores, photography, music , fitness, etc - this will change the type of apps shown in the front page.)
 *
 * @param {collectionOpenSiteCategoryPopUpParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {ed_home}
 * @property {string} category - {[market]_collection}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<collectionOpenSiteCategoryPopUpParams>} LogObject<collectionOpenSiteCategoryPopUpParams>
 */
export function collectionOpenSiteCategoryPopUp(params) {
    return { evid: 30, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addAppClick' event (evid: 31)
 *
 * Event description: add app or claim app click in app page
 *
 * @param {addAppClickParams} params - The parameters for this event
 * @property {string} require_type - the unfulfilled requirement (same as prompt message) , 'null' if all fulfilled
 * @property {string} navigation_source - e.g. top-search,home, menu, standalone-header, search_result_page, search_result_empty_page
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {string} all_requirements_filled - yes/no/no-requirements
 * @property {boolean} has_app_requirement - true\false
 * @property {string} referral_sub_tag_name - e.g. sub category name
 * @property {string} section_name - name of section's title presented
 * @property {string} click_location - 'app-page-cta' - app page regular cta location
 *
 * 'app-sticky-header-cta' - app page sticky header
 *
 * 'app-modal-footer-cta' - ‘in-context’ footer
 *
 * @property {string} widget_referral - is flow referred from widget
 * @property {string} widget_name - when trying to add an app, if app the inside a widget - what is the widget name. else null
 * @property {GUID} uuid - uuid
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {number} section_index - from top = 0, to last = 0+n. what is the ranking order of the section presented?
 * @property {boolean} in_context_view - boolean, is true if the click made in context view.
 * @property {string} section - In which section is that app located?
 * @property {GUID} impression_id - impression id - unique for which impression
 * @property {string} slug_id - id of consistent set of apps
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {number} number_of_depended_apps - number_of_depended_apps
 * @property {string} referral_section_name - section that referred this, for example: search-result	, category
 * @property {string} category - Every app belongs to one category. which one is the app category of this app?
 * @property {GUID} app_id - app_id
 * @property {string} pageType - Type of page used when add app was clicked ( Homepage, App page, Developer page , collection page etc)
 * @property {string} tag_type - type of page opened - category, homepage, app page etc
 * @property {boolean} is_app_dependency - true\false
 * @property {boolean} is_external - not originally from the app market
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag ('must have apps' , 'music' etc)
 * @property {string} referral_tag_type - previous page type
 * @property {number} index - The listing ranking of the number in the presented page.
 * @property {string} market_mode - The mode of the App Market experience that a user interacts with, such as public, unlisted, test_my_app, or enterprise.
 * @property {string} cta_type - The CTA is always 'add to site', but the flow type could be 'add app' or 'claim app' for bundles
 * @property {string} correlation_id - API correlation ID, generated during initialization. Use it to join with installer BI.
 * @property {string} badge_name - report an array with all the badge names that appeared in the app box separated by commas, f.e: premium_benefit, wix_choice
 * @property {string} history_path - a json that will return the navigation history of a user/site in the AppMarket. The page type as key and the value be the exact page name, for example: {‘homepage’:null,’collection’:’newest apps’ ,‘category’:’sell online’, ‘subCategory’: ‘stores’, ‘app_page’:’*the app_id*’}
 * @property {string} last_page -  the last page the user visited before he entered the app page.
 * will be reported only when the tag_type='app_page', otherwise null
 *
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 * @return {LogObject<addAppClickParams>} LogObject<addAppClickParams>
 */
export function addAppClick(params) {
    return { evid: 31, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unificationAddAppClick' event (evid: 32)
 *
 * Event description: unification add app click
 *
 * @param {unificationAddAppClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {dash_market_hover,....}
 * @property {string} category - {featured, new, search, pending, all_carousel....}
 * @property {GUID} app_id - app_id
 * @property {number} item_position - {1,2,3...}
 * @property {GUID} esi - esi
 * @property {string} component_type - {tpa,ed_component,list,blog...}
 * @property {GUID} msid - msid
 * @property {string} addition_method - {direct_add, modal}
 * @property {string} value - {search_term}
 * @property {string} modal_tab_name - {demo, reviews, reviews_link}
 * @return {LogObject<unificationAddAppClickParams>} LogObject<unificationAddAppClickParams>
 */
export function unificationAddAppClick(params) {
    return { evid: 32, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openAppClick' event (evid: 33)
 *
 * Event description: click on open app button
 *
 * @param {openAppClickParams} params - The parameters for this event
 * @property {string} method - {direct_add , modal}
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} section - In which section is that app located?
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - {html, analytics,...}
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} category - category
 * @property {GUID} app_id - app_id
 * @property {string} target - {editor, dashboard}
 * @property {number} item_position - {1,2,3...}
 * @property {string} pageType - type of page
 * @property {string} tag_type - type of page opened - category, homepage, app page etc
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - name of the specific tag ('must have apps' , 'music' etc)
 * @property {number} index - The listing ranking of the number in the presented page.
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 *
 * @property {string} badge_name - in case the upgrade is from the app page report an array with all the badge names that appear in the app box separated by commas, f.e: premium_benefit, wix_choice, wix_sale, dev_sale.
 * in case the upgrade is from manage apps report the wix_sale/dev_sale when a sale badgae is appear near the upgrade CTA.
 * otherwise null.
 * @property {string} cta_type - ['open', 'add_again']
 * @property {string} click_location - 'app-page-cta' - app page regular cta location
 *
 * 'app-sticky-header-cta' - app page sticky header
 *
 * 'app-modal-footer-cta' - ‘in-context’ footer
 *
 * @return {LogObject<openAppClickParams>} LogObject<openAppClickParams>
 */
export function openAppClick(params) {
    return { evid: 33, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collectionCloseSiteCategoryPopUp' event (evid: 36)
 *
 * Event description: click on close site category pop up (the pop up that is opened in order to choose what site category is used - e.g business, store, photography etc)
 *
 * @param {collectionCloseSiteCategoryPopUpParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {ed_home}
 * @property {string} closing_method - {x, cancel, outside}
 * @property {string} category - {[market]_collection}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<collectionCloseSiteCategoryPopUpParams>} LogObject<collectionCloseSiteCategoryPopUpParams>
 */
export function collectionCloseSiteCategoryPopUp(params) {
    return { evid: 36, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myAppsUpgradeAppClick' event (evid: 38)
 *
 * Event description: in manage apps - click on upgrade button for apps
 *
 * @param {myAppsUpgradeAppClickParams} params - The parameters for this event
 * @property {string} pp_origin - {my_apps,...}
 * @property {string} market - {dashboard,...}
 * @property {GUID} site_id - site_id
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<myAppsUpgradeAppClickParams>} LogObject<myAppsUpgradeAppClickParams>
 */
export function myAppsUpgradeAppClick(params) {
    return { evid: 38, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketOpenManageApps' event (evid: 4)
 *
 * Event description: when user is opening the manage apps window
 *
 * @param {appMarketOpenManageAppsParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} marketVersion - 'new' for new market
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketOpenManageAppsParams>} LogObject<appMarketOpenManageAppsParams>
 */
export function appMarketOpenManageApps(params) {
    return { evid: 4, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collectionNewSiteCategorySelected' event (evid: 40)
 *
 * Event description: click on View Apps button in Site Category pop up
 *
 * @param {collectionNewSiteCategorySelectedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} origin_category - {[market]_collection}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {ed_home}
 * @property {string} category - {[market]_collection}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<collectionNewSiteCategorySelectedParams>} LogObject<collectionNewSiteCategorySelectedParams>
 */
export function collectionNewSiteCategorySelected(params) {
    return { evid: 40, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tpaNewPremiumFlowPpOpened' event (evid: 400)
 *
 * Event description: Event is triggered whenever the PP is opened
 *
 * @param {tpaNewPremiumFlowPpOpenedParams} params - The parameters for this event
 * @property {string} pp_origin - pp_origin {settings,GFPP,BM}
 * @property {string} market - source of click (editor, dashboard)
 * @property {GUID} app_site_id - app_site_id. the instance id. key for app in msid
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {GUID} app_id - app_id
 * @property {number} num_of_packages - num_of_packages presented in the PP
 * @property {string} flow_type - upgrade or downgrade
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_of_sale_packages - The number of packages on sale while the package picker is viewed
 * @property {number} num_of_benefits_packages - The number of packages with benefit while the package picker is viewed.
 *
 * @return {LogObject<tpaNewPremiumFlowPpOpenedParams>} LogObject<tpaNewPremiumFlowPpOpenedParams>
 */
export function tpaNewPremiumFlowPpOpened(params) {
    return { evid: 400, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tpaNewPremiumFlowCyclePageOpened' event (evid: 401)
 *
 * Event description: Event is triggered whenever the cycle choosing page (subscription) is opened
 *
 * @param {tpaNewPremiumFlowCyclePageOpenedParams} params - The parameters for this event
 * @property {string} pp_origin - pp_origin {settings,GFPP,BM}
 * @property {string} package_id - the package id
 * @property {string} market - source of click for upgrade (editor, dashboard)
 * @property {GUID} app_site_id - app_site_id. the instance id. key for app in msid
 * @property {string} vertical - vertical
 * @property {string} package_name - the package name the string itself
 * @property {string} sale_name - nov21
 * @property {GUID} app_id - app_id
 * @property {string} app_plan_id - plan_id of app
 * @property {string} flow_type - upgrade or downgrade
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {boolean} is_benefit - True if the selected plan is an app benefit
 * @property {number} sale_discount - If sale exists report the sale discount (f.e: 20), otherwise null.
 *
 * @return {LogObject<tpaNewPremiumFlowCyclePageOpenedParams>} LogObject<tpaNewPremiumFlowCyclePageOpenedParams>
 */
export function tpaNewPremiumFlowCyclePageOpened(params) {
    return { evid: 401, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appmarketPackagePickerToggleCycleClick' event (evid: 402)
 *
 * Event description: Event is triggered whenever the user toggles between the cycles shown.
 *
 * @param {appmarketPackagePickerToggleCycleClickParams} params - The parameters for this event
 * @property {string} market - editor, dashboard etc
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {string} cycle_click - what cycle did the user clicked on
 * @property {GUID} msid - msid
 * @property {number} number_of_plans - Number of plans
 * @return {LogObject<appmarketPackagePickerToggleCycleClickParams>} LogObject<appmarketPackagePickerToggleCycleClickParams>
 */
export function appmarketPackagePickerToggleCycleClick(params) {
    return { evid: 402, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketReviewAppNotInstalledAlert' event (evid: 403)
 *
 * Event description: App Market - Review - App Not Installed Alert.
 * user attempt to review an app that has never been previously installed by that user - and will be blocked from posting a review.
 *
 * @param {appMarketReviewAppNotInstalledAlertParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketReviewAppNotInstalledAlertParams>} LogObject<appMarketReviewAppNotInstalledAlertParams>
 */
export function appMarketReviewAppNotInstalledAlert(params) {
    return { evid: 403, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDowngradeOpenModal' event (evid: 405)
 *
 * Event description: downgrade modal opens
 *
 * @param {appMarketDowngradeOpenModalParams} params - The parameters for this event
 * @property {string} pp_origin - package picker click origin
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<appMarketDowngradeOpenModalParams>} LogObject<appMarketDowngradeOpenModalParams>
 */
export function appMarketDowngradeOpenModal(params) {
    return { evid: 405, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDowngradeChangePlanClick' event (evid: 406)
 *
 * Event description: downgrade modal opens
 *
 * @param {appMarketDowngradeChangePlanClickParams} params - The parameters for this event
 * @property {string} pp_origin - package picker click origin
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<appMarketDowngradeChangePlanClickParams>} LogObject<appMarketDowngradeChangePlanClickParams>
 */
export function appMarketDowngradeChangePlanClick(params) {
    return { evid: 406, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDowngradeCalculateClick' event (evid: 407)
 *
 * Event description: downgrade modal opens
 *
 * @param {appMarketDowngradeCalculateClickParams} params - The parameters for this event
 * @property {string} pp_origin - package picker click origin
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<appMarketDowngradeCalculateClickParams>} LogObject<appMarketDowngradeCalculateClickParams>
 */
export function appMarketDowngradeCalculateClick(params) {
    return { evid: 407, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDowngradeGoToDowngradeFromDeleteModal' event (evid: 408)
 *
 * Event description: Go to Downgrade from Delete Modal
 *
 * @param {appMarketDowngradeGoToDowngradeFromDeleteModalParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<appMarketDowngradeGoToDowngradeFromDeleteModalParams>} LogObject<appMarketDowngradeGoToDowngradeFromDeleteModalParams>
 */
export function appMarketDowngradeGoToDowngradeFromDeleteModal(params) {
    return { evid: 408, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionsPermissionsModalLoaded' event (evid: 41)
 *
 * Event description: permissions -> permissions modal loaded
 *
 * @param {permissionsPermissionsModalLoadedParams} params - The parameters for this event
 * @property {number} num_of_permissions - number of permissions requested by consent modal
 * @property {string} modalType - consent , existing
 * @property {string} market - editor, dashboard, adi, third_party
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {GUID} collimp_id - collection impression guid
 * @property {string} referral_info - referral_info
 * @property {string} consentVersion - old_consent, new_consent
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {boolean} is_external - not originally from the app market
 * @property {string} flow_type - consent or update_app_version
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {boolean} in_context_view - true if the consent modal was triggered through “in context”, otherwise false
 * @property {string} badge_name - report an array with all the badge names that appeared in the app box separated by commas, f.e: premium_benefit, wix_choice
 * @return {LogObject<permissionsPermissionsModalLoadedParams>} LogObject<permissionsPermissionsModalLoadedParams>
 */
export function permissionsPermissionsModalLoaded(params) {
    return { evid: 41, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionsPermissionsModalClosed' event (evid: 42)
 *
 * Event description: permissions -> permissions modal closed
 *
 * @param {permissionsPermissionsModalClosedParams} params - The parameters for this event
 * @property {number} num_of_permissions - number of permissions requested by consent
 * @property {string} modalType - consent , existing
 * @property {string} market - editor, dashboard, adi, third_party
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} message_type - {default, unlisted_app_warning}
 * @property {boolean} in_context_view - bool
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<permissionsPermissionsModalClosedParams>} LogObject<permissionsPermissionsModalClosedParams>
 */
export function permissionsPermissionsModalClosed(params) {
    return { evid: 42, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionsModalAddAppClick' event (evid: 43)
 *
 * Event description: permissions modal -> add app click
 *
 * @param {permissionsModalAddAppClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} message_type - {default, unlisted_app_warning}
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<permissionsModalAddAppClickParams>} LogObject<permissionsModalAddAppClickParams>
 */
export function permissionsModalAddAppClick(params) {
    return { evid: 43, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionsModalTermsOfUseClick' event (evid: 44)
 *
 * Event description: Consent page - clicking on the 'terms of use' option
 *
 * @param {permissionsModalTermsOfUseClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} terms_type - what was the terms and condition link type ?
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<permissionsModalTermsOfUseClickParams>} LogObject<permissionsModalTermsOfUseClickParams>
 */
export function permissionsModalTermsOfUseClick(params) {
    return { evid: 44, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collectionOverrideSiteProfile' event (evid: 45)
 *
 * Event description: override site profile, when choosing a site profile in the appmarket (e.g online-store, photography , music etc) - this will affect the default apps presented in the home page and collection order.
 *
 * @param {collectionOverrideSiteProfileParams} params - The parameters for this event
 * @property {string} market - {editor, dashboard, standalone, etc.)
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} esi - esi
 * @property {string} cat - {design, accommodation, business...}
 * @property {GUID} msid - msid
 * @return {LogObject<collectionOverrideSiteProfileParams>} LogObject<collectionOverrideSiteProfileParams>
 */
export function collectionOverrideSiteProfile(params) {
    return { evid: 45, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ssrLoaded' event (evid: 46)
 *
 * Event description: SSR loaded, ssr means - Server Side Loading. when loading the app market, first the "looks" is loaded, then the images, than the links.
 *
 * @param {ssrLoadedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {number} ts - loading time in ms (some browsers don't support timing API, then 0 is send)
 * @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 * @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...} not used
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {boolean} is_first - (per user per site) not used
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<ssrLoadedParams>} LogObject<ssrLoadedParams>
 */
export function ssrLoaded(params) {
    return { evid: 46, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketBackToManageAppsSrc24Evid5' event (evid: 5)
 *
 * Event description: back to manage apps click or to the referral page. referral page  = referral_name
 *
 * @param {appMarketBackToManageAppsSrc24Evid5Params} params - The parameters for this event
 * @property {string} referral_name - what is the referral name? 'manage_apps' , 'finance'
 * @property {string} market - market
 * @property {string} click_origin - origin of click "back to manage app"
 * @property {string} marketVersion - 'new' for new market, else null
 * @property {string} vertical - vertical
 * @property {string} tag_type - tag type
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @return {LogObject<appMarketBackToManageAppsSrc24Evid5Params>} LogObject<appMarketBackToManageAppsSrc24Evid5Params>
 */
export function appMarketBackToManageAppsSrc24Evid5(params) {
    return { evid: 5, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistWishlistClick' event (evid: 51)
 *
 * Event description: wishlist -> wishlist click
 *
 * @param {wishlistWishlistClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - [search_term]
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {search, ...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_results - {0,1,2,3..}
 * @return {LogObject<wishlistWishlistClickParams>} LogObject<wishlistWishlistClickParams>
 */
export function wishlistWishlistClick(params) {
    return { evid: 51, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistWishlistLoaded' event (evid: 52)
 *
 * Event description: wishlist -> wishlist loaded
 *
 * @param {wishlistWishlistLoadedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - [search_term]
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {search, ...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_results - {0,1,2,3..}
 * @return {LogObject<wishlistWishlistLoadedParams>} LogObject<wishlistWishlistLoadedParams>
 */
export function wishlistWishlistLoaded(params) {
    return { evid: 52, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistWishlistClosed' event (evid: 53)
 *
 * Event description: wishlist -> wishlist closed
 *
 * @param {wishlistWishlistClosedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} closing_method - {x, cancel, click_out}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<wishlistWishlistClosedParams>} LogObject<wishlistWishlistClosedParams>
 */
export function wishlistWishlistClosed(params) {
    return { evid: 53, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistSendClick' event (evid: 54)
 *
 * Event description: wishlist -> send click
 *
 * @param {wishlistSendClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - [search_term]
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {search, ...}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_results - {0,1,2,3..}
 * @return {LogObject<wishlistSendClickParams>} LogObject<wishlistSendClickParams>
 */
export function wishlistSendClick(params) {
    return { evid: 54, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistSent' event (evid: 55)
 *
 * Event description: wishlist -> sent
 *
 * @param {wishlistSentParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {string} description - description
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - [search_term]
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {search, success message ...}
 * @property {string} title - title
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {number} num_results - {0,1,2,3..}
 * @return {LogObject<wishlistSentParams>} LogObject<wishlistSentParams>
 */
export function wishlistSent(params) {
    return { evid: 55, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistSuccessMessageClose' event (evid: 56)
 *
 * Event description: wishlist -> success message -> close
 *
 * @param {wishlistSuccessMessageCloseParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} closing_method - {x, done, click_out}
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<wishlistSuccessMessageCloseParams>} LogObject<wishlistSuccessMessageCloseParams>
 */
export function wishlistSuccessMessageClose(params) {
    return { evid: 56, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wishlistSuccessMessageAddAgainClick' event (evid: 57)
 *
 * Event description: wishlist -> success message -> add again click
 *
 * @param {wishlistSuccessMessageAddAgainClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<wishlistSuccessMessageAddAgainClickParams>} LogObject<wishlistSuccessMessageAddAgainClickParams>
 */
export function wishlistSuccessMessageAddAgainClick(params) {
    return { evid: 57, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'collectionLoaded' event (evid: 58)
 *
 * Event description: loading app market collection with the list of apps.
 * When only 4 apps are available (missing the main vertical app) - we should populate values 2 through 5, leaving 1 empty. created by pavelk
 *
 * @param {collectionLoadedParams} params - The parameters for this event
 * @property {GUID} app_id1 - app_id1
 * @property {string} market - {editor,dashboard,standalone, premium_cart}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {GUID} app_id5 - app_id5
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id2 - app_id2
 * @property {string} category - category of apps name (must-have-apps, social, forms, free apps, etc)
 * @property {GUID} esi - esi
 * @property {GUID} app_id4 - app_id4
 * @property {GUID} msid - msid
 * @property {GUID} app_id3 - app_id3
 * @return {LogObject<collectionLoadedParams>} LogObject<collectionLoadedParams>
 */
export function collectionLoaded(params) {
    return { evid: 58, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDeleteModalModalOpened' event (evid: 6)
 *
 * Event description: Delete modal opened to user
 *
 * @param {appMarketDeleteModalModalOpenedParams} params - The parameters for this event
 * @property {string} market - editor or dashboard
 * @property {string} marketVersion - market version ('new' or null)
 * @property {string} vertical - vertical
 * @property {string} origin - click origin from? ('context_menu' etc)
 * @property {GUID} app_id - app id
 * @property {string} tag_type - Where did the delete take place from?
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketDeleteModalModalOpenedParams>} LogObject<appMarketDeleteModalModalOpenedParams>
 */
export function appMarketDeleteModalModalOpened(params) {
    return { evid: 6, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pendingRemoveAppFromPendingClick' event (evid: 61)
 *
 * Event description: pending -> remove app from pending click
 *
 * @param {pendingRemoveAppFromPendingClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<pendingRemoveAppFromPendingClickParams>} LogObject<pendingRemoveAppFromPendingClickParams>
 */
export function pendingRemoveAppFromPendingClick(params) {
    return { evid: 61, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pendingAppRemovedFromPending' event (evid: 62)
 *
 * Event description: pending -> app removed from pending
 *
 * @param {pendingAppRemovedFromPendingParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<pendingAppRemovedFromPendingParams>} LogObject<pendingAppRemovedFromPendingParams>
 */
export function pendingAppRemovedFromPending(params) {
    return { evid: 62, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsTabClick' event (evid: 64)
 *
 * Event description: When in App Market, clicking on Tabs (App Market, Manage Apps)
 *
 * @param {manageAppsTabClickParams} params - The parameters for this event
 * @property {string} market - market name (editor, dashboard)
 * @property {string} tabName - name of tab (app market, manage apps)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<manageAppsTabClickParams>} LogObject<manageAppsTabClickParams>
 */
export function manageAppsTabClick(params) {
    return { evid: 64, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSupportMailSentToAppDeveloper' event (evid: 667)
 *
 * Event description: User submit a support ticket to the app developer via the support app modal in the manage apps.
 *
 * @param {appMarketSupportMailSentToAppDeveloperParams} params - The parameters for this event
 * @property {string} support_description - support ticket content
 * @property {boolean} is_premium_app - is the app in premium when mail was sent
 * @property {GUID} app_id - app id
 * @property {boolean} is_app_installed - is_app_installed
 * @property {GUID} msid - msid
 * @property {string} support_topic - support topic
 * @return {LogObject<appMarketSupportMailSentToAppDeveloperParams>} LogObject<appMarketSupportMailSentToAppDeveloperParams>
 */
export function appMarketSupportMailSentToAppDeveloper(params) {
    return { evid: 667, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSupportMailOpenedByDev' event (evid: 668)
 *
 * Event description: App Market - Support Mail Opened by Dev.
 *
 * @param {appMarketSupportMailOpenedByDevParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<appMarketSupportMailOpenedByDevParams>} LogObject<appMarketSupportMailOpenedByDevParams>
 */
export function appMarketSupportMailOpenedByDev(params) {
    return { evid: 668, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSupportMailModalOpened' event (evid: 669)
 *
 * Event description: Support Modal Opened
 *
 * @param {appMarketSupportMailModalOpenedParams} params - The parameters for this event
 * @property {string} market - editor or dashboard
 * @property {string} marketVersion - send 'new' for new app market, else null
 * @property {string} vertical - vertical
 * @property {string} origin - origin in tag_type
 * @property {GUID} app_id - app_id
 * @property {boolean} is_app_installed - true or false
 * @property {string} tag_type - tag of page - app page, manage apps etc.
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<appMarketSupportMailModalOpenedParams>} LogObject<appMarketSupportMailModalOpenedParams>
 */
export function appMarketSupportMailModalOpened(params) {
    return { evid: 669, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketTerminatorPresenteToUser' event (evid: 69)
 *
 * Event description: Wix 'Terminator' is an option that opens when a user is searching the app market for a feature that exists in wix , but not as an app. this will
 *
 * @param {appMarketTerminatorPresenteToUserParams} params - The parameters for this event
 * @property {string} experiment_name - what is the subject / name of experiment
 * @property {string} market - market (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} search_term - the keyword that was searched
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketTerminatorPresenteToUserParams>} LogObject<appMarketTerminatorPresenteToUserParams>
 */
export function appMarketTerminatorPresenteToUser(params) {
    return { evid: 69, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDeleteModalDeleteAppApproved' event (evid: 7)
 *
 * Event description: User clicks on Delete App call to action button
 *
 * @param {appMarketDeleteModalDeleteAppApprovedParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} delete_details - Delete reason explained by user (optional)
 * @property {string} marketVersion - market version (new or null)
 * @property {string} vertical - vertical
 * @property {string} origin - click origin from? ('context_menu' etc)
 * @property {GUID} app_id - app id
 * @property {string} tag_type - Where did the delete take place from?
 * @property {GUID} esi - esi
 * @property {number} reason_index - the position of the reason in the list
 * @property {string} delete_reason - what is the chosen reason to delete
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketDeleteModalDeleteAppApprovedParams>} LogObject<appMarketDeleteModalDeleteAppApprovedParams>
 */
export function appMarketDeleteModalDeleteAppApproved(params) {
    return { evid: 7, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpgradeWixSiteClick' event (evid: 70)
 *
 * Event description: When trying to install Apps that require premium wix site, prompt will be opened, clicking on the button "Upgrade Site" will send this BI event.
 *
 * @param {appMarketUpgradeWixSiteClickParams} params - The parameters for this event
 * @property {string} market - determines which market initiated this event (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketUpgradeWixSiteClickParams>} LogObject<appMarketUpgradeWixSiteClickParams>
 */
export function appMarketUpgradeWixSiteClick(params) {
    return { evid: 70, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSupportMailModalClosedX' event (evid: 701)
 *
 * Event description: Support Modal Opened
 *
 * @param {appMarketSupportMailModalClosedXParams} params - The parameters for this event
 * @property {string} market - editor or dashboard
 * @property {string} marketVersion - send 'new' for new app market, else null
 * @property {string} vertical - vertical
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {boolean} is_app_installed - true or false
 * @property {string} tag_type - app page or manage apps etc
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<appMarketSupportMailModalClosedXParams>} LogObject<appMarketSupportMailModalClosedXParams>
 */
export function appMarketSupportMailModalClosedX(params) {
    return { evid: 701, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppSupportedGeoSHover' event (evid: 702)
 *
 * Event description: user hover over app geo supported
 *
 * @param {appMarketAppSupportedGeoSHoverParams} params - The parameters for this event
 * @property {string} market - editor dashboard
 * @property {string} marketVersion - 'new' else null
 * @property {string} vertical - vertical
 * @property {GUID} app_id - guid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketAppSupportedGeoSHoverParams>} LogObject<appMarketAppSupportedGeoSHoverParams>
 */
export function appMarketAppSupportedGeoSHover(params) {
    return { evid: 702, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSiteRequirementsTagClick' event (evid: 703)
 *
 * Event description: user clicks on site requirements
 *
 * @param {appMarketSiteRequirementsTagClickParams} params - The parameters for this event
 * @property {string} market - dashboard, editor, standalone
 * @property {GUID} required_app_id - required_app_id of tagged app (not the app_id of the app page!)
 * @property {string} marketVersion - 'new' else null
 * @property {string} vertical - vertical
 * @property {GUID} app_id - guid
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketSiteRequirementsTagClickParams>} LogObject<appMarketSiteRequirementsTagClickParams>
 */
export function appMarketSiteRequirementsTagClick(params) {
    return { evid: 703, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCloseDialogBoxOfUpgradeWixX' event (evid: 73)
 *
 * Event description: When trying to install Apps that require premium wix site, prompt will be opened, This BI event is sent when box is closed.
 *
 * @param {appMarketCloseDialogBoxOfUpgradeWixXParams} params - The parameters for this event
 * @property {string} market - determines which market initiated this event (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketCloseDialogBoxOfUpgradeWixXParams>} LogObject<appMarketCloseDialogBoxOfUpgradeWixXParams>
 */
export function appMarketCloseDialogBoxOfUpgradeWixX(params) {
    return { evid: 73, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketConnectDomainClick' event (evid: 74)
 *
 * Event description: Clicking on "Connect Domain"
 *
 * @param {appMarketConnectDomainClickParams} params - The parameters for this event
 * @property {string} market - determines which market initiated this event (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketConnectDomainClickParams>} LogObject<appMarketConnectDomainClickParams>
 */
export function appMarketConnectDomainClick(params) {
    return { evid: 74, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketCloseDialogBoxOfConnectDomainX' event (evid: 75)
 *
 * Event description: When trying to install Apps that require premium wix site, prompt will be opened, This BI event is sent when box is closed.
 *
 * @param {appMarketCloseDialogBoxOfConnectDomainXParams} params - The parameters for this event
 * @property {string} market - determines which market initiated this event (editor or dashboard)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketCloseDialogBoxOfConnectDomainXParams>} LogObject<appMarketCloseDialogBoxOfConnectDomainXParams>
 */
export function appMarketCloseDialogBoxOfConnectDomainX(params) {
    return { evid: 75, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketUpgradeSiteConnectDomainDialogBox' event (evid: 76)
 *
 * Event description: Dialog box opened when user tries to install a premium-must app.
 *
 * @param {appMarketUpgradeSiteConnectDomainDialogBoxParams} params - The parameters for this event
 * @property {string} market - editor or dashboard
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} stepName - which step is it? 'upgrade_site' or 'connect_domain'
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketUpgradeSiteConnectDomainDialogBoxParams>} LogObject<appMarketUpgradeSiteConnectDomainDialogBoxParams>
 */
export function appMarketUpgradeSiteConnectDomainDialogBox(params) {
    return { evid: 76, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'externalPpCheckoutStart' event (evid: 77)
 *
 * Event description: Checkout Started Package Picker
 *
 * @param {externalPpCheckoutStartParams} params - The parameters for this event
 * @property {string} cycle_name - year, month etc
 * @property {string} pp_origin - Where did the package picker opened from
 * @property {string} vendorProductId - vendor product id
 * @property {GUID} appstoreId - unique guid for app_id, package and cycle. (e.g - App_1 , pro package, yearly cycle)
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov_21
 * @property {string} referralAdditionalInfo - Which button sent the user into upgrading the TPA funnel (ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn)
 * @property {string} app_plan_id - plan_id of app
 * @property {Url} referer - url that upgrade came from
 * @property {number} num_of_packages - number of packages offered by the app to upgrade.
 * @property {GUID} appId - app id
 * @property {string} flow_type - upgrade or downgrade
 * @property {GUID} esi - esi
 * @property {number} payment_cycle - 3 - monthly, 6- yearly etc.
 * @property {GUID} msid - msid
 * @property {boolean} is_benefit - True if the selected plan is an app benefit
 * @property {number} sale_discount - If sale exists report the sale discount (f.e: 20), otherwise null.
 *
 * @return {LogObject<externalPpCheckoutStartParams>} LogObject<externalPpCheckoutStartParams>
 */
export function externalPpCheckoutStart(params) {
    return { evid: 77, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'externalPpCheckoutSuccess' event (evid: 78)
 *
 * Event description: Checkout succeeded for Package Picker
 *
 * @param {externalPpCheckoutSuccessParams} params - The parameters for this event
 * @property {string} cycle_name - name of cycle (e.g - monthly, yearly)
 * @property {string} pp_origin - where was the upgrade click initiated
 * @property {string} billing_flow - where the billing took place? (external, internal)
 * @property {string} vendorProductId - vendor product id
 * @property {string} coupon_name - name of coupon used to get discount or special offer
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {string} app_plan_id - app plan id
 * @property {GUID} appId - app id
 * @property {string} flow_type - upgrade/downgrade/ free trial
 * @property {GUID} esi - esi
 * @property {number} payment_cycle - cycle_id = 3 is monthly, 6 is yearly etc.
 * @property {GUID} msid - msid
 * @property {boolean} is_benefit - True if the selected plan is an app benefit
 * @property {number} sale_discount - If sale exists report the sale discount (f.e: 20), otherwise null.
 * @return {LogObject<externalPpCheckoutSuccessParams>} LogObject<externalPpCheckoutSuccessParams>
 */
export function externalPpCheckoutSuccess(params) {
    return { evid: 78, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'externalPpCheckoutFailed' event (evid: 79)
 *
 * Event description: Checkout failed Package Picker
 *
 * @param {externalPpCheckoutFailedParams} params - The parameters for this event
 * @property {string} cycle_name - year, month etc
 * @property {string} billing_flow - where the billing took place? (external, internal)
 * @property {string} vendorProductId - vendor product id
 * @property {string} fail_reason - why checkout was failed
 * @property {string} vertical - vertical
 * @property {string} app_plan_id - plan_id of app
 * @property {GUID} appId - app id
 * @property {string} flow_type - upgrade or downgrade
 * @property {GUID} esi - esi
 * @property {number} payment_cycle - cycle_id = 3 is monthly, 6 is yearly etc.
 * @property {GUID} msid - msid
 * @return {LogObject<externalPpCheckoutFailedParams>} LogObject<externalPpCheckoutFailedParams>
 */
export function externalPpCheckoutFailed(params) {
    return { evid: 79, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketDeleteModalCancelAppDeleteX' event (evid: 8)
 *
 * Event description: User closes the delete app modal without deleting.
 *
 * @param {appMarketDeleteModalCancelAppDeleteXParams} params - The parameters for this event
 * @property {string} market - market
 * @property {string} marketVersion - market version (new or null)
 * @property {string} vertical - vertical
 * @property {string} origin - click origin from? ('context_menu' etc)
 * @property {GUID} app_id - app id
 * @property {string} tag_type - Where did the delete take place from?
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketDeleteModalCancelAppDeleteXParams>} LogObject<appMarketDeleteModalCancelAppDeleteXParams>
 */
export function appMarketDeleteModalCancelAppDeleteX(params) {
    return { evid: 8, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'externalPpContactSupportWhenFailed' event (evid: 80)
 *
 * Event description: Dev Center - when Checkout failed External Package Picker - user clicked on 'contact support'
 *
 * @param {externalPpContactSupportWhenFailedParams} params - The parameters for this event
 * @property {string} vendorProductId - vendor product id
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<externalPpContactSupportWhenFailedParams>} LogObject<externalPpContactSupportWhenFailedParams>
 */
export function externalPpContactSupportWhenFailed(params) {
    return { evid: 80, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'externalPpMoreAppsWhenSuccess' event (evid: 88)
 *
 * Event description: Dev Center - when Checkout succeeded External Package Picker - user clicked on 'view more apps'
 *
 * @param {externalPpMoreAppsWhenSuccessParams} params - The parameters for this event
 * @property {string} vendorProductId - vendor product id
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<externalPpMoreAppsWhenSuccessParams>} LogObject<externalPpMoreAppsWhenSuccessParams>
 */
export function externalPpMoreAppsWhenSuccess(params) {
    return { evid: 88, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketManageAppsActionRequiredClick' event (evid: 9)
 *
 * Event description: In the Manage Apps tab, when user clicks on an action requirement of an app.
 *
 * @param {appMarketManageAppsActionRequiredClickParams} params - The parameters for this event
 * @property {string} market - market (dashboard, editor standalone
 * @property {boolean} is_consent_required - is consent required to update
 * @property {Url} url - article url
 * @property {boolean} is_editor_required - is editor required to update
 * @property {string} action_cta - cta action (claim app, upgrade app, add info, etc)
 * @property {string} vertical - vertical
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appMarketManageAppsActionRequiredClickParams>} LogObject<appMarketManageAppsActionRequiredClickParams>
 */
export function appMarketManageAppsActionRequiredClick(params) {
    return { evid: 9, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unificationUnificationModalLoaded' event (evid: 90)
 *
 * Event description: unification -> unification modal loaded
 *
 * @param {unificationUnificationModalLoadedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {unification_modal....}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} value - {search_term}
 * @return {LogObject<unificationUnificationModalLoadedParams>} LogObject<unificationUnificationModalLoadedParams>
 */
export function unificationUnificationModalLoaded(params) {
    return { evid: 90, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deprecated' event (evid: 91)
 *
 * Event description: unification -> (server) app added to pending
 *
 * @param {deprecatedParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - market = 'new' if new market, else null
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} version_name - version_name
 * @property {string} pending_source - {unification_modal, pending_hybrid, cart}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<deprecatedParams>} LogObject<deprecatedParams>
 */
export function deprecated(params) {
    return { evid: 91, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unificationCloseUnificationModalClick' event (evid: 92)
 *
 * Event description: unification -> close unification modal click
 *
 * @param {unificationCloseUnificationModalClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {unification_modal...}
 * @property {string} closing_method - {x, later}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} value - {search_term}
 * @return {LogObject<unificationCloseUnificationModalClickParams>} LogObject<unificationCloseUnificationModalClickParams>
 */
export function unificationCloseUnificationModalClick(params) {
    return { evid: 92, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unificationGoToClick' event (evid: 93)
 *
 * Event description: unification -> 'go to' click
 *
 * @param {unificationGoToClickParams} params - The parameters for this event
 * @property {string} market - {editor,dashboard,standalone, da_widget}
 * @property {string} go_to_market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} uuid - uuid
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - {general, online_store, music...}
 * @property {string} origin - {unification_modal, pending_category}
 * @property {string} pending_source - {unification_modal, pending_hybrid, cart}
 * @property {GUID} app_id - app_id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} value - {search_term}
 * @return {LogObject<unificationGoToClickParams>} LogObject<unificationGoToClickParams>
 */
export function unificationGoToClick(params) {
    return { evid: 93, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsOpenContextMenu' event (evid: 94)
 *
 * Event description: Manage Apps section in App Market. click on context menu (...)
 *
 * @param {manageAppsOpenContextMenuParams} params - The parameters for this event
 * @property {string} market - what market ? (editor, dashboard etc)
 * @property {GUID} appInstanceId - app instance id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<manageAppsOpenContextMenuParams>} LogObject<manageAppsOpenContextMenuParams>
 */
export function manageAppsOpenContextMenu(params) {
    return { evid: 94, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsUpgradeSite' event (evid: 95)
 *
 * Event description: Upgrade App Click in the Manage Apps or App Page
 * (will also be reported on the app page starting November 2024)
 *
 * @param {manageAppsUpgradeSiteParams} params - The parameters for this event
 * @property {string} market - what market ? (editor, dashboard etc)
 * @property {GUID} appInstanceId - app instance id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {string} sale_name - nov21
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} upgrade_origin - manage-apps/app-page: Will be implemented on the app page starting November 2024. 'null' or 'manage-apps' indicates it was reported through Manage Apps.
 * @property {string} badge_name - in case the upgrade is from the app page report an array with all the badge names that appear in the app box separated by commas, f.e: premium_benefit, wix_choice, wix_sale, dev_sale.
 * in case the upgrade is from manage apps report the wix_sale/dev_sale when a sale badgae is appear near the upgrade CTA.
 * otherwise null.
 * @property {number} sale_discount - If the app is on sale, show the discount as a percentage (for example: 20, 50, etc.). otherwise, return null.
 *
 * @property {string} cta_type - upgrade / redeem
 * @return {LogObject<manageAppsUpgradeSiteParams>} LogObject<manageAppsUpgradeSiteParams>
 */
export function manageAppsUpgradeSite(params) {
    return { evid: 95, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsContextMenuAction' event (evid: 96)
 *
 * Event description: Manage Apps - Context Menu Action
 *
 * @param {manageAppsContextMenuActionParams} params - The parameters for this event
 * @property {string} contextAction - action taken inside the context menu within the Manage App section in the app market
 * @property {string} market - what market ? (editor, dashboard etc)
 * @property {GUID} appInstanceId - app instance id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<manageAppsContextMenuActionParams>} LogObject<manageAppsContextMenuActionParams>
 */
export function manageAppsContextMenuAction(params) {
    return { evid: 96, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsDeletePendingAppClick' event (evid: 97)
 *
 * Event description: Manage Apps - Delete Pending App Click
 *
 * @param {manageAppsDeletePendingAppClickParams} params - The parameters for this event
 * @property {string} market - what market ? (editor, dashboard etc)
 * @property {GUID} appInstanceId - app instance id
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} appId - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<manageAppsDeletePendingAppClickParams>} LogObject<manageAppsDeletePendingAppClickParams>
 */
export function manageAppsDeletePendingAppClick(params) {
    return { evid: 97, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageAppsAddApp' event (evid: 98)
 *
 * Event description: Manage Apps - go back to market and add more apps.
 *
 * @param {manageAppsAddAppParams} params - The parameters for this event
 * @property {string} market - what market ? (editor, dashboard etc)
 * @property {string} referral_info - 'manage_apps' , 'finance_tab' etc
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - vertical
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<manageAppsAddAppParams>} LogObject<manageAppsAddAppParams>
 */
export function manageAppsAddApp(params) {
    return { evid: 98, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppImageGalleryInteraction' event (evid: 99)
 *
 * Event description: user browse through the apps image gallery
 *
 * @param {appMarketAppImageGalleryInteractionParams} params - The parameters for this event
 * @property {string} market - What market? (dashboard, editor, standalone etc)
 * @property {string} marketVersion - For new App Market version, what version of market this BI was sent from
 * @property {string} vertical - what is the site postreg? {general, online_store, music...}
 * @property {GUID} app_id - app id
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {string} action - "more" or "less" click
 * @return {LogObject<appMarketAppImageGalleryInteractionParams>} LogObject<appMarketAppImageGalleryInteractionParams>
 */
export function appMarketAppImageGalleryInteraction(params) {
    return { evid: 99, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppInstallationFailedClient' event (evid: 998)
 *
 * Event description: App Installation Failed , Client BI for rich data.
 *
 * @param {appMarketAppInstallationFailedClientParams} params - The parameters for this event
 * @property {string} market - editor, dashboard, adi, add-panel
 * @property {string} app_subcategory - what is the app sub-category of the category
 * @property {string} fail_reason - fail reason of installation
 * @property {string} vertical - vertical
 * @property {string} installType - What type of install? (API, App Builder, Share URL, normal, other)
 * @property {GUID} app_id - app_id
 * @property {string} tag_type - what is the type of app tag? category, collection etc
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - app instance id
 * @property {string} tag_name - what is the specific tag from which the app was installed from
 * @property {string} version_of_app - app version
 * @property {number} index - When apps are loaded on the screen for a user, what is the ranking order that the app was given
 * @property {boolean} in_context_view - true if the app was installed through “in context”, otherwise false
 * @property {string} context_tag_id - being reported only when the app installed from context, the context tag id is the tag id as it appears in the tag manager of the in context asset
 * @return {LogObject<appMarketAppInstallationFailedClientParams>} LogObject<appMarketAppInstallationFailedClientParams>
 */
export function appMarketAppInstallationFailedClient(params) {
    return { evid: 998, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppInstallationFailedServer' event (evid: 999)
 *
 * Event description: App Installation Failed , server side event.
 *
 * @param {appMarketAppInstallationFailedServerParams} params - The parameters for this event
 * @property {string} app_version - what is the app version
 * @property {string} fail_reason - What caused the installation to fail
 * @property {string} section - In which section is that app located?
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - app instance id
 * @return {LogObject<appMarketAppInstallationFailedServerParams>} LogObject<appMarketAppInstallationFailedServerParams>
 */
export function appMarketAppInstallationFailedServer(params) {
    return { evid: 999, src: 24, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorEvent' event (evid: 10)
 *
 * Event description: error event.
 *
 * @param {errorEventParams} params - The parameters for this event
 * @property {string} dsc - dsc
 * @property {number} response_time - Time in ms from load to error
 * @property {string} vsi - vsi
 * @property {boolean} is_rollout - is_rollout
 * @property {string} initiator_name - initiator_name
 * @property {string} builderType - builder_type
 * @property {string} errscp - error scope
 * @property {GUID} site_id - changed from did -> site_id on Oct 03, 2013
 * @property {string} errn - error name
 * @property {string} p4 - 4st extra parameter
 * @property {string} majorver - the major version of html editor
 * @property {string} trgt - target name, api call or class
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {number} ts - Time in ms from load to error
 * @property {string} playerVersion - player_version
 * @property {string} artifactVersion - artifact_version
 * @property {GUID} visitor_id - visitor_id
 * @property {number} usersOnPageCount - users_on_page_count
 * @property {string} viewmode - viewmode
 * @property {string} error_description_short - error_description_short
 * @property {string} data_center - data_center
 * @property {string} screenResolution - screen_resolution
 * @property {string} p3 - 3rd extra parameter
 * @property {GUID} did - changed from did -> site_id on Oct 03, 2013
 * @property {boolean} isSg - is_sg
 * @property {string} dsOrigin - ds_origin
 * @property {string} p2 - 2nd extra parameter
 * @property {string} token - token
 * @property {string} sessionId - session_id
 * @property {number} errc - error code
 * @property {string} stack - stacktrace
 * @property {string} viewerName - viewer_name
 * @property {GUID} uid - uuid
 * @property {string} app_id - app_id
 * @property {number} sev - severity of the error
 * @property {GUID} esi - esi
 * @property {number} cat - category id
 * @property {string} errormsg - dsc
 * @property {number} usersOnSiteCount - users_on_site_count
 * @property {string} p1 - 1st extra parameter
 * @property {GUID} msid - msid
 * @property {number} base_version - base_version
 * @property {number} iss - issue (sub-category)
 * @return {LogObject<errorEventParams>} LogObject<errorEventParams>
 */
export function errorEvent(params) {
    return { evid: 10, src: 60, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appBuilderPartLoadedInPublished' event (evid: 103)
 *
 * Event description: app builder -> part loaded in published.
 *
 * @param {appBuilderPartLoadedInPublishedParams} params - The parameters for this event
 * @property {GUID} site_id - site_id
 * @property {GUID} g2 - uuid
 * @property {string} c2 - part_id
 * @property {string} viewmode - viewmode
 * @property {string} c1 - app_id
 * @property {string} vsi - vsi
 * @property {GUID} uid - uuid
 * @property {Url} http_referrer - http_referrer
 * @property {GUID} esi - esi
 * @property {GUID} msid - msid
 * @return {LogObject<appBuilderPartLoadedInPublishedParams>} LogObject<appBuilderPartLoadedInPublishedParams>
 */
export function appBuilderPartLoadedInPublished(params) {
    return { evid: 103, src: 60, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appIntent' event (evid: 12)
 *
 * Event description: A user did an action that shows an intent to use a certain app.
 *
 * This event will be sent only once for each app by checking the site profile and making sure its the first time.
 *
 * @param {appIntentParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} appId - app_id
 * @property {string} reg_color - reg_color
 * @property {number} ts - ts
 * @property {string} viewmode - viewmode
 * @property {GUID} triggerAppId - the id of the app that triggered the intent (if exists)
 * @property {GUID} instanceid - instance_id
 * @property {GUID} ownerid - uuid
 * @property {string} installType - share url / app builder / appmarket /regular etc....
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} app_id - app_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} type - type of intent - add app / gfpp upgrade / gfpp settings / gfpp open bo / upgrade app button / manage app button / ADI checkbox / add section / add page...
 * @property {GUID} esi - esi
 * @property {string} extra_fields - extra_fields
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {string} initiator - where was the intent showed from - editor / dashboard / ADI / app market / transfer / duplicate
 * @return {LogObject<appIntentParams>} LogObject<appIntentParams>
 */
export function appIntent(params) {
    return { evid: 12, src: 75, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appEngagement' event (evid: 13)
 *
 * Event description: The event will indicate intent from an app (app indicates that a user has engaged it highly according to its internal parameters)
 *
 * @param {appEngagementParams} params - The parameters for this event
 * @property {number} ts - ts
 * @property {string} viewmode - viewmode
 * @property {number} intensity - Level of engagement (according to enum in SDK)
 * @property {string} premium_intent - Intent for Premium subscription (NEUTRAL / FREE / PREMIUM)
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} app_id - App Definition ID
 * @property {GUID} esi - esi
 * @property {GUID} msid - Meta Site ID
 * @property {GUID} instance_id - app instance id - unique per app per site
 * @return {LogObject<appEngagementParams>} LogObject<appEngagementParams>
 */
export function appEngagement(params) {
    return { evid: 13, src: 75, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppStatusChangedInSqlTable' event (evid: 1)
 *
 * Event description: An app status changed in the SQL server table. Contains 'from' and 'to'
 *
 * @param {devCenterAppStatusChangedInSqlTableParams} params - The parameters for this event
 * @property {string} toVersionNumber - new version number
 * @property {string} appType - app type
 * @property {string} toAppStatus - the new status
 * @property {GUID} appId - app id
 * @property {string} fromVersionNumber - previous version number
 * @property {string} fromAppStatus - the previous status
 * @return {LogObject<devCenterAppStatusChangedInSqlTableParams>} LogObject<devCenterAppStatusChangedInSqlTableParams>
 */
export function devCenterAppStatusChangedInSqlTable(params) {
    return { evid: 1, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterNewBusinessFormOpened' event (evid: 10)
 *
 * Event description: Developer opened a new business (company) form page.
 *
 * @param {devCenterNewBusinessFormOpenedParams} params - The parameters for this event
 * @return {LogObject<devCenterNewBusinessFormOpenedParams>} LogObject<devCenterNewBusinessFormOpenedParams>
 */
export function devCenterNewBusinessFormOpened(params) {
    return { evid: 10, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterHomepageOpenDevCenter' event (evid: 100)
 *
 * Event description: The user opened dev.wix homepage
 *
 * @param {devCenterHomepageOpenDevCenterParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {Url} referer - Identifies the address of the previous web page
 * @property {GUID} msid - msid
 * @return {LogObject<devCenterHomepageOpenDevCenterParams>} LogObject<devCenterHomepageOpenDevCenterParams>
 */
export function devCenterHomepageOpenDevCenter(params) {
    return { evid: 100, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCreated' event (evid: 1000)
 *
 * Event description: App Created in the dev center (a creation of a Blocks app also triggers the event). please note that between June 23 and Dec 23 it wasn't sent from the DevCenter new service (used by Blocks f.e)
 *
 * @param {appCreatedParams} params - The parameters for this event
 * @property {string} appClassification - API_KEYS, SITE_APP etc.
 * @property {string} appName - name of app given
 * @property {string} appStatus - app status: "created"
 * @property {GUID} appId - app id
 * @return {LogObject<appCreatedParams>} LogObject<appCreatedParams>
 */
export function appCreated(params) {
    return { evid: 1000, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'categoryCreated' event (evid: 1002)
 *
 * Event description: Category Created
 *
 * @param {categoryCreatedParams} params - The parameters for this event
 * @property {GUID} categoryId - category id
 * @property {string} categoryName - category name
 * @property {GUID} parentId - parent id
 * @return {LogObject<categoryCreatedParams>} LogObject<categoryCreatedParams>
 */
export function categoryCreated(params) {
    return { evid: 1002, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'componentCreated' event (evid: 1004)
 *
 * Event description: Component Created
 *
 * @param {componentCreatedParams} params - The parameters for this event
 * @property {string} compName - component name
 * @property {GUID} compId - component id
 * @property {string} comptType - component type
 * @property {GUID} appId - app id
 * @return {LogObject<componentCreatedParams>} LogObject<componentCreatedParams>
 */
export function componentCreated(params) {
    return { evid: 1004, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'componentUpdated' event (evid: 1005)
 *
 * Event description: Component Updated
 *
 * @param {componentUpdatedParams} params - The parameters for this event
 * @property {string} compName - component name
 * @property {GUID} compId - component id
 * @property {string} comptType - component type
 * @property {GUID} appId - app id
 * @return {LogObject<componentUpdatedParams>} LogObject<componentUpdatedParams>
 */
export function componentUpdated(params) {
    return { evid: 1005, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'componentDeleted' event (evid: 1007)
 *
 * Event description: Component Deleted
 *
 * @param {componentDeletedParams} params - The parameters for this event
 * @property {GUID} compId - component id
 * @property {GUID} appId - app id
 * @return {LogObject<componentDeletedParams>} LogObject<componentDeletedParams>
 */
export function componentDeleted(params) {
    return { evid: 1007, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listingInfoUpdated' event (evid: 1008)
 *
 * Event description: Listing Info Updated
 *
 * @param {listingInfoUpdatedParams} params - The parameters for this event
 * @property {string} name - name
 * @property {string} appName - what is the name of the app that was changed
 * @property {string} listing_changed_reason - what was changed in the market listing of the app? (name, description e.g)
 * @property {GUID} appId - app id
 * @return {LogObject<listingInfoUpdatedParams>} LogObject<listingInfoUpdatedParams>
 */
export function listingInfoUpdated(params) {
    return { evid: 1008, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMigrated' event (evid: 1009)
 *
 * Event description: App Migrated
 *
 * @param {appMigratedParams} params - The parameters for this event
 * @property {GUID} appId - app id
 * @return {LogObject<appMigratedParams>} LogObject<appMigratedParams>
 */
export function appMigrated(params) {
    return { evid: 1009, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOathClickOnPermissionCatalog' event (evid: 101)
 *
 * Event description: Click On Permission catalog
 *
 * @param {devCenterOathClickOnPermissionCatalogParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterOathClickOnPermissionCatalogParams>} LogObject<devCenterOathClickOnPermissionCatalogParams>
 */
export function devCenterOathClickOnPermissionCatalog(params) {
    return { evid: 101, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appUpdatedInAppStore' event (evid: 1010)
 *
 * Event description: App Updated In App Store
 *
 * @param {appUpdatedInAppStoreParams} params - The parameters for this event
 * @property {GUID} appId - app id
 * @return {LogObject<appUpdatedInAppStoreParams>} LogObject<appUpdatedInAppStoreParams>
 */
export function appUpdatedInAppStore(params) {
    return { evid: 1010, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appUpdatedInAppMarketApi' event (evid: 1011)
 *
 * Event description: App Updated In App Market API
 *
 * @param {appUpdatedInAppMarketApiParams} params - The parameters for this event
 * @property {GUID} appId - app id
 * @return {LogObject<appUpdatedInAppMarketApiParams>} LogObject<appUpdatedInAppMarketApiParams>
 */
export function appUpdatedInAppMarketApi(params) {
    return { evid: 1011, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionRegistered' event (evid: 1012)
 *
 * Event description: Permission Registered
 *
 * @param {permissionRegisteredParams} params - The parameters for this event
 * @property {string} permissionId - permission id
 * @property {GUID} appId - app id
 * @property {string} hostingPlatform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<permissionRegisteredParams>} LogObject<permissionRegisteredParams>
 */
export function permissionRegistered(params) {
    return { evid: 1012, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appUriUpdated' event (evid: 1013)
 *
 * Event description: App URI Updated
 *
 * @param {appUriUpdatedParams} params - The parameters for this event
 * @property {string} appUri - app uri
 * @property {GUID} appId - app id
 * @return {LogObject<appUriUpdatedParams>} LogObject<appUriUpdatedParams>
 */
export function appUriUpdated(params) {
    return { evid: 1013, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redirectUrisUpdated' event (evid: 1014)
 *
 * Event description: Redirect URIs Updated
 *
 * @param {redirectUrisUpdatedParams} params - The parameters for this event
 * @property {string} redirectUris - redirect_uris
 * @property {GUID} appId - app id
 * @return {LogObject<redirectUrisUpdatedParams>} LogObject<redirectUrisUpdatedParams>
 */
export function redirectUrisUpdated(params) {
    return { evid: 1014, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'permissionDeleted' event (evid: 1015)
 *
 * Event description: Permission Deleted
 *
 * @param {permissionDeletedParams} params - The parameters for this event
 * @property {string} permissionId - permission id
 * @property {GUID} appId - app id
 * @return {LogObject<permissionDeletedParams>} LogObject<permissionDeletedParams>
 */
export function permissionDeleted(params) {
    return { evid: 1015, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planCreated' event (evid: 1016)
 *
 * Event description: App Plan Created
 *
 * @param {planCreatedParams} params - The parameters for this event
 * @property {GUID} planId - app_plan_id
 * @property {GUID} appId - app id
 * @return {LogObject<planCreatedParams>} LogObject<planCreatedParams>
 */
export function planCreated(params) {
    return { evid: 1016, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planUpdated' event (evid: 1017)
 *
 * Event description: App Plan Updated
 *
 * @param {planUpdatedParams} params - The parameters for this event
 * @property {number} monthlyPrice - monthly USD when relevant (recurring)
 * @property {string} planBenefits - full list or paragraph
 * @property {number} oneTimePrice - price USD when relevant (one-time)
 * @property {string} pricingStructure - pricing structure when relevant (Dynamic)
 * @property {string} planType - plan type (one time, dynamic etc.)
 * @property {string} planName - plan name
 * @property {boolean} isMeteredBilling - is_metered_billing
 * @property {string} monthlyBaseFee - monthly_base_fee
 * @property {string} additionalInfo - additional_info
 * @property {number} freeTrialDays - free_trial_days
 * @property {string} planBenefitsFormat - list/paragraph
 * @property {string} productId - product id
 * @property {string} additionalCharges - additional_charges
 * @property {GUID} appId - app id
 * @property {string} businessModel - business_model
 * @property {GUID} planId - app_plan_id
 * @property {number} yearlyPrice - yearly USD when relevant (recurring)
 * @return {LogObject<planUpdatedParams>} LogObject<planUpdatedParams>
 */
export function planUpdated(params) {
    return { evid: 1017, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planDeleted' event (evid: 1018)
 *
 * Event description: App Plan Deleted
 *
 * @param {planDeletedParams} params - The parameters for this event
 * @property {GUID} planId - app_plan_id
 * @property {GUID} appId - app id
 * @return {LogObject<planDeletedParams>} LogObject<planDeletedParams>
 */
export function planDeleted(params) {
    return { evid: 1018, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureCreated' event (evid: 1019)
 *
 * Event description: Feature Created
 *
 * @param {featureCreatedParams} params - The parameters for this event
 * @property {string} featureName - feature name
 * @property {GUID} featureId - feature id
 * @property {GUID} appId - app id
 * @return {LogObject<featureCreatedParams>} LogObject<featureCreatedParams>
 */
export function featureCreated(params) {
    return { evid: 1019, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOathClickOnSearch' event (evid: 102)
 *
 * Event description: Click On filter by category
 *
 * @param {devCenterOathClickOnSearchParams} params - The parameters for this event
 * @property {string} search_term - search term
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathClickOnSearchParams>} LogObject<devCenterOathClickOnSearchParams>
 */
export function devCenterOathClickOnSearch(params) {
    return { evid: 102, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureUpdated' event (evid: 1020)
 *
 * Event description: Feature Updated
 *
 * @param {featureUpdatedParams} params - The parameters for this event
 * @property {string} featureName - feature name
 * @property {GUID} featureId - feature id
 * @property {GUID} appId - app id
 * @return {LogObject<featureUpdatedParams>} LogObject<featureUpdatedParams>
 */
export function featureUpdated(params) {
    return { evid: 1020, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureDeleted' event (evid: 1021)
 *
 * Event description: Feature Deleted
 *
 * @param {featureDeletedParams} params - The parameters for this event
 * @property {string} featureName - name
 * @property {GUID} featureId - feature id
 * @property {GUID} appId - app id
 * @return {LogObject<featureDeletedParams>} LogObject<featureDeletedParams>
 */
export function featureDeleted(params) {
    return { evid: 1021, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingModelCreated' event (evid: 1022)
 *
 * Event description: Pricing Model Created
 *
 * @param {pricingModelCreatedParams} params - The parameters for this event
 * @property {string} businessModel - business model
 * @property {GUID} appId - app id
 * @return {LogObject<pricingModelCreatedParams>} LogObject<pricingModelCreatedParams>
 */
export function pricingModelCreated(params) {
    return { evid: 1022, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingModelUpdated' event (evid: 1023)
 *
 * Event description: Pricing Model Updated
 *
 * @param {pricingModelUpdatedParams} params - The parameters for this event
 * @property {number} amountVisiblePlans - how many visible plans?
 * @property {boolean} isFreeTrial - boolean
 * @property {string} pricingPageType - (Wix pricing and checkout/External pricing page)
 * @property {boolean} isPremiumAndDomainOnly - boolean
 * @property {GUID} appId - app id
 * @property {string} businessModel - business model
 * @return {LogObject<pricingModelUpdatedParams>} LogObject<pricingModelUpdatedParams>
 */
export function pricingModelUpdated(params) {
    return { evid: 1023, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingModelDeleted' event (evid: 1024)
 *
 * Event description: Pricing Model Deleted
 *
 * @param {pricingModelDeletedParams} params - The parameters for this event
 * @property {GUID} appId - app id
 * @return {LogObject<pricingModelDeletedParams>} LogObject<pricingModelDeletedParams>
 */
export function pricingModelDeleted(params) {
    return { evid: 1024, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamMemberCreated' event (evid: 1025)
 *
 * Event description: Team Member Created
 *
 * @param {teamMemberCreatedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {string} role - role
 * @property {GUID} appId - app id
 * @return {LogObject<teamMemberCreatedParams>} LogObject<teamMemberCreatedParams>
 */
export function teamMemberCreated(params) {
    return { evid: 1025, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamMemberDeleted' event (evid: 1026)
 *
 * Event description: Team Member Deleted
 *
 * @param {teamMemberDeletedParams} params - The parameters for this event
 * @property {GUID} userId - user id
 * @property {GUID} appId - app id
 * @return {LogObject<teamMemberDeletedParams>} LogObject<teamMemberDeletedParams>
 */
export function teamMemberDeleted(params) {
    return { evid: 1026, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'teamMemberConfirmed' event (evid: 1027)
 *
 * Event description: Team Member Confirmed
 *
 * @param {teamMemberConfirmedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} appId - app id
 * @return {LogObject<teamMemberConfirmedParams>} LogObject<teamMemberConfirmedParams>
 */
export function teamMemberConfirmed(params) {
    return { evid: 1027, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pendingTeamMemberDeleted' event (evid: 1028)
 *
 * Event description: Pending Team Member Deleted
 *
 * @param {pendingTeamMemberDeletedParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} appId - app id
 * @return {LogObject<pendingTeamMemberDeletedParams>} LogObject<pendingTeamMemberDeletedParams>
 */
export function pendingTeamMemberDeleted(params) {
    return { evid: 1028, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'versionCreated' event (evid: 1029)
 *
 * Event description: Version Created
 *
 * @param {versionCreatedParams} params - The parameters for this event
 * @property {string} versionType - string e.g. MAJOR/MINOR/BUILD
 * @property {GUID} appId - app id
 * @return {LogObject<versionCreatedParams>} LogObject<versionCreatedParams>
 */
export function versionCreated(params) {
    return { evid: 1029, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'webhookDeleted' event (evid: 1032)
 *
 * Event description: Webhook Deleted
 *
 * @param {webhookDeletedParams} params - The parameters for this event
 * @property {string} webhookSlug - webhook slug
 * @property {string} event_name - Event's name
 * @property {boolean} is_wix_app - Is wix app?
 * @property {string} app_status - App's status
 * @property {string} category - Event's category
 * @property {GUID} appId - app id
 * @return {LogObject<webhookDeletedParams>} LogObject<webhookDeletedParams>
 */
export function webhookDeleted(params) {
    return { evid: 1032, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'staticArtifactUpdated' event (evid: 1033)
 *
 * Event description: App service listens for GA and StaticDeploy events of static artifacts and then updates tpeTemplateUrls
 *
 * @param {staticArtifactUpdatedParams} params - The parameters for this event
 * @property {string} templateUrls - Template urls of target artifact
 * @property {string} version - Target artifact deploy version
 * @property {GUID} appId - App Definition Id
 * @return {LogObject<staticArtifactUpdatedParams>} LogObject<staticArtifactUpdatedParams>
 */
export function staticArtifactUpdated(params) {
    return { evid: 1033, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterReviewsDropdownChoice' event (evid: 109)
 *
 * Event description: sort by dropdown
 *
 * @param {devCenterReviewsDropdownChoiceParams} params - The parameters for this event
 * @property {string} name - name of the drop down selected
 * @property {string} sort_by - sort by
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterReviewsDropdownChoiceParams>} LogObject<devCenterReviewsDropdownChoiceParams>
 */
export function devCenterReviewsDropdownChoice(params) {
    return { evid: 109, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterCreateNewAppClick' event (evid: 11)
 *
 * Event description: Triggered by clicking on 'create new app' button in 'my apps' page. The click opens a popover.
 *
 * @param {devCenterCreateNewAppClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterCreateNewAppClickParams>} LogObject<devCenterCreateNewAppClickParams>
 */
export function devCenterCreateNewAppClick(params) {
    return { evid: 11, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterStatsDisplayData' event (evid: 110)
 *
 * Event description: Dev Center -  Stats - Display Settings.
 *
 * @param {devCenterStatsDisplayDataParams} params - The parameters for this event
 * @property {number} time_interval - 1 = day , 7 = week, 30 = month
 * @property {string} tab - overview/details
 * @property {GUID} app_id - app id
 * @property {string} period - period of time
 * @return {LogObject<devCenterStatsDisplayDataParams>} LogObject<devCenterStatsDisplayDataParams>
 */
export function devCenterStatsDisplayData(params) {
    return { evid: 110, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDevelopmentSiteCreated' event (evid: 11001)
 *
 * Event description: Development Site Created
 *
 * @param {devCenterDevelopmentSiteCreatedParams} params - The parameters for this event
 * @property {number} numberOfDevSites - amount of dev sites of the user
 * @property {string} subDomain - sub_domain
 * @property {string} hostDomain - Host Domain of the created site
 * @property {string} userId - User ID
 * @property {string} metaSiteId - msid
 * @property {boolean} isWixStaff - is Wix employee
 * @return {LogObject<devCenterDevelopmentSiteCreatedParams>} LogObject<devCenterDevelopmentSiteCreatedParams>
 */
export function devCenterDevelopmentSiteCreated(params) {
    return { evid: 11001, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterApiCallToGetCurrentMember' event (evid: 112)
 *
 * Event description: Dev Center - API call to get current member.
 *
 * @param {devCenterApiCallToGetCurrentMemberParams} params - The parameters for this event
 * @property {string} customer_id - customer_id
 * @property {Url} article_url - article_url
 * @property {string} article_name - article_name
 * @property {GUID} app_id - app id
 * @property {GUID} msid - msid
 * @property {boolean} email_filled - email_filled
 * @return {LogObject<devCenterApiCallToGetCurrentMemberParams>} LogObject<devCenterApiCallToGetCurrentMemberParams>
 */
export function devCenterApiCallToGetCurrentMember(params) {
    return { evid: 112, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsClickOnSettingsButton' event (evid: 11200)
 *
 * Event description: Event is triggered when user has clicked on the 'settings' button to enter the settings menu
 *
 * @param {appSettingsClickOnSettingsButtonParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} element_type - e.g booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<appSettingsClickOnSettingsButtonParams>} LogObject<appSettingsClickOnSettingsButtonParams>
 */
export function appSettingsClickOnSettingsButton(params) {
    return { evid: 11200, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsNavigation' event (evid: 11201)
 *
 * Event description: Event is triggered when user has navigated using the side panel
 *
 * @param {editorAppSettingsNavigationParams} params - The parameters for this event
 * @property {string} from_tab - navigation origin
 * @property {string} to_tab - navigation destination
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsNavigationParams>} LogObject<editorAppSettingsNavigationParams>
 */
export function editorAppSettingsNavigation(params) {
    return { evid: 11201, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsExpandCollapseMenu' event (evid: 11202)
 *
 * Event description: Event is triggered when user has navigated to/from sub-menu screens
 *
 * @param {appSettingsExpandCollapseMenuParams} params - The parameters for this event
 * @property {string} sub_tab - the sub-menu tab
 * @property {string} tab - the tab (text/design...)
 * @property {string} click_type - enter/back
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<appSettingsExpandCollapseMenuParams>} LogObject<appSettingsExpandCollapseMenuParams>
 */
export function appSettingsExpandCollapseMenu(params) {
    return { evid: 11202, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsEditParameter' event (evid: 11203)
 *
 * Event description: Event is triggered when user made a change (saved or not) in a parameter.
 *
 * @param {editorAppSettingsEditParameterParams} params - The parameters for this event
 * @property {string} sub_tab - the sub-menu tab where parameter changed
 * @property {string} parameter_name - the parameter changed
 * @property {string} tab - the tab (main/display/text...)
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsEditParameterParams>} LogObject<editorAppSettingsEditParameterParams>
 */
export function editorAppSettingsEditParameter(params) {
    return { evid: 11203, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsSeeDashboardClick' event (evid: 11204)
 *
 * Event description: Event is triggered when user clicked on the 'see dashboard' button
 *
 * @param {editorAppSettingsSeeDashboardClickParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsSeeDashboardClickParams>} LogObject<editorAppSettingsSeeDashboardClickParams>
 */
export function editorAppSettingsSeeDashboardClick(params) {
    return { evid: 11204, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsAddOnAdded' event (evid: 11205)
 *
 * Event description: Event is triggered when user added an add-on in the modal window
 *
 * @param {editorAppSettingsAddOnAddedParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} element_type - click location booking-engine/search/availability
 * @property {string} add_on - the added add-on
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsAddOnAddedParams>} LogObject<editorAppSettingsAddOnAddedParams>
 */
export function editorAppSettingsAddOnAdded(params) {
    return { evid: 11205, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsResetDesign' event (evid: 11207)
 *
 * Event description: Event is triggered when user has clicked on 'reset to original design' button
 *
 * @param {editorAppSettingsResetDesignParams} params - The parameters for this event
 * @property {string} sub_tab - the sub-menu tab
 * @property {string} tab - the tab (text/design...)
 * @property {boolean} is_changed - Did the reset make any changes?
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsResetDesignParams>} LogObject<editorAppSettingsResetDesignParams>
 */
export function editorAppSettingsResetDesign(params) {
    return { evid: 11207, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsSupportClick' event (evid: 11208)
 *
 * Event description: Event is triggered when user clicked a support button
 *
 * @param {editorAppSettingsSupportClickParams} params - The parameters for this event
 * @property {string} tab - the tab (support/main...)
 * @property {string} click_type - contact-us/privacy-policy/dev-website/leave-review
 * @property {GUID} app_id - app_id
 * @property {string} element_type - booking-engine/search/availability
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsSupportClickParams>} LogObject<editorAppSettingsSupportClickParams>
 */
export function editorAppSettingsSupportClick(params) {
    return { evid: 11208, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorAppSettingsUpgradeClickInSidePanel' event (evid: 11210)
 *
 * Event description: Event is triggered when user clicked on the 'upgrade' button in the panel
 *
 * @param {editorAppSettingsUpgradeClickInSidePanelParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} element_type - element name (assigned by user)
 * @property {GUID} msid - msid
 * @return {LogObject<editorAppSettingsUpgradeClickInSidePanelParams>} LogObject<editorAppSettingsUpgradeClickInSidePanelParams>
 */
export function editorAppSettingsUpgradeClickInSidePanel(params) {
    return { evid: 11210, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookPublicKeyLearnMore' event (evid: 114)
 *
 * Event description: Public Key Learn More Click
 *
 * @param {devCenterWebhookPublicKeyLearnMoreParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterWebhookPublicKeyLearnMoreParams>} LogObject<devCenterWebhookPublicKeyLearnMoreParams>
 */
export function devCenterWebhookPublicKeyLearnMore(params) {
    return { evid: 114, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterTranslationClickOnTranslateAnItem' event (evid: 11404)
 *
 * Event description: Sent when user is clicking on Translate an Item in a language table
 *
 * @param {devCenterTranslationClickOnTranslateAnItemParams} params - The parameters for this event
 * @property {string} translation_status - the translated status as it appears in the table, f.e: translated/not translated/partially translated/missing required fields
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @return {LogObject<devCenterTranslationClickOnTranslateAnItemParams>} LogObject<devCenterTranslationClickOnTranslateAnItemParams>
 */
export function devCenterTranslationClickOnTranslateAnItem(params) {
    return { evid: 11404, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterTranslationClickOnActivateInactivateTranslationForAnItem' event (evid: 11405)
 *
 * Event description: Sent when user is clicking on Activate/Inactivate translation for an item in the language table
 *
 * @param {devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams} params - The parameters for this event
 * @property {string} translation_status - the translated status as it appears in the table, f.e: translated/not translated/partially translated/missing required fields
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @property {string} action - activate/inactivate
 * @return {LogObject<devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams>} LogObject<devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams>
 */
export function devCenterTranslationClickOnActivateInactivateTranslationForAnItem(params) {
    return { evid: 11405, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterTranslationTranslationWasSaved' event (evid: 11406)
 *
 * Event description: Sent when Translation of an Item/component was saved (when user clicked on save translation and it was successfully saved)
 *
 * @param {devCenterTranslationTranslationWasSavedParams} params - The parameters for this event
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @property {string} translated_fields - JSON when the key is the Form section and the values are a list of the fields the user filled in this form’s section. If there’s is no section like when the item is component send “General” as section F.e:{“Media”:[“images”,”label”,”youtube video url”],”Pricing Plans”:[“name”,”first benefit”]}
 * @return {LogObject<devCenterTranslationTranslationWasSavedParams>} LogObject<devCenterTranslationTranslationWasSavedParams>
 */
export function devCenterTranslationTranslationWasSaved(params) {
    return { evid: 11406, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenu' event (evid: 11408)
 *
 * Event description: Build Your App - Manage Extensions - when a user is clicking on action in more actions menu of specific component.
 *
 * @param {devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} action_name - edit extension/ delete/etc.
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams>} LogObject<devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams>
 */
export function devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenu(params) {
    return { evid: 11408, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletion' event (evid: 11409)
 *
 * Event description: Build Your App - Manage Extensions - when a user is clicking on 'delete' to delete extension in the extension's deletion modal (approve the deletion).
 *
 * @param {devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams>} LogObject<devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams>
 */
export function devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletion(params) {
    return { evid: 11409, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppClickOnCreateExtension' event (evid: 11412)
 *
 * Event description: In the Build Your App  - Extensions (Components) page - click on create extension to open Extensions Modal.
 * There are 2 possible origins: 'Create Extension' top button, 'Create Extension' empty state button.
 *
 * @param {devCenterBuildYourAppClickOnCreateExtensionParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} origin - top button/ empty state button
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterBuildYourAppClickOnCreateExtensionParams>} LogObject<devCenterBuildYourAppClickOnCreateExtensionParams>
 */
export function devCenterBuildYourAppClickOnCreateExtension(params) {
    return { evid: 11412, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnTabInTheDocumentationSidepanel' event (evid: 11413)
 *
 * Event description: In the JSON Editor  - click on a tab ('properties' tab or 'example' tab) in the documentation side panel.
 *
 * @param {devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams} params - The parameters for this event
 * @property {string} tab_name - properties/example
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams>} LogObject<devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams>
 */
export function devCenterJsonEditorClickOnTabInTheDocumentationSidepanel(params) {
    return { evid: 11413, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanel' event (evid: 11414)
 *
 * Event description: In the JSON Editor  - click on copy example in the documentation side panel.
 *
 * @param {devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams>} LogObject<devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams>
 */
export function devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanel(params) {
    return { evid: 11414, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsMoveAppToArchive' event (evid: 11415)
 *
 * Event description: User is approving the move of an app to archive in the move to archive modal
 *
 * @param {devCenterMyAppsMoveAppToArchiveParams} params - The parameters for this event
 * @property {string} last_update - the app last update date as it appears in My Apps page
 * @property {string} app_status - the app_status: DRAFT/SUBMITTED/PUBLISHED/DECLINED
 * @property {GUID} app_id - app id
 * @property {string} latest_version_status - the lastest app version status as it appears in My Apps page
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterMyAppsMoveAppToArchiveParams>} LogObject<devCenterMyAppsMoveAppToArchiveParams>
 */
export function devCenterMyAppsMoveAppToArchive(params) {
    return { evid: 11415, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfDevCenterWebhookPublicKeyOpen' event (evid: 115)
 *
 * Event description: Dev Center - Webhook - Public Key Open.
 *
 * @param {copyOfDevCenterWebhookPublicKeyOpenParams} params - The parameters for this event
 * @property {boolean} is_wix_app - is_wix_app
 * @property {string} app_status - app_status
 * @property {number} num_webhooks - how many webhooks currently exist in the subscriptions table?  (new from 04/23)
 * @property {GUID} app_id - app id
 * @return {LogObject<copyOfDevCenterWebhookPublicKeyOpenParams>} LogObject<copyOfDevCenterWebhookPublicKeyOpenParams>
 */
export function copyOfDevCenterWebhookPublicKeyOpen(params) {
    return { evid: 115, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksApiCategoryTypes' event (evid: 116)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on Add Webhook Button what API Category he chose and the type.
 *
 * @param {devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams} params - The parameters for this event
 * @property {string} api_category - Wix Stores, Marketing...
 * @property {boolean} is_wix_app - [DEPRECATE] is_wix_app
 * @property {string} app_status - [DEPRECATE] app_status
 * @property {GUID} app_id - app id
 * @property {string} type - name of the api that was selected (also known as event name)
 * @property {string} slug - slug
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams>} LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams>
 */
export function devCenterDashboardBuildYourAppWebhooksApiCategoryTypes(params) {
    return { evid: 116, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppReviewsAppScoreChanged' event (evid: 11600)
 *
 * Event description: App Score. when the app review score is changed, this event triggers.
 *
 * @param {devCenterAppReviewsAppScoreChangedParams} params - The parameters for this event
 * @property {string} rating_change_reason - why was the app rating changed
 * @property {number} old_rating - what is the app rating that was true until this even was sent? (multiplied by 100 due to format limitations)
 * @property {GUID} app_id - app_id
 * @property {number} new_rating - what is the new app rating that is now true?(multiplied by 100 due to format limitations)
 * @return {LogObject<devCenterAppReviewsAppScoreChangedParams>} LogObject<devCenterAppReviewsAppScoreChangedParams>
 */
export function devCenterAppReviewsAppScoreChanged(params) {
    return { evid: 11600, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devWixComHeaderTabClick' event (evid: 12)
 *
 * Event description: Click on one of the tabs in the header, dev.wix.com website.
 *
 * @param {devWixComHeaderTabClickParams} params - The parameters for this event
 * @property {string} tabName - which tab was clicked (e.g 'my_apps','documentation','api reference','app market')
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComHeaderTabClickParams>} LogObject<devWixComHeaderTabClickParams>
 */
export function devWixComHeaderTabClick(params) {
    return { evid: 12, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhooksLogsCopy' event (evid: 121)
 *
 * Event description: Webhooks- Logs - the user chose to copy instance id or to view payload
 *
 * @param {devCenterWebhooksLogsCopyParams} params - The parameters for this event
 * @property {string} event_name - Event's name
 * @property {boolean} is_wix_app - Is wix app?
 * @property {DateTime} time_sent - time sent
 * @property {string} response - response status
 * @property {string} app_status - App's status
 * @property {GUID} app_id - app id
 * @property {GUID} instance_id - instance_id
 * @property {string} action_type - The action the user did - Copy instance ID / View payload
 * @property {number} index - index - row number -from the top to the button (first row=0)
 * @return {LogObject<devCenterWebhooksLogsCopyParams>} LogObject<devCenterWebhooksLogsCopyParams>
 */
export function devCenterWebhooksLogsCopy(params) {
    return { evid: 121, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterRealTimeErrorMessageIsTriggered' event (evid: 12300)
 *
 * Event description: Being reported when a real-time error is appearing to users in the Dev Center. currently being sent only from Market Listing pages.
 *
 * @param {devCenterRealTimeErrorMessageIsTriggeredParams} params - The parameters for this event
 * @property {string} field - the field the error was triggered from, f.e: app name/teaser/feature 1/etc.
 * @property {string} error_content - please report the error message content in English
 * @property {string} section - the section the error was triggered from, f.e: basic information/app icon/ overview
 * @property {string} page_name - the Market Listing page the error was triggered from, f.e: app info/media/get found/app audience.
 * @property {string} app_id - the app id
 * @return {LogObject<devCenterRealTimeErrorMessageIsTriggeredParams>} LogObject<devCenterRealTimeErrorMessageIsTriggeredParams>
 */
export function devCenterRealTimeErrorMessageIsTriggered(params) {
    return { evid: 12300, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookPublicKeyClose' event (evid: 124)
 *
 * Event description: Webhook - Public Key Close
 *
 * @param {devCenterWebhookPublicKeyCloseParams} params - The parameters for this event
 * @property {boolean} is_wix_app - is_wix_app
 * @property {string} app_status - [DEPRECATE]  App status  (new from 04/23)
 * @property {GUID} app_id - app id
 * @property {string} action_type - what did the user chose to do with the public key? will get : Download / Copy key /  Done / Learn more  (new from 04/23)
 * @return {LogObject<devCenterWebhookPublicKeyCloseParams>} LogObject<devCenterWebhookPublicKeyCloseParams>
 */
export function devCenterWebhookPublicKeyClose(params) {
    return { evid: 124, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'developerCenterVersionSubmitted' event (evid: 13)
 *
 * Event description: Developer Center - Version Submitted
 *
 * @param {developerCenterVersionSubmittedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {string} displayVersion - string e.g 'V1'
 * @property {GUID} appId - app_id
 * @return {LogObject<developerCenterVersionSubmittedParams>} LogObject<developerCenterVersionSubmittedParams>
 */
export function developerCenterVersionSubmitted(params) {
    return { evid: 13, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookSentTriggered' event (evid: 1300)
 *
 * Event description: Dev Center - Webhook - Sent / Triggered
 *
 * @param {devCenterWebhookSentTriggeredParams} params - The parameters for this event
 * @property {GUID} instanceId - guid
 * @property {GUID} webhookId - guid
 * @property {string} url - url
 * @property {string} httpMethod - http method
 * @property {string} webhookEventType - webhook_event_type
 * @property {string} responseStatus - response_status
 * @property {string} topic - topic
 * @property {GUID} appId - app id
 * @property {string} originalTimestamp - originalTimestamp
 * @property {string} retryAttempt - retryAttempt
 * @property {string} statusCode - statusCode
 * @property {string} responseDuration - responseDuration
 * @property {string} kafkaEventId - unique identifier for each kafka attempt
 * @property {string} KafkaWebhookId - unique id to each webhook call (if there are 2 attempts - 2 row with this id)
 * @property {string} startHandlingTimestamp - start_handling_timestamp. when the webhook dispatcher started to work on the message
 * @return {LogObject<devCenterWebhookSentTriggeredParams>} LogObject<devCenterWebhookSentTriggeredParams>
 */
export function devCenterWebhookSentTriggered(params) {
    return { evid: 1300, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterStatsShowingDataCustomDates' event (evid: 135)
 *
 * Event description: Stats - Showing data Click Custom dates
 *
 * @param {devCenterStatsShowingDataCustomDatesParams} params - The parameters for this event
 * @property {string} tab - overview/settings
 * @property {string} end_date - end date
 * @property {GUID} app_id - app id
 * @property {string} startDate - start date
 * @return {LogObject<devCenterStatsShowingDataCustomDatesParams>} LogObject<devCenterStatsShowingDataCustomDatesParams>
 */
export function devCenterStatsShowingDataCustomDates(params) {
    return { evid: 135, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterVisitToWebhookLogger' event (evid: 139)
 *
 * Event description: User visits the webhook logger page
 *
 * @param {devCenterVisitToWebhookLoggerParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterVisitToWebhookLoggerParams>} LogObject<devCenterVisitToWebhookLoggerParams>
 */
export function devCenterVisitToWebhookLogger(params) {
    return { evid: 139, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'developerCenterSubmitFormOpened' event (evid: 14)
 *
 * Event description: Developer Center - Submit Form Opened
 *
 * @param {developerCenterSubmitFormOpenedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {string} displayVersion - string e.g 'V1'
 * @property {GUID} appId - app_id
 * @return {LogObject<developerCenterSubmitFormOpenedParams>} LogObject<developerCenterSubmitFormOpenedParams>
 */
export function developerCenterSubmitFormOpened(params) {
    return { evid: 14, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterChooseFilterInWebhookLogger' event (evid: 140)
 *
 * Event description: User filter the webhook logger page
 *
 * @param {devCenterChooseFilterInWebhookLoggerParams} params - The parameters for this event
 * @property {string} filter_type - what filter did the user chose?
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterChooseFilterInWebhookLoggerParams>} LogObject<devCenterChooseFilterInWebhookLoggerParams>
 */
export function devCenterChooseFilterInWebhookLogger(params) {
    return { evid: 140, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookHoverNotification' event (evid: 141)
 *
 * Event description: hover over webhook notification
 *
 * @param {devCenterWebhookHoverNotificationParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterWebhookHoverNotificationParams>} LogObject<devCenterWebhookHoverNotificationParams>
 */
export function devCenterWebhookHoverNotification(params) {
    return { evid: 141, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookSendMetadata' event (evid: 142)
 *
 * Event description: Dev Center - Webhook - Send Metadata
 *
 * @param {devCenterWebhookSendMetadataParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} webhook_deprecation_status - webhook_deprecation_status
 * @property {string} webhook_slug - webhook slug
 * @return {LogObject<devCenterWebhookSendMetadataParams>} LogObject<devCenterWebhookSendMetadataParams>
 */
export function devCenterWebhookSendMetadata(params) {
    return { evid: 142, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookOpenModalNewWebhook' event (evid: 143)
 *
 * Event description: Dev Center - Webhook - Open Modal
 *
 * @param {devCenterWebhookOpenModalNewWebhookParams} params - The parameters for this event
 * @property {string} webhook_slug - webhook slug
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterWebhookOpenModalNewWebhookParams>} LogObject<devCenterWebhookOpenModalNewWebhookParams>
 */
export function devCenterWebhookOpenModalNewWebhook(params) {
    return { evid: 143, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhookVersionAdded' event (evid: 144)
 *
 * Event description: Dev Center - Webhook - Click subscribe or cancel
 *
 * @param {devCenterWebhookVersionAddedParams} params - The parameters for this event
 * @property {string} callback_url - callback url  (new from 04/23)
 * @property {string} event_name - Event's name (new from 04/2023)
 * @property {boolean} is_wix_app - [DEPRECATE] is_wix_app
 * @property {string} permission_status - Has permission / Permission added: {chosen permission name} / Automatically added {added permission name}  (new from 04/23)
 * @property {string} origin - [DEPRECATE]
 * origin
 * @property {string} app_status - [DEPRECATE] app_status
 * @property {string} category - Event's category (new from 04/2023)
 * @property {GUID} app_id - app_id
 * @property {string} end_type - Subscribe / Cancel (new from 04/23)
 * @property {string} webhook_slug - webhook slug
 * @return {LogObject<devCenterWebhookVersionAddedParams>} LogObject<devCenterWebhookVersionAddedParams>
 */
export function devCenterWebhookVersionAdded(params) {
    return { evid: 144, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMoreInTestYourApp' event (evid: 146)
 *
 * Event description: The user clicks on 'Learn More' in the popover menu of 'Test Your App'.
 *
 * @param {devCenterDashboardClickOnLearnMoreInTestYourAppParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - Did the developer reach the number of test sites limit
 * @property {string} location - location
 * @property {boolean} has_wix_site - has_wix_site
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many sites does the developer already have
 * @return {LogObject<devCenterDashboardClickOnLearnMoreInTestYourAppParams>} LogObject<devCenterDashboardClickOnLearnMoreInTestYourAppParams>
 */
export function devCenterDashboardClickOnLearnMoreInTestYourApp(params) {
    return { evid: 146, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMoreInCreateSite' event (evid: 147)
 *
 * Event description: The user clicks on 'Learn More' in the modal window menu of 'Create Site'.
 *
 * @param {devCenterDashboardClickOnLearnMoreInCreateSiteParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - is_sites_limit
 * @property {string} location - the location of the click (main dashboard, Components section...)
 * @property {boolean} has_wix_site - has_wix_site
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - number_of_dev_sites
 * @return {LogObject<devCenterDashboardClickOnLearnMoreInCreateSiteParams>} LogObject<devCenterDashboardClickOnLearnMoreInCreateSiteParams>
 */
export function devCenterDashboardClickOnLearnMoreInCreateSite(params) {
    return { evid: 147, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardCreateSiteMenuClick' event (evid: 148)
 *
 * Event description: The developer clicks on one of the options on the modal window menu of the Create Development Site menu - Takes effect only when the developer hasn't reached sites limit
 *
 * @param {devCenterDashboardCreateSiteMenuClickParams} params - The parameters for this event
 * @property {string} location - location
 * @property {string} click_type - close/create site
 * @property {string} app_install_type - app_install_type
 * @property {boolean} has_wix_site - Does the user has any Wix site or not
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many dev sites does the user have
 * @return {LogObject<devCenterDashboardCreateSiteMenuClickParams>} LogObject<devCenterDashboardCreateSiteMenuClickParams>
 */
export function devCenterDashboardCreateSiteMenuClick(params) {
    return { evid: 148, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardClickOnTestYourApp' event (evid: 149)
 *
 * Event description: The User Clicks On test your app button from the dashboard or dashboard slide bar sections. (Doesn't overlap with event#52, only one event is triggered each time)
 *
 * @param {dashboardClickOnTestYourAppParams} params - The parameters for this event
 * @property {number} num_of_dev_sites - How many dev sites does the developer have
 * @property {string} location - location
 * @property {boolean} has_wix_site - Does the user has a Wix site or not
 * @property {GUID} app_id - app id
 * @return {LogObject<dashboardClickOnTestYourAppParams>} LogObject<dashboardClickOnTestYourAppParams>
 */
export function dashboardClickOnTestYourApp(params) {
    return { evid: 149, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'developerCenterNewBusinessCreated' event (evid: 15)
 *
 * Event description: Developer Center - New Business Created
 *
 * @param {developerCenterNewBusinessCreatedParams} params - The parameters for this event
 * @property {string} companySize - size of company
 * @property {string} industry - business type of company
 * @property {string} cameFrom - how did developer heard about us
 * @property {string} otherPlatforms - developer's experience with other services
 * @property {string} businessName - (deprecated) developer's name of business
 * @property {string} compIntent - developer's intent of business with wix
 * @property {GUID} compId - company (business) id
 * @property {boolean} termsAndConditions - (deprecated) terms and conditions
 * @return {LogObject<developerCenterNewBusinessCreatedParams>} LogObject<developerCenterNewBusinessCreatedParams>
 */
export function developerCenterNewBusinessCreated(params) {
    return { evid: 15, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterNavigationSideMenuClick' event (evid: 150)
 *
 * Event description: Triggered when user is clicking on navigation panel and the action is meaningful (page change, menu expand/collapse)
 *
 * @param {devCenterNavigationSideMenuClickParams} params - The parameters for this event
 * @property {string} click_type - page-change/expand-menu/collapse-menu
 * @property {GUID} uuid - uuid
 * @property {string} click_tag - navigation click title
 * @property {string} from_page - current page/tab
 * @property {string} app_id - app id
 * @return {LogObject<devCenterNavigationSideMenuClickParams>} LogObject<devCenterNavigationSideMenuClickParams>
 */
export function devCenterNavigationSideMenuClick(params) {
    return { evid: 150, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newFreeTrialNotificationClickOnDiscoverFreeTrialCloseSrc96Evid151' event (evid: 151)
 *
 * Event description: user clicks on 'discover free trial'/ 'close' in "New Free Trial" notification
 *
 * @param {newFreeTrialNotificationClickOnDiscoverFreeTrialCloseSrc96Evid151Params} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} cta - discover_free_trial/close
 * @return {LogObject<newFreeTrialNotificationClickOnDiscoverFreeTrialCloseSrc96Evid151Params>} LogObject<newFreeTrialNotificationClickOnDiscoverFreeTrialCloseSrc96Evid151Params>
 */
export function newFreeTrialNotificationClickOnDiscoverFreeTrialCloseSrc96Evid151(params) {
    return { evid: 151, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppSubmissionPopUpAction' event (evid: 152)
 *
 * Event description: Triggered when user is clicking on the blockers/recommendations actions
 *
 * @param {devCenterAppSubmissionPopUpActionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app id
 * @property {string} tag_type - oAuth, missing logo etc.
 * @property {string} action_type - fix, dismiss etc.
 * @return {LogObject<devCenterAppSubmissionPopUpActionParams>} LogObject<devCenterAppSubmissionPopUpActionParams>
 */
export function devCenterAppSubmissionPopUpAction(params) {
    return { evid: 152, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPublishYourAppContactInfoUpdated' event (evid: 155)
 *
 * Event description: Contact info edited and saved
 *
 * @param {devCenterPublishYourAppContactInfoUpdatedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterPublishYourAppContactInfoUpdatedParams>} LogObject<devCenterPublishYourAppContactInfoUpdatedParams>
 */
export function devCenterPublishYourAppContactInfoUpdated(params) {
    return { evid: 155, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsDownloadData' event (evid: 159)
 *
 * Event description: The user downloaded the data
 *
 * @param {devCenterPayoutsDownloadDataParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutsDownloadDataParams>} LogObject<devCenterPayoutsDownloadDataParams>
 */
export function devCenterPayoutsDownloadData(params) {
    return { evid: 159, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devWixComActionButtonClick' event (evid: 16)
 *
 * Event description: Click on 'Get Started' Button, dev.wix.com website
 *
 * @param {devWixComActionButtonClickParams} params - The parameters for this event
 * @property {string} button_name - e.g : get_started_upper , get_started_lower , explore_appmarket
 * @return {LogObject<devWixComActionButtonClickParams>} LogObject<devWixComActionButtonClickParams>
 */
export function devWixComActionButtonClick(params) {
    return { evid: 16, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsClickToViewTransactions' event (evid: 160)
 *
 * Event description: The user navigate to transactions by clicking on the bar chart
 *
 * @param {devCenterPayoutsClickToViewTransactionsParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutsClickToViewTransactionsParams>} LogObject<devCenterPayoutsClickToViewTransactionsParams>
 */
export function devCenterPayoutsClickToViewTransactions(params) {
    return { evid: 160, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsSetDataRangeFilter' event (evid: 161)
 *
 * Event description: The user set a preferred date range (start month) for transactions view
 *
 * @param {devCenterPayoutsSetDataRangeFilterParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {DateTime} start_time - month-year
 * @return {LogObject<devCenterPayoutsSetDataRangeFilterParams>} LogObject<devCenterPayoutsSetDataRangeFilterParams>
 */
export function devCenterPayoutsSetDataRangeFilter(params) {
    return { evid: 161, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingListingUpdated' event (evid: 164)
 *
 * Event description: The user saved the listing after he made changes.
 *
 * @param {devCenterMarketListingListingUpdatedParams} params - The parameters for this event
 * @property {string} fields_updated - the fields the user updated and save separeted by commas. f.e:
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @property {GUID} app_id - app_id
 * @property {string} sections_updated - the sections the user updated and save separated by commas, For example: basic information,app icon,overview
 * @property {string} gtag_id - Google Tag ID
 * @return {LogObject<devCenterMarketListingListingUpdatedParams>} LogObject<devCenterMarketListingListingUpdatedParams>
 */
export function devCenterMarketListingListingUpdated(params) {
    return { evid: 164, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingClickOnPreviewListing' event (evid: 165)
 *
 * Event description: The user clicked on preview listing
 *
 * @param {devCenterMarketListingClickOnPreviewListingParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @return {LogObject<devCenterMarketListingClickOnPreviewListingParams>} LogObject<devCenterMarketListingClickOnPreviewListingParams>
 */
export function devCenterMarketListingClickOnPreviewListing(params) {
    return { evid: 165, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingClickOnWixLogoMakerLink' event (evid: 166)
 *
 * Event description: The user saved the listing after he made changes.
 *
 * @param {devCenterMarketListingClickOnWixLogoMakerLinkParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @return {LogObject<devCenterMarketListingClickOnWixLogoMakerLinkParams>} LogObject<devCenterMarketListingClickOnWixLogoMakerLinkParams>
 */
export function devCenterMarketListingClickOnWixLogoMakerLink(params) {
    return { evid: 166, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickOnAddPlanButton' event (evid: 167)
 *
 * Event description: The user clicked on 'add plan'
 *
 * @param {devCenterPricingClickOnAddPlanButtonParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingClickOnAddPlanButtonParams>} LogObject<devCenterPricingClickOnAddPlanButtonParams>
 */
export function devCenterPricingClickOnAddPlanButton(params) {
    return { evid: 167, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickToSaveNewPlan' event (evid: 168)
 *
 * Event description: The user clicked on 'add plan' to save new plan
 *
 * @param {devCenterPricingClickToSaveNewPlanParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {number} monthly_price - monthly USD when relevant (recurring)
 * @property {string} plan_name - Plan name
 * @property {number} yearly_price - yearly USD when relevant (recurring)
 * @property {number} one_time_price - price USD when relevant (one-time)
 * @property {string} plan_type - plan type (one time, dynamic etc.)
 * @property {string} plan_benefits_format - list/paragraph
 * @property {string} product_id - product id
 * @property {GUID} app_id - app_id
 * @property {string} plan_benefits - full list or paragraph
 * @property {string} pricing_structure - pricing structure when relevant (Dynamic)
 * @return {LogObject<devCenterPricingClickToSaveNewPlanParams>} LogObject<devCenterPricingClickToSaveNewPlanParams>
 */
export function devCenterPricingClickToSaveNewPlan(params) {
    return { evid: 168, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickOnEditPlan' event (evid: 169)
 *
 * Event description: The user clicked on the button that opens the edit modal
 *
 * @param {devCenterPricingClickOnEditPlanParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type (dynamic etc.)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingClickOnEditPlanParams>} LogObject<devCenterPricingClickOnEditPlanParams>
 */
export function devCenterPricingClickOnEditPlan(params) {
    return { evid: 169, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devWixComAccountProfileHover' event (evid: 17)
 *
 * Event description: Hover over profile's account name or avatar on the top right corner, dev.wix.com website.
 *
 * @param {devWixComAccountProfileHoverParams} params - The parameters for this event
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComAccountProfileHoverParams>} LogObject<devWixComAccountProfileHoverParams>
 */
export function devWixComAccountProfileHover(params) {
    return { evid: 17, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingEditPlanSaved' event (evid: 170)
 *
 * Event description: Actual delete. User clicked on red button
 *
 * @param {devCenterPricingEditPlanSavedParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type - payment (dynamic, recurring etc.)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingEditPlanSavedParams>} LogObject<devCenterPricingEditPlanSavedParams>
 */
export function devCenterPricingEditPlanSaved(params) {
    return { evid: 170, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingNavigateToPricingPage' event (evid: 171)
 *
 * Event description: The user clicked on "customize your pricing page"
 *
 * @param {devCenterPricingNavigateToPricingPageParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingNavigateToPricingPageParams>} LogObject<devCenterPricingNavigateToPricingPageParams>
 */
export function devCenterPricingNavigateToPricingPage(params) {
    return { evid: 171, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageClickOnAddPlanFeature' event (evid: 172)
 *
 * Event description: The user clicked on 'add plan feature'
 *
 * @param {devCenterPricingPricingPageClickOnAddPlanFeatureParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type
 * @property {string} feature_name - feature name saved
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingPricingPageClickOnAddPlanFeatureParams>} LogObject<devCenterPricingPricingPageClickOnAddPlanFeatureParams>
 */
export function devCenterPricingPricingPageClickOnAddPlanFeature(params) {
    return { evid: 172, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppBoxClick' event (evid: 173)
 *
 * Event description: Triggered by clicking on an app in 'my apps' page
 *
 * @param {devCenterAppBoxClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} installations_num - number of installations as it appears in My Apps page
 * @property {string} last_update - the app last update date as it appears in My Apps page
 * @property {string} app_status - app status as it appears in My Apps page: Published/Draft/Submitted/etc.
 * @property {GUID} app_id - app_id
 * @property {string} app_rating - app rating as it appears in My Apps page
 * @property {string} latest_version_status - the lastest app version status as it appears in My Apps page
 * @property {string} click_type - edit-cta, row-level-click
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterAppBoxClickParams>} LogObject<devCenterAppBoxClickParams>
 */
export function devCenterAppBoxClick(params) {
    return { evid: 173, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterHeaderNavigationClick' event (evid: 174)
 *
 * Event description: Triggered by clicking on a link in the top navigation bar
 *
 * @param {devCenterHeaderNavigationClickParams} params - The parameters for this event
 * @property {string} link_name - link name
 * @property {GUID} uuid - uuid
 * @return {LogObject<devCenterHeaderNavigationClickParams>} LogObject<devCenterHeaderNavigationClickParams>
 */
export function devCenterHeaderNavigationClick(params) {
    return { evid: 174, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppsReviewsDeleteReply' event (evid: 175)
 *
 * Event description: User deleted a reply to a review
 *
 * @param {devCenterManageYourAppsReviewsDeleteReplyParams} params - The parameters for this event
 * @property {GUID} reply_id - reply id
 * @property {number} app_review_score - # of stars of the review
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppsReviewsDeleteReplyParams>} LogObject<devCenterManageYourAppsReviewsDeleteReplyParams>
 */
export function devCenterManageYourAppsReviewsDeleteReply(params) {
    return { evid: 175, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingSavePricingSettings' event (evid: 176)
 *
 * Event description: user click 'save' in the pricing main page
 *
 * @param {devCenterPricingSavePricingSettingsParams} params - The parameters for this event
 * @property {boolean} is_free_trial - boolean
 * @property {string} pricing_page_type - (Wix pricing and checkout/External pricing page)
 * @property {string} business_model - Freemium, Premium etc.
 * @property {string} app_id - app id
 * @property {number} amount_visible_plans - how many visible plans?
 * @property {boolean} is_premium_and_domain_only - App is only available for sites with a Wix Premium plan and a domain
 * @property {number} free_trial_days - number of free trial days
 * @return {LogObject<devCenterPricingSavePricingSettingsParams>} LogObject<devCenterPricingSavePricingSettingsParams>
 */
export function devCenterPricingSavePricingSettings(params) {
    return { evid: 176, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageFeatureSave' event (evid: 177)
 *
 * Event description: user clicks on 'save' a new or existing feature
 *
 * @param {devCenterPricingPricingPageFeatureSaveParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} feature_name - feature name
 * @property {string} app_id - app id
 * @property {string} action_type - new,edit
 * @return {LogObject<devCenterPricingPricingPageFeatureSaveParams>} LogObject<devCenterPricingPricingPageFeatureSaveParams>
 */
export function devCenterPricingPricingPageFeatureSave(params) {
    return { evid: 177, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageFeatureDeleted' event (evid: 178)
 *
 * Event description: user deletes a feature
 *
 * @param {devCenterPricingPricingPageFeatureDeletedParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} feature_name - feature name
 * @property {string} app_id - app id
 * @return {LogObject<devCenterPricingPricingPageFeatureDeletedParams>} LogObject<devCenterPricingPricingPageFeatureDeletedParams>
 */
export function devCenterPricingPricingPageFeatureDeleted(params) {
    return { evid: 178, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageClickOnPreviewPage' event (evid: 179)
 *
 * Event description: user clicks on 'preview pricing page'
 *
 * @param {devCenterPricingPricingPageClickOnPreviewPageParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterPricingPricingPageClickOnPreviewPageParams>} LogObject<devCenterPricingPricingPageClickOnPreviewPageParams>
 */
export function devCenterPricingPricingPageClickOnPreviewPage(params) {
    return { evid: 179, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devWixComAccountProfileMenuClick' event (evid: 18)
 *
 * Event description: After Hovering over account profile , clicking on menu option, dev.wix.com website.
 *
 * @param {devWixComAccountProfileMenuClickParams} params - The parameters for this event
 * @property {string} menuClick - menu click name ( 'developer account', 'log out')
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComAccountProfileMenuClickParams>} LogObject<devWixComAccountProfileMenuClickParams>
 */
export function devWixComAccountProfileMenuClick(params) {
    return { evid: 18, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsButtonClick' event (evid: 180)
 *
 * Event description: Triggered by clicking on UI buttons in 'my apps' page. Used for 'create new app' CTA
 *
 * @param {devCenterMyAppsButtonClickParams} params - The parameters for this event
 * @property {string} location - location of the button (context)
 * @property {GUID} uuid - uuid
 * @property {string} button_name - the name of the button (with additional context if needed)
 * @property {string} cta_name - name of the action
 * @property {GUID} app_id - app id
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @return {LogObject<devCenterMyAppsButtonClickParams>} LogObject<devCenterMyAppsButtonClickParams>
 */
export function devCenterMyAppsButtonClick(params) {
    return { evid: 180, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOneTimePublishHelperPopupIsShownSrc96Evid181' event (evid: 181)
 *
 * Event description: When the "one time publish helper" popup is shown
 *
 * @param {devCenterOneTimePublishHelperPopupIsShownSrc96Evid181Params} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} page_name - the page where the popup is shown
 * @property {string} action_required - submit/publish (the action the user need to perform in order to save the changes)
 * @return {LogObject<devCenterOneTimePublishHelperPopupIsShownSrc96Evid181Params>} LogObject<devCenterOneTimePublishHelperPopupIsShownSrc96Evid181Params>
 */
export function devCenterOneTimePublishHelperPopupIsShownSrc96Evid181(params) {
    return { evid: 181, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionCopySrc96Evid182' event (evid: 182)
 *
 * Event description: In the  Build Your App  - Permissions page when the user clicks on 'Save'
 *
 * @param {devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionCopySrc96Evid182Params} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {string} scope_list - all the scopes that were added
 * @property {string} uuid - user id
 * @property {string} platform - platform
 * @return {LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionCopySrc96Evid182Params>} LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionCopySrc96Evid182Params>
 */
export function devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionCopySrc96Evid182(params) {
    return { evid: 182, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppActionsModalLoadedSrc96Evid183' event (evid: 183)
 *
 * Event description: Modal loaded in dev center 'my apps' or app's 'homepage'
 *
 * @param {devCenterAppActionsModalLoadedSrc96Evid183Params} params - The parameters for this event
 * @property {string} modal_name - name of the modal
 * @property {GUID} app_id - app_id
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @property {string} route - the page's route (from URL)
 * @return {LogObject<devCenterAppActionsModalLoadedSrc96Evid183Params>} LogObject<devCenterAppActionsModalLoadedSrc96Evid183Params>
 */
export function devCenterAppActionsModalLoadedSrc96Evid183(params) {
    return { evid: 183, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsModalCtaClickSrc96Evid184' event (evid: 184)
 *
 * Event description: User clicked on CTA in a modal that is loaded from my apps
 *
 * @param {devCenterMyAppsModalCtaClickSrc96Evid184Params} params - The parameters for this event
 * @property {string} modal_name - name of the modal
 * @property {GUID} app_id - app_id
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @property {string} cta_name - name of the CTA
 * @property {string} to_url - the url of the destination
 * @property {string} route - the page's route (from URL)
 * @return {LogObject<devCenterMyAppsModalCtaClickSrc96Evid184Params>} LogObject<devCenterMyAppsModalCtaClickSrc96Evid184Params>
 */
export function devCenterMyAppsModalCtaClickSrc96Evid184(params) {
    return { evid: 184, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleSaleWasAddedSuccessfullyInTheDevCenterSrc96Evid187' event (evid: 187)
 *
 * Event description: when a a sale was added successfully to the Sales page in the DevCenter
 *
 * @param {appMarketSaleSaleWasAddedSuccessfullyInTheDevCenterSrc96Evid187Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} sale_name - The name of the sale as it appears in the basic info
 * @property {number} discount_percentage - The discount the dev chose: 20/30/40/50 (integer)
 * @property {string} pricing_plans - The plans the sale apply to
 * @property {string} monthly_charge - First month/12 months/etc.
 * @property {string} cycle_billing - the billing cycle: yearly/monthly/yearly and monthly
 * @property {string} sale_status - the status of the sale, f.e: f.e: scheduled sale
 * @property {string} save_type - 'first save' if it's the first time the user save this sale/ 'update' when it's an update of existing sale
 * @property {string} valid_from_date - the date the sale valid from
 * @property {string} valid_until_date - the date the sale valid until
 * @return {LogObject<appMarketSaleSaleWasAddedSuccessfullyInTheDevCenterSrc96Evid187Params>} LogObject<appMarketSaleSaleWasAddedSuccessfullyInTheDevCenterSrc96Evid187Params>
 */
export function appMarketSaleSaleWasAddedSuccessfullyInTheDevCenterSrc96Evid187(params) {
    return { evid: 187, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleClickOnSalesQuickActionIn3DotsMenuSrc96Evid188' event (evid: 188)
 *
 * Event description: when a user (developer) is clicking on sale’s quick action (in the 3 dots menu). action could be: edit/delete/opt out.
 *
 * @param {appMarketSaleClickOnSalesQuickActionIn3DotsMenuSrc96Evid188Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} action_name - edit/delete/opt out
 * @return {LogObject<appMarketSaleClickOnSalesQuickActionIn3DotsMenuSrc96Evid188Params>} LogObject<appMarketSaleClickOnSalesQuickActionIn3DotsMenuSrc96Evid188Params>
 */
export function appMarketSaleClickOnSalesQuickActionIn3DotsMenuSrc96Evid188(params) {
    return { evid: 188, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleApproveSalesQuickActionSrc96Evid189' event (evid: 189)
 *
 * Event description: when a user (developer) is clicking on Approve sale’s quick action in the DevCenter Sales page
 *
 * @param {appMarketSaleApproveSalesQuickActionSrc96Evid189Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} sale_name - The name of the sale as it appears in the basic info
 * @property {number} discount_percentage - The discount the dev chose: 20/30/40/50 (integer)
 * @property {string} pricing_plans - The plans the sale apply to
 * @property {string} action_name - delete/ opt out
 * @property {string} upgrades_count - The number of upgrades were purchased through the sale
 * @property {string} valid_from_date - the date the sale valid from
 * @property {string} valid_until_date - the date the sale valid until
 * @return {LogObject<appMarketSaleApproveSalesQuickActionSrc96Evid189Params>} LogObject<appMarketSaleApproveSalesQuickActionSrc96Evid189Params>
 */
export function appMarketSaleApproveSalesQuickActionSrc96Evid189(params) {
    return { evid: 189, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPricingSavePricingSettingsCopySrc96Evid19' event (evid: 19)
 *
 * Event description: user click 'save' in the pricing main page
 *
 * @param {devCenterPricingSavePricingSettingsCopySrc96Evid19Params} params - The parameters for this event
 * @property {boolean} is_free_trial - boolean
 * @property {string} pricing_page_type - (Wix pricing and checkout/External pricing page)
 * @property {string} business_model - Freemium, Premium etc.
 * @property {string} app_id - app id
 * @property {number} amount_visible_plans - how many visible plans?
 * @property {boolean} is_premium_and_domain_only - App is only available for sites with a Wix Premium plan and a domain
 * @property {number} free_trial_days - the number of free trial days
 * @return {LogObject<devCenterPricingSavePricingSettingsCopySrc96Evid19Params>} LogObject<devCenterPricingSavePricingSettingsCopySrc96Evid19Params>
 */
export function devCenterPricingSavePricingSettingsCopySrc96Evid19(params) {
    return { evid: 19, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleClickOnFillDetailsToJoinWixSaleSrc96Evid190' event (evid: 190)
 *
 * Event description: Click On Learn More on Any Page
 *
 * @param {appMarketSaleClickOnFillDetailsToJoinWixSaleSrc96Evid190Params} params - The parameters for this event
 * @property {string} target_url - target url of the kb
 * @property {string} app_id - app id
 * @property {string} action_name - f.e: 'fill out details'
 * @return {LogObject<appMarketSaleClickOnFillDetailsToJoinWixSaleSrc96Evid190Params>} LogObject<appMarketSaleClickOnFillDetailsToJoinWixSaleSrc96Evid190Params>
 */
export function appMarketSaleClickOnFillDetailsToJoinWixSaleSrc96Evid190(params) {
    return { evid: 190, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterComponentSExperimentStatusUpdate' event (evid: 1900)
 *
 * Event description: triggers when a connection of extension to experiment (petri spec) was created/updated/deleted in the server. the status field is reflecting the status of the experiment.
 *
 * @param {devCenterComponentSExperimentStatusUpdateParams} params - The parameters for this event
 * @property {number} minConductedVersion - the minimum version that will  be conducted when the experiment eill be open
 * @property {string} appStatus - the status of the app when the action occured: published/draft/etc.
 * @property {string} componentId - the component id
 * @property {string} variantValue - the variant value as it defined in petri
 * @property {string} spec - the spec of the experiment
 * @property {GUID} appId - the app id of the app created/updated/deleted the experiment
 * @property {string} experimentState - The status of the experiment: created/ updated/ deleted
 * @return {LogObject<devCenterComponentSExperimentStatusUpdateParams>} LogObject<devCenterComponentSExperimentStatusUpdateParams>
 */
export function devCenterComponentSExperimentStatusUpdate(params) {
    return { evid: 1900, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleClickOnCreateNewSaleInTheDevCenterSalesPageSrc96Evid191' event (evid: 191)
 *
 * Event description: when a user (developer) is clicking  on Create new Sale in the Dev Center Sales page
 *
 * @param {appMarketSaleClickOnCreateNewSaleInTheDevCenterSalesPageSrc96Evid191Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @return {LogObject<appMarketSaleClickOnCreateNewSaleInTheDevCenterSalesPageSrc96Evid191Params>} LogObject<appMarketSaleClickOnCreateNewSaleInTheDevCenterSalesPageSrc96Evid191Params>
 */
export function appMarketSaleClickOnCreateNewSaleInTheDevCenterSalesPageSrc96Evid191(params) {
    return { evid: 191, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppDistributionCtaClickSrc96Evid193' event (evid: 193)
 *
 * Event description: Clicks in App Distribution Page
 *
 * @param {devCenterAppDistributionCtaClickSrc96Evid193Params} params - The parameters for this event
 * @property {GUID} appId - app_id
 * @property {string} section - the section/widget where the Call to Action (CTA) is located
 * @property {string} to_page_name - The destination page
 * @property {string} to_url - the destination url (internal and external)
 * @property {string} cta_name - The name of the cta click
 * @return {LogObject<devCenterAppDistributionCtaClickSrc96Evid193Params>} LogObject<devCenterAppDistributionCtaClickSrc96Evid193Params>
 */
export function devCenterAppDistributionCtaClickSrc96Evid193(params) {
    return { evid: 193, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterVersionsModalLoadedSrc96Evid197' event (evid: 197)
 *
 * Event description: Release Version Modal Loaded
 *
 * @param {devCenterVersionsModalLoadedSrc96Evid197Params} params - The parameters for this event
 * @property {string} modal_name - name of the modal
 * @property {GUID} app_id - app_id
 * @property {string} release_type_options - minor, major, minor or major
 * @property {string} release_modal_type - cli/blocks/self hosted
 * @property {string} from_version - the current version as presented in the modal
 * @property {string} route - route (from page url)
 * @property {string} intent - intent (flow state)
 * @return {LogObject<devCenterVersionsModalLoadedSrc96Evid197Params>} LogObject<devCenterVersionsModalLoadedSrc96Evid197Params>
 */
export function devCenterVersionsModalLoadedSrc96Evid197(params) {
    return { evid: 197, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createShareUrl' event (evid: 2)
 *
 * Event description: Link created - The event will be sent from the server once the short link is created.
 *
 * @param {createShareUrlParams} params - The parameters for this event
 * @property {string} url - Share url
 * @property {GUID} appId - app id
 * @return {LogObject<createShareUrlParams>} LogObject<createShareUrlParams>
 */
export function createShareUrl(params) {
    return { evid: 2, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTemplatesPageLoaded' event (evid: 200)
 *
 * Event description: Triggered by any load of a page/modal.
 *
 * @param {appTemplatesPageLoadedParams} params - The parameters for this event
 * @property {string} to_url - The URL of the page where the click is send the user to
 * @property {string} page_title - The title of the page
 * @property {string} from_url - The URL of the page where the click is located
 * @property {string} page_name - The name of the page/modal
 * @property {string} page_type - Page or modal
 * @return {LogObject<appTemplatesPageLoadedParams>} LogObject<appTemplatesPageLoadedParams>
 */
export function appTemplatesPageLoaded(params) {
    return { evid: 200, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterCouponCreation' event (evid: 2001)
 *
 * Event description: Dev Center - Coupon Creation.
 *
 * @param {devCenterCouponCreationParams} params - The parameters for this event
 * @property {string} discountType - amount / percent
 * @property {number} discountValue - value: 10\ 20 ....
 * @property {boolean} testing - yes / no
 * @property {GUID} assignedToUserId - what is the uuid that received the coupon
 * @property {string} cycleName - monthly, yearly
 * @property {number} useCount - the number of the issued coupon
 * @property {string} currency - currency
 * @property {number} useLimit - the max issued coupons
 * @property {string} couponType - type of coupon
 * @property {string} appId - app id
 * @property {number} numberOfDays - number of days the coupon can be use
 * @property {string} couponId - coupon_id
 * @return {LogObject<devCenterCouponCreationParams>} LogObject<devCenterCouponCreationParams>
 */
export function devCenterCouponCreation(params) {
    return { evid: 2001, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTemplatesUserClicked' event (evid: 201)
 *
 * Event description: Triggered by UI clicks in 'App Templates' environment.
 *
 * @param {appTemplatesUserClickedParams} params - The parameters for this event
 * @property {string} click_name - The name of the action or destination
 * @property {string} click_type - What does the click do?
 * @property {string} guid_type - The id type of relevant  the entity (template_id,app_id)
 * @property {string} to_url - The URL of the page where the click is send the user to
 * @property {string} from_url - The URL of the page where the click is located
 * @property {GUID} guid_value - The id  of relevant  the entity
 * @return {LogObject<appTemplatesUserClickedParams>} LogObject<appTemplatesUserClickedParams>
 */
export function appTemplatesUserClicked(params) {
    return { evid: 201, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateDeactivateFreeTrialToggleOffOnSrc96Evid202' event (evid: 202)
 *
 * Event description: The event is triggered when user clicks on the toggle to active/deactivate Free Trial
 *
 * @param {activateDeactivateFreeTrialToggleOffOnSrc96Evid202Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} action - activate/deactivate
 * @property {string} business_model - the marked business model while the user click on the toggle
 * @return {LogObject<activateDeactivateFreeTrialToggleOffOnSrc96Evid202Params>} LogObject<activateDeactivateFreeTrialToggleOffOnSrc96Evid202Params>
 */
export function activateDeactivateFreeTrialToggleOffOnSrc96Evid202(params) {
    return { evid: 202, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingPageClickOnActivateNewTrialInFreeTrialSectionToMigrateToNewFreeTrialSrc96Evid203' event (evid: 203)
 *
 * Event description: When users clicks on activate new trial in ‘Free Trial’ section to migrate to new free trial
 *
 *
 * @param {pricingPageClickOnActivateNewTrialInFreeTrialSectionToMigrateToNewFreeTrialSrc96Evid203Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {number} free_trial_days - the days of trial as it appears while the user clicks on ‘activate new trial’
 * @property {string} business_model - the marked business model while the user click on the toggle
 * @return {LogObject<pricingPageClickOnActivateNewTrialInFreeTrialSectionToMigrateToNewFreeTrialSrc96Evid203Params>} LogObject<pricingPageClickOnActivateNewTrialInFreeTrialSectionToMigrateToNewFreeTrialSrc96Evid203Params>
 */
export function pricingPageClickOnActivateNewTrialInFreeTrialSectionToMigrateToNewFreeTrialSrc96Evid203(params) {
    return { evid: 203, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingPageClickOnActivateNewTrialCtaInActivateTrialMigrationModalSrc96Evid204' event (evid: 204)
 *
 * Event description: When user clicks on ‘Activate new trial’ CTA in Activate Trial migration modal
 *
 * @param {pricingPageClickOnActivateNewTrialCtaInActivateTrialMigrationModalSrc96Evid204Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {number} free_trial_days - the days of trials as it appears while the user clicks on ‘activate new trial’
 * @property {string} business_model - the marked business model while the user click on the toggle
 * @return {LogObject<pricingPageClickOnActivateNewTrialCtaInActivateTrialMigrationModalSrc96Evid204Params>} LogObject<pricingPageClickOnActivateNewTrialCtaInActivateTrialMigrationModalSrc96Evid204Params>
 */
export function pricingPageClickOnActivateNewTrialCtaInActivateTrialMigrationModalSrc96Evid204(params) {
    return { evid: 204, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketSaleClickOnSaveInJoinToWixSaleDevCenterPageSrc96Evid205' event (evid: 205)
 *
 * Event description: when a user (developer) is clicking on Save in ‘Join to Wix Sale’ DevCenter page
 *
 * @param {appMarketSaleClickOnSaveInJoinToWixSaleDevCenterPageSrc96Evid205Params} params - The parameters for this event
 * @property {string} app_id - the app id
 * @property {string} sale_name - The name of the sale as it appears in the basic info
 * @property {number} discount_percentage - The discount the dev chose: 20/30/40/50 (integer)
 * @property {string} pricing_plans - The plans the sale apply to
 * @property {string} monthly_charge - First month/12 months/etc.
 * @property {string} cycle_billing - the billing cycle: yearly/monthly/yearly and monthly
 * @property {string} save_type - first save/ update
 * @property {string} valid_from_date - The date the sale valid from
 * @property {string} valid_until_date - The date the sale valid until
 * @return {LogObject<appMarketSaleClickOnSaveInJoinToWixSaleDevCenterPageSrc96Evid205Params>} LogObject<appMarketSaleClickOnSaveInJoinToWixSaleDevCenterPageSrc96Evid205Params>
 */
export function appMarketSaleClickOnSaveInJoinToWixSaleDevCenterPageSrc96Evid205(params) {
    return { evid: 205, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appBenefitsBannerImpressionOrClickSrc96Evid211' event (evid: 211)
 *
 * Event description: App Benefits Banner Impression or Click in Manage apps
 *
 * @param {appBenefitsBannerImpressionOrClickSrc96Evid211Params} params - The parameters for this event
 * @property {GUID} msid - site guid
 * @property {GUID} uuid - user guid
 * @property {string} tag_type - manage-apps
 * @property {string} action_type - impression, cta, close
 * @return {LogObject<appBenefitsBannerImpressionOrClickSrc96Evid211Params>} LogObject<appBenefitsBannerImpressionOrClickSrc96Evid211Params>
 */
export function appBenefitsBannerImpressionOrClickSrc96Evid211(params) {
    return { evid: 211, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterGoogleAnalyticsBannerImpressionOrClickSrc96Evid213' event (evid: 213)
 *
 * Event description:  Dev Center - Google Analytics Banner - Impression or Click (on one of the CTAs)
 *
 *
 * @param {devCenterGoogleAnalyticsBannerImpressionOrClickSrc96Evid213Params} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} uuid - uuid
 * @property {string} page_name - The name of the page where the banner is shown
 * @property {string} action_type - impression, get_started, learn_more, close
 * @return {LogObject<devCenterGoogleAnalyticsBannerImpressionOrClickSrc96Evid213Params>} LogObject<devCenterGoogleAnalyticsBannerImpressionOrClickSrc96Evid213Params>
 */
export function devCenterGoogleAnalyticsBannerImpressionOrClickSrc96Evid213(params) {
    return { evid: 213, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppInfoModalLoadedSrc96Evid215' event (evid: 215)
 *
 * Event description: Dev Center - App Info Modal Loaded
 *
 * @param {devCenterAppInfoModalLoadedSrc96Evid215Params} params - The parameters for this event
 * @property {string} modal_name - name of the modal
 * @property {GUID} app_id - app_id
 * @property {string} route - route (from page url)
 * @return {LogObject<devCenterAppInfoModalLoadedSrc96Evid215Params>} LogObject<devCenterAppInfoModalLoadedSrc96Evid215Params>
 */
export function devCenterAppInfoModalLoadedSrc96Evid215(params) {
    return { evid: 215, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppInfoModalCtaClickSrc96Evid216' event (evid: 216)
 *
 * Event description: Dev Center - App Info Modal CTA Click
 *
 * @param {devCenterAppInfoModalCtaClickSrc96Evid216Params} params - The parameters for this event
 * @property {string} modal_name - name of the modal
 * @property {GUID} app_id - app_id
 * @property {string} cta_name - cta name
 * @property {string} route - route (from page url)
 * @return {LogObject<devCenterAppInfoModalCtaClickSrc96Evid216Params>} LogObject<devCenterAppInfoModalCtaClickSrc96Evid216Params>
 */
export function devCenterAppInfoModalCtaClickSrc96Evid216(params) {
    return { evid: 216, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOpenTokenModalClick' event (evid: 29)
 *
 * Event description: User clicks on 'token' button
 *
 * @param {devCenterOpenTokenModalClickParams} params - The parameters for this event
 * @property {boolean} isTokenExist - token already generated - true / false
 * @property {string} origin - "playground","main_header"
 * @return {LogObject<devCenterOpenTokenModalClickParams>} LogObject<devCenterOpenTokenModalClickParams>
 */
export function devCenterOpenTokenModalClick(params) {
    return { evid: 29, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'revokeShareUrl' event (evid: 3)
 *
 * Event description: share url event - not in use
 *
 * @param {revokeShareUrlParams} params - The parameters for this event
 * @property {string} url - ShareURL - url of shared link
 * @property {string} link_source - link_source
 * @property {GUID} compId - Company id (key field for App Developers!)
 * @property {GUID} appId - App id
 * @return {LogObject<revokeShareUrlParams>} LogObject<revokeShareUrlParams>
 */
export function revokeShareUrl(params) {
    return { evid: 3, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmCollectionCreated' event (evid: 3000)
 *
 * Event description: New Collection Created
 *
 * @param {mnmCollectionCreatedParams} params - The parameters for this event
 * @property {string} tagName - tag name
 * @property {string} tagPopulation - manual / by component
 * @property {string} slugId - slug
 * @property {string} componentType - component type
 * @property {GUID} tagId - tag id
 * @property {string} tagType - collection / category
 * @return {LogObject<mnmCollectionCreatedParams>} LogObject<mnmCollectionCreatedParams>
 */
export function mnmCollectionCreated(params) {
    return { evid: 3000, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmContributorAdded' event (evid: 3001)
 *
 * Event description: User added contributor/s
 *
 * @param {mnmContributorAddedParams} params - The parameters for this event
 * @property {string} tagName - tagName
 * @property {string} tagPopulation - manual / by component
 * @property {string} slugId - slug
 * @property {string} componentType - component type
 * @property {GUID} tagId - tag id
 * @property {string} tagType - collection / category
 * @property {GUID} contributorId - contributor id
 * @return {LogObject<mnmContributorAddedParams>} LogObject<mnmContributorAddedParams>
 */
export function mnmContributorAdded(params) {
    return { evid: 3001, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmContributorRemoved' event (evid: 3002)
 *
 * Event description: User removed contributor/s
 *
 * @param {mnmContributorRemovedParams} params - The parameters for this event
 * @property {string} tagName - tag name
 * @property {string} tagPopulation - manual / by component
 * @property {GUID} collectionId - collection id
 * @property {string} slugId - slug
 * @property {string} componentType - component type
 * @property {string} collectionName - collection name
 * @property {GUID} tagId - tag id
 * @property {GUID} contributorId - contributor id
 * @return {LogObject<mnmContributorRemovedParams>} LogObject<mnmContributorRemovedParams>
 */
export function mnmContributorRemoved(params) {
    return { evid: 3002, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmTagDetailsUpdated' event (evid: 3003)
 *
 * Event description: Changes were made (and saved) to tag details. All fields values are the new values after the change.
 *
 * @param {mnmTagDetailsUpdatedParams} params - The parameters for this event
 * @property {string} tagDescription - the full text of the description
 * @property {string} tagName - tag name
 * @property {string} tagPopulation - manual / by component
 * @property {string} slugId - slug
 * @property {string} componentType - component type
 * @property {string} tagTeaser - the full teaser text
 * @property {GUID} tagId - tag id
 * @property {string} tagType - collection / category
 * @return {LogObject<mnmTagDetailsUpdatedParams>} LogObject<mnmTagDetailsUpdatedParams>
 */
export function mnmTagDetailsUpdated(params) {
    return { evid: 3003, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devWixComLogInToDeveloperCenter' event (evid: 31)
 *
 * Event description: When a wix user, or a new signed up user is logged in into dev.wix.com.
 *
 * @param {devWixComLogInToDeveloperCenterParams} params - The parameters for this event
 * @return {LogObject<devWixComLogInToDeveloperCenterParams>} LogObject<devWixComLogInToDeveloperCenterParams>
 */
export function devWixComLogInToDeveloperCenter(params) {
    return { evid: 31, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmAppListUpdatedByUser' event (evid: 3100)
 *
 * Event description: User changed the app list and saved (manual collection type)
 *
 * @param {mnmAppListUpdatedByUserParams} params - The parameters for this event
 * @property {string} tagPopulation - manual / by component
 * @property {string} actionSource - manual / automatic
 * @property {GUID} collectionId - collection id
 * @property {string} slugId - slug
 * @property {string} componentType - component name
 * @property {string} actionType - add / remove
 * @property {GUID} tagId - tag id
 * @property {GUID} appId - app id
 * @property {string} tagType - category / collection
 * @return {LogObject<mnmAppListUpdatedByUserParams>} LogObject<mnmAppListUpdatedByUserParams>
 */
export function mnmAppListUpdatedByUser(params) {
    return { evid: 3100, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardDashboardOpened' event (evid: 32)
 *
 * Event description: In the developer center, the dashboard of an app is being opened by a developer.
 *
 * @param {devCenterDynamicDashboardDashboardOpenedParams} params - The parameters for this event
 * @property {string} step_name - name of main step that opened the dashboard (main, add_info, collect_rev, almost_done etc...)
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardDashboardOpenedParams>} LogObject<devCenterDynamicDashboardDashboardOpenedParams>
 */
export function devCenterDynamicDashboardDashboardOpened(params) {
    return { evid: 32, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mnmTagAppListUpdatedManually' event (evid: 3200)
 *
 * Event description: User edited and saved the app list of a collection/category. Only triggered if the list has changed.
 *
 * @param {mnmTagAppListUpdatedManuallyParams} params - The parameters for this event
 * @property {string} tag_population - manual / by component type
 * @property {string} slug - slug
 * @property {GUID} contributor_id - the uuid of the contributor that edited
 * @property {string} tag_id - tag id
 * @property {string} tag_type - collection / category
 * @property {string} component_type - component name (if relevant)
 * @property {string} tag_name - tag name (user-defined)
 * @return {LogObject<mnmTagAppListUpdatedManuallyParams>} LogObject<mnmTagAppListUpdatedManuallyParams>
 */
export function mnmTagAppListUpdatedManually(params) {
    return { evid: 3200, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardExpandStep' event (evid: 33)
 *
 * Event description: In the developer center, user clicks on steps offered by the dynamic dashboard. clicking on the steps will expand them for more information and call to action button
 *
 * @param {devCenterDynamicDashboardExpandStepParams} params - The parameters for this event
 * @property {string} step_name - step name inside the dynamic dashboard
 * @property {string} expand_reason - step was expand because ('url_visit','direct_click')
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardExpandStepParams>} LogObject<devCenterDynamicDashboardExpandStepParams>
 */
export function devCenterDynamicDashboardExpandStep(params) {
    return { evid: 33, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardCallToAction' event (evid: 34)
 *
 * Event description: In the developer center, user clicks on steps offered by the dashboard.  each step offered has a unique call to action button that will help the developer to make progress.
 *
 * @param {devCenterDynamicDashboardCallToActionParams} params - The parameters for this event
 * @property {string} step_name - [OLD DASHBOARD] in the dashboard steps, user clicks on the button that calls for action (e.g - add app info)
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @property {string} section - the section where the Call to Action (CTA) is located
 * @property {string} to_page_name - The destination page
 * @property {string} to_url - the destination url (internal and external)
 * @property {string} cta_name - The name of the cta click
 * @return {LogObject<devCenterDynamicDashboardCallToActionParams>} LogObject<devCenterDynamicDashboardCallToActionParams>
 */
export function devCenterDynamicDashboardCallToAction(params) {
    return { evid: 34, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardSideboxClick' event (evid: 35)
 *
 * Event description: In the developer center, the dashboard of an app is being opened by a developer - there is a small help sidebox on the side with options to click. clicking on those options will trigger this event.
 *
 * @param {devCenterDynamicDashboardSideboxClickParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {string} sidebox_name - sidebox button that offer more features to developers
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardSideboxClickParams>} LogObject<devCenterDynamicDashboardSideboxClickParams>
 */
export function devCenterDynamicDashboardSideboxClick(params) {
    return { evid: 35, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPreviewAppClick' event (evid: 36)
 *
 * Event description: Developer clicks on 'Preview App' in order to review his app listing in the market.
 *
 * @param {devCenterPreviewAppClickParams} params - The parameters for this event
 * @property {GUID} appId - app_id
 * @property {string} loaction - location
 * @return {LogObject<devCenterPreviewAppClickParams>} LogObject<devCenterPreviewAppClickParams>
 */
export function devCenterPreviewAppClick(params) {
    return { evid: 36, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterCompanyInfoUpdated' event (evid: 37)
 *
 * Event description: company info edited and saved
 *
 * @param {devCenterCompanyInfoUpdatedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterCompanyInfoUpdatedParams>} LogObject<devCenterCompanyInfoUpdatedParams>
 */
export function devCenterCompanyInfoUpdated(params) {
    return { evid: 37, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterNavigationPageView' event (evid: 38)
 *
 * Event description: Navigating between different pages in the Dev Center
 *
 * @param {devCenterNavigationPageViewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral came from email? outside link? inside navigation?
 * @property {string} pageName - name of page viewed by developer
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterNavigationPageViewParams>} LogObject<devCenterNavigationPageViewParams>
 */
export function devCenterNavigationPageView(params) {
    return { evid: 38, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'installByShareUrl' event (evid: 4)
 *
 * Event description: Install App by Share Url (revoke link)
 *
 * @param {installByShareUrlParams} params - The parameters for this event
 * @property {string} url - ShareURL - url of shared link
 * @property {GUID} compId - Company id (key field for App Developers!)
 * @property {GUID} appId - App Id
 * @property {string} shareUrlId - depcrecated dont use this
 * @return {LogObject<installByShareUrlParams>} LogObject<installByShareUrlParams>
 */
export function installByShareUrl(params) {
    return { evid: 4, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareUrlCreateLinkSrc96Evid40' event (evid: 40)
 *
 * Event description: Dev.Center - Share URL - Link opened.
 *
 * @param {shareUrlCreateLinkSrc96Evid40Params} params - The parameters for this event
 * @property {string} url - url
 * @property {GUID} appId - app id
 * @return {LogObject<shareUrlCreateLinkSrc96Evid40Params>} LogObject<shareUrlCreateLinkSrc96Evid40Params>
 */
export function shareUrlCreateLinkSrc96Evid40(params) {
    return { evid: 40, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPageView' event (evid: 41)
 *
 * Event description: Page was loaded to user
 *
 * @param {devCenterPageViewParams} params - The parameters for this event
 * @property {string} page_name - name of page
 * @property {GUID} app_id - app_id
 * @property {string} route - the page's route
 *
 * @property {string} page_content - the content of the page that was rendered
 * @return {LogObject<devCenterPageViewParams>} LogObject<devCenterPageViewParams>
 */
export function devCenterPageView(params) {
    return { evid: 41, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterTransactionHistoryPageView' event (evid: 42)
 *
 * Event description: user view the 'transaction history' page
 *
 * @param {devCenterTransactionHistoryPageViewParams} params - The parameters for this event
 * @property {string} label_name - name of label
 * @property {string} origin - tooltip or button
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterTransactionHistoryPageViewParams>} LogObject<devCenterTransactionHistoryPageViewParams>
 */
export function devCenterTransactionHistoryPageView(params) {
    return { evid: 42, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPayoutDashboardDownloadCsvFileClick' event (evid: 43)
 *
 * Event description: user clicks on 'download csv file' button
 *
 * @param {devCenterPayoutDashboardDownloadCsvFileClickParams} params - The parameters for this event
 * @property {string} start_date - start date
 * @property {string} end_date - end date
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutDashboardDownloadCsvFileClickParams>} LogObject<devCenterPayoutDashboardDownloadCsvFileClickParams>
 */
export function devCenterPayoutDashboardDownloadCsvFileClick(params) {
    return { evid: 43, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterReviewsLearnMoreClick' event (evid: 44)
 *
 * Event description: user clicks on learn more
 *
 * @param {devCenterReviewsLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} app_Id - app_id
 * @return {LogObject<devCenterReviewsLearnMoreClickParams>} LogObject<devCenterReviewsLearnMoreClickParams>
 */
export function devCenterReviewsLearnMoreClick(params) {
    return { evid: 44, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppStatusChanged' event (evid: 5)
 *
 * Event description: Dev Center - App Status Change (draft, approved, rejected,
 *
 * @param {devCenterAppStatusChangedParams} params - The parameters for this event
 * @property {string} versionNumber - version Number
 * @property {string} appStatus - draft, submitted, in review, approved, declined, published
 * @property {GUID} appId - app_id
 * @property {boolean} isTriggeredByUser - True if the new status was triggered by user, otherwise false (wix employee f.e)
 * @return {LogObject<devCenterAppStatusChangedParams>} LogObject<devCenterAppStatusChangedParams>
 */
export function devCenterAppStatusChanged(params) {
    return { evid: 5, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnBackToMyApps' event (evid: 50)
 *
 * Event description: In the dashboard page when the user clicks on  Back To My Apps Button.
 *
 * @param {devCenterDashboardClickOnBackToMyAppsParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {string} location_name - If the user clicked from the main dashboard or from the sections
 * @return {LogObject<devCenterDashboardClickOnBackToMyAppsParams>} LogObject<devCenterDashboardClickOnBackToMyAppsParams>
 */
export function devCenterDashboardClickOnBackToMyApps(params) {
    return { evid: 50, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppAddedToSearchIndex' event (evid: 500)
 *
 * Event description: this events is triggered when the server index the app to the app market search. A proxy event for defining real apps.
 *
 * @param {appMarketAppAddedToSearchIndexParams} params - The parameters for this event
 * @property {string} appType - type of the app (server definition)
 * @property {string} appStatus - status of the app (PUBLISHED etc.)
 * @property {GUID} appId - app id
 * @return {LogObject<appMarketAppAddedToSearchIndexParams>} LogObject<appMarketAppAddedToSearchIndexParams>
 */
export function appMarketAppAddedToSearchIndex(params) {
    return { evid: 500, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAppStatusChangedSrc96Evid5001' event (evid: 5001)
 *
 * Event description: App Status Changed
 *
 * @param {cactusAppStatusChangedSrc96Evid5001Params} params - The parameters for this event
 * @property {string} market_status - market status- listed, not listed, removed...
 * @property {GUID} uuid - uuid
 * @property {string} previous_app_status - previous app status - submitted, in review, declined, unpublished.....
 * @property {DateTime} last_modified - last date modified
 * @property {string} app_status - new app status - submitted, in review, declined, unpublished.....
 * @property {string} member_name - team member name
 * @property {GUID} app_id - app id
 * @return {LogObject<cactusAppStatusChangedSrc96Evid5001Params>} LogObject<cactusAppStatusChangedSrc96Evid5001Params>
 */
export function cactusAppStatusChangedSrc96Evid5001(params) {
    return { evid: 5001, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appMarketAppRemovedFromSearchIndex' event (evid: 501)
 *
 * Event description: this events is triggered when the server remove the app from the search index of the app market search. A proxy event for defining real apps.
 *
 * @param {appMarketAppRemovedFromSearchIndexParams} params - The parameters for this event
 * @property {string} appType - type of the app (server definition)
 * @property {string} appStatus - the status of the app (server definition)
 * @property {GUID} appId - app id
 * @return {LogObject<appMarketAppRemovedFromSearchIndexParams>} LogObject<appMarketAppRemovedFromSearchIndexParams>
 */
export function appMarketAppRemovedFromSearchIndex(params) {
    return { evid: 501, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnWixTpa' event (evid: 51)
 *
 * Event description: In the dashboard page when the user clicks on  Back To My Apps Button.
 *
 * @param {devCenterDashboardClickOnWixTpaParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {boolean} is_clicked - if the user clicked on the button Wix TPA- (if he clicked than 1, if he canceled 0, if not clicked null)
 * @return {LogObject<devCenterDashboardClickOnWixTpaParams>} LogObject<devCenterDashboardClickOnWixTpaParams>
 */
export function devCenterDashboardClickOnWixTpa(params) {
    return { evid: 51, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardHoverOnTestYourApp' event (evid: 52)
 *
 * Event description: The User Hovers On test your app from the dashboard or dashboard slide bar sections.
 *
 * @param {devCenterDashboardHoverOnTestYourAppParams} params - The parameters for this event
 * @property {number} num_of_dev_sites - num_of_dev_sites
 * @property {string} loaction - the location of the hovering (main dashboard, Components section...)
 * @property {boolean} has_wix_site - Does the user has a Wix site or not
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardHoverOnTestYourAppParams>} LogObject<devCenterDashboardHoverOnTestYourAppParams>
 */
export function devCenterDashboardHoverOnTestYourApp(params) {
    return { evid: 52, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsChooseApp' event (evid: 53)
 *
 * Event description: User visits the Dev Center My Apps and clicks on specific app.
 *
 * @param {devCenterMyAppsChooseAppParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterMyAppsChooseAppParams>} LogObject<devCenterMyAppsChooseAppParams>
 */
export function devCenterMyAppsChooseApp(params) {
    return { evid: 53, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnTestYourApp' event (evid: 54)
 *
 * Event description: The user clicks on 'Create Site' or on one of the entry points in the popover menu of 'Test Your App'.
 *
 * @param {devCenterDashboardClickOnTestYourAppParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - Did the developer reach the number of test sites limit
 * @property {string} test_name - app market, editor, dashboard
 * @property {string} click_type - entry point/create site
 * @property {string} loaction - the location of the click (main dashboard, Components section...)
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many sites does the developer already have
 * @return {LogObject<devCenterDashboardClickOnTestYourAppParams>} LogObject<devCenterDashboardClickOnTestYourAppParams>
 */
export function devCenterDashboardClickOnTestYourApp(params) {
    return { evid: 54, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppClickOnComponent' event (evid: 55)
 *
 * Event description: In the Build Your App  - Components page when the user clicks on  existing component.
 *
 * @param {devCenterDashboardBuildYourAppClickOnComponentParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterDashboardBuildYourAppClickOnComponentParams>} LogObject<devCenterDashboardBuildYourAppClickOnComponentParams>
 */
export function devCenterDashboardBuildYourAppClickOnComponent(params) {
    return { evid: 55, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppHoverOnAddComponent' event (evid: 56)
 *
 * Event description: In the Build Your App  - Components page when the user hover on  add new component button.
 *
 * @param {devCenterDashboardBuildYourAppHoverOnAddComponentParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppHoverOnAddComponentParams>} LogObject<devCenterDashboardBuildYourAppHoverOnAddComponentParams>
 */
export function devCenterDashboardBuildYourAppHoverOnAddComponent(params) {
    return { evid: 56, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppClickOnAddComponent' event (evid: 57)
 *
 * Event description: deprecated on September 2023, 96:9620 replacing this event (being triggered when user clicks on create component or submit a proposal)
 *
 * @param {devCenterDashboardBuildYourAppClickOnAddComponentParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {GUID} app_id - app id
 * @property {string} component_type - page / widget etc.
 * @return {LogObject<devCenterDashboardBuildYourAppClickOnAddComponentParams>} LogObject<devCenterDashboardBuildYourAppClickOnAddComponentParams>
 */
export function devCenterDashboardBuildYourAppClickOnAddComponent(params) {
    return { evid: 57, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnSave' event (evid: 58)
 *
 * Event description: In the  Build Your App  - OAuth page when the user clicks on save.
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnSaveParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnSaveParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnSaveParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnSave(params) {
    return { evid: 58, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnAppUrlBehavior' event (evid: 59)
 *
 * Event description: In the  Build Your App  - OAuth page when the user clicks on App URL Behavior.
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams} params - The parameters for this event
 * @property {string} behavior_name - Open App URL in new tab (Recommended), Or Open App URL in new window
 * @property {GUID} app_id - app id
 * @property {number} behavior_index - the index 0 or 1
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnAppUrlBehavior(params) {
    return { evid: 59, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterVersionSubmitted' event (evid: 6)
 *
 * Event description: App was submitted for review and got approved
 *
 * @param {devCenterVersionSubmittedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterVersionSubmittedParams>} LogObject<devCenterVersionSubmittedParams>
 */
export function devCenterVersionSubmitted(params) {
    return { evid: 6, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppPermissionsClickOnAddPermission' event (evid: 60)
 *
 * Event description: In the  Build Your App  - Permissions page when the user clicks on AAdd Permission Button.
 *
 * @param {devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {string} platform - platform
 * @return {LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams>} LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams>
 */
export function devCenterDashboardBuildYourAppPermissionsClickOnAddPermission(params) {
    return { evid: 60, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusContextMenuActionClick' event (evid: 6002)
 *
 * Event description: After dots menu is open, an action from the menu was clicked on.
 *
 * @param {cactusContextMenuActionClickParams} params - The parameters for this event
 * @property {string} action_name - Go to app page / Assign app / Review app / Unassign app
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app id
 * @return {LogObject<cactusContextMenuActionClickParams>} LogObject<cactusContextMenuActionClickParams>
 */
export function cactusContextMenuActionClick(params) {
    return { evid: 6002, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusStatusFilterSelected' event (evid: 6003)
 *
 * Event description: Status Filter Selected
 *
 * @param {cactusStatusFilterSelectedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} filter_name - filter name - All Statuses, in review, declined, published...
 * @property {boolean} filter_action - true if selected, false if removed
 * @return {LogObject<cactusStatusFilterSelectedParams>} LogObject<cactusStatusFilterSelectedParams>
 */
export function cactusStatusFilterSelected(params) {
    return { evid: 6003, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusTeamMemberFilterSelected' event (evid: 6004)
 *
 * Event description: Status Filter Selected
 *
 * @param {cactusTeamMemberFilterSelectedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} filter_name - filter name -No one, All team....
 * @property {boolean} filter_action - true if selected, false if removed
 * @return {LogObject<cactusTeamMemberFilterSelectedParams>} LogObject<cactusTeamMemberFilterSelectedParams>
 */
export function cactusTeamMemberFilterSelected(params) {
    return { evid: 6004, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusSearchPreformed' event (evid: 6005)
 *
 * Event description: Search Preformed
 *
 * @param {cactusSearchPreformedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} results_number - the amount of results that have returned
 * @property {string} search_term - search term the user entered
 * @return {LogObject<cactusSearchPreformedParams>} LogObject<cactusSearchPreformedParams>
 */
export function cactusSearchPreformed(params) {
    return { evid: 6005, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusSortByModifiedClick' event (evid: 6006)
 *
 * Event description: Sort By Modified Click
 *
 * @param {cactusSortByModifiedClickParams} params - The parameters for this event
 * @property {string} sort_type - newest or oldest
 * @property {GUID} uuid - uuid
 * @return {LogObject<cactusSortByModifiedClickParams>} LogObject<cactusSortByModifiedClickParams>
 */
export function cactusSortByModifiedClick(params) {
    return { evid: 6006, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAppClick' event (evid: 6007)
 *
 * Event description: Cactus - App Click.
 *
 * @param {cactusAppClickParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app id
 * @return {LogObject<cactusAppClickParams>} LogObject<cactusAppClickParams>
 */
export function cactusAppClick(params) {
    return { evid: 6007, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusHeaderClick' event (evid: 6008)
 *
 * Event description: Header Click
 *
 * @param {cactusHeaderClickParams} params - The parameters for this event
 * @property {string} name - header name - apps, cactus team
 * @property {GUID} uuid - uuid
 * @return {LogObject<cactusHeaderClickParams>} LogObject<cactusHeaderClickParams>
 */
export function cactusHeaderClick(params) {
    return { evid: 6008, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusPagination' event (evid: 6009)
 *
 * Event description: Cactus - Pagination.
 *
 * @param {cactusPaginationParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} current_page_number - what page the user was when clicking
 * @property {number} page_number - what page was clicked on
 * @return {LogObject<cactusPaginationParams>} LogObject<cactusPaginationParams>
 */
export function cactusPagination(params) {
    return { evid: 6009, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusCopyAppId' event (evid: 6010)
 *
 * Event description: Context Menu Click
 *
 * @param {cactusCopyAppIdParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, not listed, removed...
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app status - submitted, in review, declined, unpublished.....
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - team member name assigned
 * @property {GUID} app_id - app id
 * @property {string} button_location - options: 'apps_table' or 'sidebar_menu'
 * @return {LogObject<cactusCopyAppIdParams>} LogObject<cactusCopyAppIdParams>
 */
export function cactusCopyAppId(params) {
    return { evid: 6010, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAssignApp' event (evid: 6011)
 *
 * Event description: Assign App to a team member
 *
 * @param {cactusAssignAppParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, not listed, removed...
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app status - submitted, in review, declined, unpublished.....
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} assign_from - Member on app, before reassignment
 * @property {GUID} app_id - app id
 * @property {string} assign_to - Member on app, after reassignment
 * @property {string} type - assign / unassign
 * @return {LogObject<cactusAssignAppParams>} LogObject<cactusAssignAppParams>
 */
export function cactusAssignApp(params) {
    return { evid: 6011, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusLeftMenuAction' event (evid: 6012)
 *
 * Event description: Left Menu Action
 *
 * @param {cactusLeftMenuActionParams} params - The parameters for this event
 * @property {string} action_name - Actions: go back to apps, go to dev center, app log, developers team.
 * @property {string} market_status - market status- listed, not listed, removed...
 * @property {GUID} uuid - uuid
 * @property {string} page_subtopic - sub page name
 * @property {string} app_status - app status - submitted, in review, declined, unpublished.....
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - team member name assigned
 * @property {GUID} app_id - app id
 * @property {string} page_topic - main page name
 * @return {LogObject<cactusLeftMenuActionParams>} LogObject<cactusLeftMenuActionParams>
 */
export function cactusLeftMenuAction(params) {
    return { evid: 6012, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusFinishButtonClick' event (evid: 6015)
 *
 * Event description: clicking on the Finish button triggers the event.
 *
 * @param {cactusFinishButtonClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app_status
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusFinishButtonClickParams>} LogObject<cactusFinishButtonClickParams>
 */
export function cactusFinishButtonClick(params) {
    return { evid: 6015, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAddACommentButtonClick' event (evid: 6016)
 *
 * Event description: clicking on the Save button in the 'add a comment to the report' modal triggers the event.
 *
 * @param {cactusAddACommentButtonClickParams} params - The parameters for this event
 * @property {boolean} is_blocker - 1 - yes, 0 - no
 * @property {string} item_id - item_id
 * @property {GUID} review_id - review id
 * @property {string} path - full path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {boolean} is_unpublish_flow - Is the flow of the action is thru 'unpublish'
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @property {string} type - comment, update, update&comment
 * @property {string} refferal_name - referral could be: 1-the general add a comment button. 2- add a comment item from 'previous activity' tab.
 * @property {number} item_status - 1 = active or 0 = deleted
 * @return {LogObject<cactusAddACommentButtonClickParams>} LogObject<cactusAddACommentButtonClickParams>
 */
export function cactusAddACommentButtonClick(params) {
    return { evid: 6016, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusSubmissionCommentOpenClick' event (evid: 6017)
 *
 * Event description: open the Submission Comment section triggers the event.
 * just when it's opened (not closed!)
 *
 * @param {cactusSubmissionCommentOpenClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusSubmissionCommentOpenClickParams>} LogObject<cactusSubmissionCommentOpenClickParams>
 */
export function cactusSubmissionCommentOpenClick(params) {
    return { evid: 6017, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusReviewTabsClick' event (evid: 6018)
 *
 * Event description: Cactus - Review Tabs Click.
 *
 * @param {cactusReviewTabsClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} loaction - report, previous activity
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusReviewTabsClickParams>} LogObject<cactusReviewTabsClickParams>
 */
export function cactusReviewTabsClick(params) {
    return { evid: 6018, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusDeleteACommentFromReportTab' event (evid: 6019)
 *
 * Event description: Button Click
 *
 * @param {cactusDeleteACommentFromReportTabParams} params - The parameters for this event
 * @property {boolean} is_blocker - 1 - yes, 0 - no
 * @property {string} item_id - item_id
 * @property {GUID} review_id - review_id
 * @property {string} path - full path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {boolean} is_unpublish_flow - Is the flow of the action is thru 'unpublish'
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - member_name
 * @property {GUID} app_id - app_id
 * @property {string} type - comment, update, comment&update
 * @property {number} item_status - 1 = active or 0 = deleted
 * @return {LogObject<cactusDeleteACommentFromReportTabParams>} LogObject<cactusDeleteACommentFromReportTabParams>
 */
export function cactusDeleteACommentFromReportTab(params) {
    return { evid: 6019, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusCommentsButtonsFromPreviousActivityTabClicks' event (evid: 6020)
 *
 * Event description: hovering on the selected item in 'updates&previous' tab and clicking 'dismiss', 'remove', 'revert' 'add to report' button triggers this event
 *
 * @param {cactusCommentsButtonsFromPreviousActivityTabClicksParams} params - The parameters for this event
 * @property {boolean} is_blocker - 1 - yes, 0 - no
 * @property {string} item_id - item_id
 * @property {GUID} review_id - review_id
 * @property {string} path - full path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} comment_status - Active or deleted
 * @property {string} button_name - 'remove',  'add to report'
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @property {string} type - comment, update, comments&update
 * @property {number} item_status - 1 = active or 0 = deleted
 * @return {LogObject<cactusCommentsButtonsFromPreviousActivityTabClicksParams>} LogObject<cactusCommentsButtonsFromPreviousActivityTabClicksParams>
 */
export function cactusCommentsButtonsFromPreviousActivityTabClicks(params) {
    return { evid: 6020, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusPreviewButtonClick' event (evid: 6021)
 *
 * Event description: Cactus - Preview button click.
 *
 * @param {cactusPreviewButtonClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {boolean} is_unpublish_flow - Is the flow of the action is thru 'unpublish'
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusPreviewButtonClickParams>} LogObject<cactusPreviewButtonClickParams>
 */
export function cactusPreviewButtonClick(params) {
    return { evid: 6021, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusDeclineAppClick' event (evid: 6022)
 *
 * Event description: At the end of the Decline flow, clicking on the 'Decline' button triggers the event.
 *
 * @param {cactusDeclineAppClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusDeclineAppClickParams>} LogObject<cactusDeclineAppClickParams>
 */
export function cactusDeclineAppClick(params) {
    return { evid: 6022, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusPublishApp' event (evid: 6023)
 *
 * Event description: At the end of the Publish flow, clicking on the 'Publish' button triggers the event.
 *
 * @param {cactusPublishAppParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} loaction - location
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusPublishAppParams>} LogObject<cactusPublishAppParams>
 */
export function cactusPublishApp(params) {
    return { evid: 6023, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusCopyAllEmails' event (evid: 6024)
 *
 * Event description: At the App Team Page, Click On Copy All Emails
 *
 * @param {cactusCopyAllEmailsParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusCopyAllEmailsParams>} LogObject<cactusCopyAllEmailsParams>
 */
export function cactusCopyAllEmails(params) {
    return { evid: 6024, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusCopyOneEmail' event (evid: 6025)
 *
 * Event description: Cactus - Copy One Email.
 *
 * @param {cactusCopyOneEmailParams} params - The parameters for this event
 * @property {string} email - email
 * @property {string} market_status - market_status
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app_status
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - team member his email copied
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusCopyOneEmailParams>} LogObject<cactusCopyOneEmailParams>
 */
export function cactusCopyOneEmail(params) {
    return { evid: 6025, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusChangeRole' event (evid: 6026)
 *
 * Event description: After the user changing a role of one team member
 *
 * @param {cactusChangeRoleParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} from_role - the previous role
 * @property {string} role_type - new role type
 * @property {string} member_name - member name his role changed
 * @return {LogObject<cactusChangeRoleParams>} LogObject<cactusChangeRoleParams>
 */
export function cactusChangeRole(params) {
    return { evid: 6026, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAddTeamMember' event (evid: 6027)
 *
 * Event description: When a team member added
 *
 * @param {cactusAddTeamMemberParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} role_type - role type
 * @return {LogObject<cactusAddTeamMemberParams>} LogObject<cactusAddTeamMemberParams>
 */
export function cactusAddTeamMember(params) {
    return { evid: 6027, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusRemoveTeamMember' event (evid: 6028)
 *
 * Event description: When a team member Removed
 *
 * @param {cactusRemoveTeamMemberParams} params - The parameters for this event
 * @property {string} email - email
 * @property {GUID} uuid - uuid
 * @property {string} role_type - role type
 * @return {LogObject<cactusRemoveTeamMemberParams>} LogObject<cactusRemoveTeamMemberParams>
 */
export function cactusRemoveTeamMember(params) {
    return { evid: 6028, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusGoToReviewButtonClick' event (evid: 6029)
 *
 * Event description: Go To Review Button Click
 *
 * @param {cactusGoToReviewButtonClickParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusGoToReviewButtonClickParams>} LogObject<cactusGoToReviewButtonClickParams>
 */
export function cactusGoToReviewButtonClick(params) {
    return { evid: 6029, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusViewDeveloperCommentNote' event (evid: 6030)
 *
 * Event description: View Developer Comment Note Click
 *
 * @param {cactusViewDeveloperCommentNoteParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {GUID} app_id - app_id
 * @property {string} reviewer - reviewer
 * @return {LogObject<cactusViewDeveloperCommentNoteParams>} LogObject<cactusViewDeveloperCommentNoteParams>
 */
export function cactusViewDeveloperCommentNote(params) {
    return { evid: 6030, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusAssignUnassignClick' event (evid: 6031)
 *
 * Event description: Assign \ Unassign Click
 *
 * @param {cactusAssignUnassignClickParams} params - The parameters for this event
 * @property {string} location - Location of the click
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {GUID} app_id - app_id
 * @property {string} type - assign \ unassign
 * @property {string} team_member - team_member name
 * @return {LogObject<cactusAssignUnassignClickParams>} LogObject<cactusAssignUnassignClickParams>
 */
export function cactusAssignUnassignClick(params) {
    return { evid: 6031, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusViewReportButtonClick' event (evid: 6032)
 *
 * Event description: View Report Button Click
 *
 * @param {cactusViewReportButtonClickParams} params - The parameters for this event
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {GUID} app_id - app_id
 * @property {string} reviewer - reviewer
 * @return {LogObject<cactusViewReportButtonClickParams>} LogObject<cactusViewReportButtonClickParams>
 */
export function cactusViewReportButtonClick(params) {
    return { evid: 6032, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusUnpublishAddACommentButtonClick' event (evid: 6033)
 *
 * Event description: clicking on Save (new or existing) or Delete button of and add/edit comment modal window.
 *
 * @param {cactusUnpublishAddACommentButtonClickParams} params - The parameters for this event
 * @property {string} item_id - item_id
 * @property {GUID} review_id - unique id that contains uuid and cycle number
 * @property {string} path - full path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @property {string} action_type - AddNew, SaveEdit, Delete
 * @return {LogObject<cactusUnpublishAddACommentButtonClickParams>} LogObject<cactusUnpublishAddACommentButtonClickParams>
 */
export function cactusUnpublishAddACommentButtonClick(params) {
    return { evid: 6033, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusUnpublishDeleteACommentFromReport' event (evid: 6034)
 *
 * Event description: Unpublish delete a comment from Report
 *
 * @param {cactusUnpublishDeleteACommentFromReportParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} path - full path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {DateTime} last_modified - last_modified
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - member_name
 * @property {GUID} app_id - app_id
 * @property {string} refferal_name - referral could be: 1-the general 'add a comment' button. 2- the 'add a comment' button displayed in the 'Report' tab empty state. 3- add a 'comment' type item from 'previous activity' tab. 4- add an 'update' type item from 'previous activity' tab. 5- add a 'update&comment' type item from 'updates&previous' tab.
 * @return {LogObject<cactusUnpublishDeleteACommentFromReportParams>} LogObject<cactusUnpublishDeleteACommentFromReportParams>
 */
export function cactusUnpublishDeleteACommentFromReport(params) {
    return { evid: 6034, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusUnpublishAppClick' event (evid: 6035)
 *
 * Event description: At the end of the Unpublish flow, clicking on the 'Unpublish' button triggers the event.
 *
 * @param {cactusUnpublishAppClickParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - App's Cactus team member assignee.
 * @property {GUID} app_id - app_id
 * @return {LogObject<cactusUnpublishAppClickParams>} LogObject<cactusUnpublishAppClickParams>
 */
export function cactusUnpublishAppClick(params) {
    return { evid: 6035, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusEditACommentFromReportTab' event (evid: 6036)
 *
 * Event description: [DELETE] - replaced with 96:6033
 *
 * @param {cactusEditACommentFromReportTabParams} params - The parameters for this event
 * @property {boolean} is_blocker - 1 - yes, 0 - no
 * @property {string} item_id - item_id
 * @property {GUID} review_id - review_id
 * @property {string} path - path
 * @property {string} market_status - market status- listed, never listed, removed
 * @property {boolean} is_unpublish_flow - Is the flow of the action is thru 'unpublish'
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {string} last_modified_date - App's last status modify date.
 * @property {string} member_name - The member who edited the comment
 * @property {GUID} app_id - app_id
 * @property {string} type - comment, update or both
 * @property {number} item_status - 1 = active or 0 = deleted
 * @return {LogObject<cactusEditACommentFromReportTabParams>} LogObject<cactusEditACommentFromReportTabParams>
 */
export function cactusEditACommentFromReportTab(params) {
    return { evid: 6036, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusReviewUpdateItem' event (evid: 6043)
 *
 * Event description: User change review item - triggered on Save (new or existing= edit), Delete, Remove
 *
 * @param {cactusReviewUpdateItemParams} params - The parameters for this event
 * @property {boolean} is_blocker - is the comment a blocker?
 * @property {string} item_id - item id
 * @property {string} location - Location of the click
 * @property {string} path - path
 * @property {boolean} is_unpublish_flow - Is the flow of the action is thru 'unpublish'
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {GUID} app_id - app_id
 * @property {string} item_type - comment etc.
 * @property {string} action_type - save/new/remove/delete
 * @property {string} team_member - team_member name
 * @return {LogObject<cactusReviewUpdateItemParams>} LogObject<cactusReviewUpdateItemParams>
 */
export function cactusReviewUpdateItem(params) {
    return { evid: 6043, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cactusReviewDismissRevertItemClick' event (evid: 6044)
 *
 * Event description: User click to dismiss or revert an item in Review tab
 *
 * @param {cactusReviewDismissRevertItemClickParams} params - The parameters for this event
 * @property {boolean} is_blocker - is the comment a blocker?
 * @property {string} item_id - item id
 * @property {string} location - Location of the click
 * @property {string} path - path
 * @property {string} click_type - dismiss/revert
 * @property {GUID} uuid - uuid
 * @property {string} app_status - app statuses - draft,  submitted, in review, declined, publish, unpublished.
 * @property {GUID} app_id - app_id
 * @property {string} item_type - comment etc.
 * @property {string} team_member - team_member name
 * @return {LogObject<cactusReviewDismissRevertItemClickParams>} LogObject<cactusReviewDismissRevertItemClickParams>
 */
export function cactusReviewDismissRevertItemClick(params) {
    return { evid: 6044, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksApiCategory' event (evid: 61)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on Add Webhook Button what API Category he chose.
 *
 * @param {devCenterDashboardBuildYourAppWebhooksApiCategoryParams} params - The parameters for this event
 * @property {string} api_category - Wix Stores, Marketing...
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryParams>} LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryParams>
 */
export function devCenterDashboardBuildYourAppWebhooksApiCategory(params) {
    return { evid: 61, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPublishedAppDashboardPageDashboardOpened' event (evid: 62)
 *
 * Event description: In the developer center, the dashboard of a published app is being opened by a developer.
 *
 * @param {devCenterPublishedAppDashboardPageDashboardOpenedParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPublishedAppDashboardPageDashboardOpenedParams>} LogObject<devCenterPublishedAppDashboardPageDashboardOpenedParams>
 */
export function devCenterPublishedAppDashboardPageDashboardOpened(params) {
    return { evid: 62, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterPublishedAppDashboardPageCallToAction' event (evid: 63)
 *
 * Event description: In the developer center, a published app clicks on steps offered by the dynamic dashboard.  each step offered has a unique call to action button that will help the developer to make progress.
 *
 * @param {devCenterPublishedAppDashboardPageCallToActionParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {string} cta_name - in the dynamic dashboard steps, user clicks on the button that calls for action (e.g - add app info)
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterPublishedAppDashboardPageCallToActionParams>} LogObject<devCenterPublishedAppDashboardPageCallToActionParams>
 */
export function devCenterPublishedAppDashboardPageCallToAction(params) {
    return { evid: 63, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksAddWebhook' event (evid: 64)
 *
 * Event description: In the  Build Your App  - Webhooks page when the user clicks on Add Webhook Button .
 *
 * @param {devCenterDashboardBuildYourAppWebhooksAddWebhookParams} params - The parameters for this event
 * @property {string} loaction - the location the user clicked on "add webhook". The values changed in 2/2023: top--> Set up webhook CTA, bottom--> Empty state
 * @property {boolean} is_wix_app - [DEPRECATE]
 * is_wix_app
 * @property {string} app_status - [DEPRECATE]
 * app_status
 * @property {number} num_webhooks - [DEPRECATE]
 * num_webhooks
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksAddWebhookParams>} LogObject<devCenterDashboardBuildYourAppWebhooksAddWebhookParams>
 */
export function devCenterDashboardBuildYourAppWebhooksAddWebhook(params) {
    return { evid: 64, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppSubmittedRejected' event (evid: 666)
 *
 * Event description: App was submitted for review and got rejected
 *
 * @param {devCenterAppSubmittedRejectedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {string} rejectReason - why was the app rejected
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterAppSubmittedRejectedParams>} LogObject<devCenterAppSubmittedRejectedParams>
 */
export function devCenterAppSubmittedRejected(params) {
    return { evid: 666, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppStatusChangedMysql' event (evid: 8)
 *
 * Event description: For Blocks apps - the status changed to RELEASED which the same as APPROVED status for TPAs
 *
 * @param {devCenterAppStatusChangedMysqlParams} params - The parameters for this event
 * @property {string} toVersionNumber - version number
 * @property {string} appStatus - draft, submitted, in review, approved, declined, published
 * @property {string} toAppStatus - draft, submitted, in review, approved, declined, published
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterAppStatusChangedMysqlParams>} LogObject<devCenterAppStatusChangedMysqlParams>
 */
export function devCenterAppStatusChangedMysql(params) {
    return { evid: 8, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsDownloadCsvClick' event (evid: 81)
 *
 * Event description: In the Manage Your App - Reviews - Download CSV  reviews Click
 *
 * @param {devCenterManageYourAppReviewsDownloadCsvClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppReviewsDownloadCsvClickParams>} LogObject<devCenterManageYourAppReviewsDownloadCsvClickParams>
 */
export function devCenterManageYourAppReviewsDownloadCsvClick(params) {
    return { evid: 81, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsViewReviewClick' event (evid: 82)
 *
 * Event description: In the Manage Your App - Reviews - View Review Click
 *
 * @param {devCenterManageYourAppReviewsViewReviewClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {boolean} is_selected - true = open, close = false
 * @return {LogObject<devCenterManageYourAppReviewsViewReviewClickParams>} LogObject<devCenterManageYourAppReviewsViewReviewClickParams>
 */
export function devCenterManageYourAppReviewsViewReviewClick(params) {
    return { evid: 82, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsPostReplyClick' event (evid: 83)
 *
 * Event description: Dev Center - Manage Your App - Reviews -Post Reply Click.
 *
 * @param {devCenterManageYourAppReviewsPostReplyClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} reply_type - new/edit
 * @return {LogObject<devCenterManageYourAppReviewsPostReplyClickParams>} LogObject<devCenterManageYourAppReviewsPostReplyClickParams>
 */
export function devCenterManageYourAppReviewsPostReplyClick(params) {
    return { evid: 83, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppStatsDetailsOrOverviewClick' event (evid: 86)
 *
 * Event description: Dev Center - Manage Your App - Stats - Click on Tab to Navigate.
 *
 * @param {devCenterManageYourAppStatsDetailsOrOverviewClickParams} params - The parameters for this event
 * @property {string} loaction - Details or Overview
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppStatsDetailsOrOverviewClickParams>} LogObject<devCenterManageYourAppStatsDetailsOrOverviewClickParams>
 */
export function devCenterManageYourAppStatsDetailsOrOverviewClick(params) {
    return { evid: 86, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersAddTeamMemberClick' event (evid: 88)
 *
 * Event description: In the Manage Your App - Team Members- Add team member Click
 *
 * @param {devCenterManageYourAppTeamMembersAddTeamMemberClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppTeamMembersAddTeamMemberClickParams>} LogObject<devCenterManageYourAppTeamMembersAddTeamMemberClickParams>
 */
export function devCenterManageYourAppTeamMembersAddTeamMemberClick(params) {
    return { evid: 88, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersSendInviteClick' event (evid: 89)
 *
 * Event description: Manage Your App - Team Members - Send Invite Click
 *
 * @param {devCenterManageYourAppTeamMembersSendInviteClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppTeamMembersSendInviteClickParams>} LogObject<devCenterManageYourAppTeamMembersSendInviteClickParams>
 */
export function devCenterManageYourAppTeamMembersSendInviteClick(params) {
    return { evid: 89, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppPublished' event (evid: 9)
 *
 * Event description: Dev Center - App Published by developer into the market.
 *
 * @param {devCenterAppPublishedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterAppPublishedParams>} LogObject<devCenterAppPublishedParams>
 */
export function devCenterAppPublished(params) {
    return { evid: 9, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersCopyLinkClick' event (evid: 90)
 *
 * Event description: Manage Your App - Team Members - Copy Link Click
 *
 * @param {devCenterManageYourAppTeamMembersCopyLinkClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} entryPoint - the page the user copy the link from: collaborators/my apps
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterManageYourAppTeamMembersCopyLinkClickParams>} LogObject<devCenterManageYourAppTeamMembersCopyLinkClickParams>
 */
export function devCenterManageYourAppTeamMembersCopyLinkClick(params) {
    return { evid: 90, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnCopy' event (evid: 91)
 *
 * Event description: Dashboard - Build Your App - OAuth - Click On Copy
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnCopyParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnCopyParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnCopyParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnCopy(params) {
    return { evid: 91, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnShow' event (evid: 92)
 *
 * Event description: Dashboard - Build Your App - OAuth - Click On Show
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnShowParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {boolean} is_selected - show = true \ hide = false
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnShowParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnShowParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnShow(params) {
    return { evid: 92, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterReadTheAppGuidelines' event (evid: 93)
 *
 * Event description: any click inside the stepper menu
 *
 * @param {devCenterReadTheAppGuidelinesParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} click_type - the name of the button
 * @return {LogObject<devCenterReadTheAppGuidelinesParams>} LogObject<devCenterReadTheAppGuidelinesParams>
 */
export function devCenterReadTheAppGuidelines(params) {
    return { evid: 93, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterReadTheAppGuidelinesSaveClick' event (evid: 94)
 *
 * Event description: click on save in Read the App Guidelines
 *
 * @param {devCenterReadTheAppGuidelinesSaveClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterReadTheAppGuidelinesSaveClickParams>} LogObject<devCenterReadTheAppGuidelinesSaveClickParams>
 */
export function devCenterReadTheAppGuidelinesSaveClick(params) {
    return { evid: 94, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterSubmitYourApp' event (evid: 95)
 *
 * Event description: click on Submit your app button to open app submit form
 *
 * @param {devCenterSubmitYourAppParams} params - The parameters for this event
 * @property {string} location - page / tab
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app id
 * @property {string} location_section - specific location in page/tab
 * @property {string} action - submit/publish
 * @return {LogObject<devCenterSubmitYourAppParams>} LogObject<devCenterSubmitYourAppParams>
 */
export function devCenterSubmitYourApp(params) {
    return { evid: 95, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMore' event (evid: 96)
 *
 * Event description: Click On Learn More on Any Page
 *
 * @param {devCenterDashboardClickOnLearnMoreParams} params - The parameters for this event
 * @property {string} target_url - target url of the kb
 * @property {string} loaction - components, oath, permission etc.
 * @property {string} app_id - app id
 * @property {string} location_section - specific area in the page
 * @property {string} click_name - the name of the click (learn more, etc...)
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @return {LogObject<devCenterDashboardClickOnLearnMoreParams>} LogObject<devCenterDashboardClickOnLearnMoreParams>
 */
export function devCenterDashboardClickOnLearnMore(params) {
    return { evid: 96, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'developerCenterAirflowJobsMonitoring' event (evid: 9600)
 *
 * Event description: This event helps the dev center to make sure there are no issues with Airflow sent jobs. when Airflow is not sending new data , this event should trigger an alert in Grafana or any other alerting method.
 *
 * @param {developerCenterAirflowJobsMonitoringParams} params - The parameters for this event
 * @property {number} metric_value - Airflow Job Metric value
 * @property {string} metric_name - Airflow Job Metric name
 * @return {LogObject<developerCenterAirflowJobsMonitoringParams>} LogObject<developerCenterAirflowJobsMonitoringParams>
 */
export function developerCenterAirflowJobsMonitoring(params) {
    return { evid: 9600, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppChooseComponentCategory' event (evid: 9601)
 *
 * Event description: In the Build Your App  - Components page - after the user hover on add new component button- will be sent when he clicks on the wanted category. was deprecated on 15/08/23 due to removing the categories and changing add component flow.
 *
 * @param {devCenterDashboardBuildYourAppChooseComponentCategoryParams} params - The parameters for this event
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppChooseComponentCategoryParams>} LogObject<devCenterDashboardBuildYourAppChooseComponentCategoryParams>
 */
export function devCenterDashboardBuildYourAppChooseComponentCategory(params) {
    return { evid: 9601, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppAddComponentEnd' event (evid: 9602)
 *
 * Event description: In the Build Your App  - Components page - after the user choose the component type he wants to add -how did the "add component" process end?
 *
 * @param {devCenterDashboardBuildYourAppAddComponentEndParams} params - The parameters for this event
 * @property {string} step_name - Settings / Add Components
 * @property {number} duration - duration in ms from first typing in the page  till the user ended the process and clicked on "save"
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {boolean} is_json_editor - will get 'true' when the component type uses Json Editor
 * @property {string} origin - Where was the process-end made from? "Save button", "Cancel button", "Navigation"
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} end_type - What kind of end did the user chose from the origin:  "Save changes - succeeded", "Save changes - failure", "Drop changes" (navigated or cancelled and discard changes), "No changes", "Unknown" (for navigation from sidebar)
 * @property {string} component_id - a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @property {string} fields_values - A Json field with the values the user typed in the different component's fields : {"Field 1 Name": "Field 1 Value", "Field 2 Name": "Field 2 Value"}.
 * @property {string} action_type - "edit" for editing existing component, "create" for creating new component
 * @return {LogObject<devCenterDashboardBuildYourAppAddComponentEndParams>} LogObject<devCenterDashboardBuildYourAppAddComponentEndParams>
 */
export function devCenterDashboardBuildYourAppAddComponentEnd(params) {
    return { evid: 9602, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppStartTypeInJasonEditor' event (evid: 9603)
 *
 * Event description: In the Build Your App  - Components page - after the user chose to add "data extension" component - what type of entity he wants to add?
 *
 * @param {devCenterDashboardBuildYourAppStartTypeInJasonEditorParams} params - The parameters for this event
 * @property {string} entity_owner - The vertical/horizontal that exposed this entity
 * @property {string} component_category - Integration
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} entity_name - The entity name (subtitle)
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (Edit mode) a unique identifier
 * @property {string} component_type - Data extension
 * @return {LogObject<devCenterDashboardBuildYourAppStartTypeInJasonEditorParams>} LogObject<devCenterDashboardBuildYourAppStartTypeInJasonEditorParams>
 */
export function devCenterDashboardBuildYourAppStartTypeInJasonEditor(params) {
    return { evid: 9603, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppErrorsInJasonEditor' event (evid: 9604)
 *
 * Event description: In the Build Your App  - Components page - when the user gets an error toast after he tried to save his changes in the Json Editor window (for component types that use Json Editor)
 *
 * @param {devCenterDashboardBuildYourAppErrorsInJasonEditorParams} params - The parameters for this event
 * @property {string} error_origin - server validation / schema validation
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} error_type - the error content in english (as it shown in the toast)
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (Edit mode) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterDashboardBuildYourAppErrorsInJasonEditorParams>} LogObject<devCenterDashboardBuildYourAppErrorsInJasonEditorParams>
 */
export function devCenterDashboardBuildYourAppErrorsInJasonEditor(params) {
    return { evid: 9604, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dcBuildInstallationSettingsClick' event (evid: 9606)
 *
 * Event description: In the Build Your App - Components page - fires when the user clicks on installation settings of the app
 *
 * @param {dcBuildInstallationSettingsClickParams} params - The parameters for this event
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps. relevant since september 23
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status: DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - the component unique identifier
 * @property {string} component_type - page / widget / dashboard / blocks etc.
 * @return {LogObject<dcBuildInstallationSettingsClickParams>} LogObject<dcBuildInstallationSettingsClickParams>
 */
export function dcBuildInstallationSettingsClick(params) {
    return { evid: 9606, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dcBuildInstallationSettingsAction' event (evid: 9607)
 *
 * Event description: In the Build Your App - Components page - fires when the user clicks on any action in the app installation settings page
 *
 * @param {dcBuildInstallationSettingsActionParams} params - The parameters for this event
 * @property {string} step - {installation_method, add_panel_show, desktop_preset, mobile_preset, page_name, page_id, widget_size}
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status: DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - the component unique identifier
 * @property {string} component_type - page / widget / dashboard / blocks etc.
 * @property {string} action - the action taken for each step
 * @return {LogObject<dcBuildInstallationSettingsActionParams>} LogObject<dcBuildInstallationSettingsActionParams>
 */
export function dcBuildInstallationSettingsAction(params) {
    return { evid: 9607, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWebhooksDeleteOrEditWebhook' event (evid: 9610)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on delete webhook / edit callback from the subscriptions table - the action the user chose on the opened modal
 *
 * @param {devCenterWebhooksDeleteOrEditWebhookParams} params - The parameters for this event
 * @property {string} action_name - What action did the user choose to do in the opened modal: Delete webhook / Edit callback
 * @property {string} event_name - [DEPRECATE]
 * event_name
 * @property {boolean} is_wix_app - [DEPRECATE]
 * is_wix_app
 * @property {string} app_status - [DEPRECATE]
 * app_status
 * @property {string} category - [DEPRECATE]
 * category
 * @property {GUID} app_id - app id
 * @property {string} slug - slug
 * @return {LogObject<devCenterWebhooksDeleteOrEditWebhookParams>} LogObject<devCenterWebhooksDeleteOrEditWebhookParams>
 */
export function devCenterWebhooksDeleteOrEditWebhook(params) {
    return { evid: 9610, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterSaveChangesInSpec' event (evid: 9611)
 *
 * Event description: When user save changes in spec that connected to component after editing the spec
 *
 * @param {devCenterSaveChangesInSpecParams} params - The parameters for this event
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterSaveChangesInSpecParams>} LogObject<devCenterSaveChangesInSpecParams>
 */
export function devCenterSaveChangesInSpec(params) {
    return { evid: 9611, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterWhenUserRemoveSpecFromAComponent' event (evid: 9612)
 *
 * Event description: When user remove spec that connected to component when merging/terminating
 *
 * @param {devCenterWhenUserRemoveSpecFromAComponentParams} params - The parameters for this event
 * @property {string} removing_reason - terminate/merge
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterWhenUserRemoveSpecFromAComponentParams>} LogObject<devCenterWhenUserRemoveSpecFromAComponentParams>
 */
export function devCenterWhenUserRemoveSpecFromAComponent(params) {
    return { evid: 9612, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnQuickFormatButton' event (evid: 9615)
 *
 * Event description: In the JSON Editor  - when a user is clicking on the quick format button
 *
 * @param {devCenterJsonEditorClickOnQuickFormatButtonParams} params - The parameters for this event
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - quick format/ documentation
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnQuickFormatButtonParams>} LogObject<devCenterJsonEditorClickOnQuickFormatButtonParams>
 */
export function devCenterJsonEditorClickOnQuickFormatButton(params) {
    return { evid: 9615, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorDocumentationSidepanelIsShown' event (evid: 9616)
 *
 * Event description: In the JSON Editor  - when the documentation side panel is shown/closed (notice the status field). The side panel is shown when a user is entering JSON editor or after a user clicked on documentation button.
 *
 * @param {devCenterJsonEditorDocumentationSidepanelIsShownParams} params - The parameters for this event
 * @property {string} sidepanel_status - shown/closed
 * @property {string} closing_trigger - when the sidepanel is closed reporting the closing trigger: X / documentation button. otherwise null (when the sidebar is shown the value isnull)
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @property {boolean} is_example_tab - true if the component type sidepanel contains example tab, otherwise false.
 * @return {LogObject<devCenterJsonEditorDocumentationSidepanelIsShownParams>} LogObject<devCenterJsonEditorDocumentationSidepanelIsShownParams>
 */
export function devCenterJsonEditorDocumentationSidepanelIsShown(params) {
    return { evid: 9616, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterClickOnDocumentationExternalLink' event (evid: 9617)
 *
 * Event description: When a user is clicking on a link to external documentation in the DevCenter
 *
 * @param {devCenterClickOnDocumentationExternalLinkParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} origin - the origin where the link appears, f.e: json ide documentation side panel
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - the cta of the link
 * @property {GUID} app_id - app id
 * @property {string} component_type - when the documentation is for component type send the component type, otherwise null.
 * @return {LogObject<devCenterClickOnDocumentationExternalLinkParams>} LogObject<devCenterClickOnDocumentationExternalLinkParams>
 */
export function devCenterClickOnDocumentationExternalLink(params) {
    return { evid: 9617, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppSelectUnselectExtensionTypeLabel' event (evid: 9618)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is selecting/Unselecting an extension type label.
 *
 * @param {devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams} params - The parameters for this event
 * @property {string} label_name - all extensions/ backend/ wix editor/ live site/ dashboard
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {boolean} status - true when selecting a label, False when unselecting  a label
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams>} LogObject<devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams>
 */
export function devCenterBuildYourAppSelectUnselectExtensionTypeLabel(params) {
    return { evid: 9618, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppSearchQueryInAddExtensionModal' event (evid: 9619)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is typing in the search. the event will be sent in the end of the results (also when there are no results).
 *
 * @param {devCenterBuildYourAppSearchQueryInAddExtensionModalParams} params - The parameters for this event
 * @property {string} above_results - a list of all the above the fold component types that returned
 * @property {string} query - the user query search (the term he searched for)
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} labels - the selected labels while the user typed in search
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {number} num_results - the number of extension types that returned
 * @property {string} below_results - a list of all the below the fold component types that returned
 * @return {LogObject<devCenterBuildYourAppSearchQueryInAddExtensionModalParams>} LogObject<devCenterBuildYourAppSearchQueryInAddExtensionModalParams>
 */
export function devCenterBuildYourAppSearchQueryInAddExtensionModal(params) {
    return { evid: 9619, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterClickOnCreateSubmitProposalInAddExtensionModal' event (evid: 9620)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is clicking on create/submit proposal in add extension modal
 *
 * @param {devCenterClickOnCreateSubmitProposalInAddExtensionModalParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} labels - the selected labels while the user click on learn more. If there are no labels null
 * @property {string} search_query - when the clicked extension is a search result send the search query. otherwise null
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - create / submit proposal
 * @property {GUID} app_id - app id
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterClickOnCreateSubmitProposalInAddExtensionModalParams>} LogObject<devCenterClickOnCreateSubmitProposalInAddExtensionModalParams>
 */
export function devCenterClickOnCreateSubmitProposalInAddExtensionModal(params) {
    return { evid: 9620, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOauthClickOnContactUs' event (evid: 97)
 *
 * Event description: Click On Contact Us
 *
 * @param {devCenterOauthClickOnContactUsParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterOauthClickOnContactUsParams>} LogObject<devCenterOauthClickOnContactUsParams>
 */
export function devCenterOauthClickOnContactUs(params) {
    return { evid: 97, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOathFilterByCategory' event (evid: 98)
 *
 * Event description: Click On filter by category
 *
 * @param {devCenterOathFilterByCategoryParams} params - The parameters for this event
 * @property {string} category - which category selected
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathFilterByCategoryParams>} LogObject<devCenterOathFilterByCategoryParams>
 */
export function devCenterOathFilterByCategory(params) {
    return { evid: 98, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterOathPermissionScopes' event (evid: 99)
 *
 * Event description: Click On Permission Scopes
 *
 * @param {devCenterOathPermissionScopesParams} params - The parameters for this event
 * @property {string} scope - Permission Scopes name
 * @property {string} category - which category selected, if it is from manually search - send search
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathPermissionScopesParams>} LogObject<devCenterOathPermissionScopesParams>
 */
export function devCenterOathPermissionScopes(params) {
    return { evid: 99, src: 96, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devCenterAppStatusChangedServerless' event (evid: 9905)
 *
 * Event description: Dev Center - App Status Change (draft, approved, rejected,
 *
 * @param {devCenterAppStatusChangedServerlessParams} params - The parameters for this event
 * @property {string} versionNumber - version Number
 * @property {string} appStatus - draft, submitted, in review, approved, declined, published
 * @property {GUID} userId - uuid of account manager in cactus
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterAppStatusChangedServerlessParams>} LogObject<devCenterAppStatusChangedServerlessParams>
 */
export function devCenterAppStatusChangedServerless(params) {
    return { evid: 9905, src: 96, endpoint: '', params };
}
//# sourceMappingURL=index.js.map